
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("5Aqtw", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("esLjV")).default);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $esLjV = parcelRequire("esLjV");

});
parcelRegister("esLjV", function(module, exports) {

$parcel$export(module.exports, "default", () => $0742c9f41a91d77b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $0cdA8 = parcelRequire("0cdA8");

var $1ybV0 = parcelRequire("1ybV0");

var $frZnw = parcelRequire("frZnw");

var $khSOi = parcelRequire("khSOi");

var $eMtcB = parcelRequire("eMtcB");

var $ZrysJ = parcelRequire("ZrysJ");

var $kCywN = parcelRequire("kCywN");

var $6M8Uw = parcelRequire("6M8Uw");

var $jK1pm = parcelRequire("jK1pm");

var $lB25E = parcelRequire("lB25E");
const $0742c9f41a91d77b$var$jcsFeatures = {
    hasChannels: false,
    hasEssentials: false,
    hasPractices: false,
    hasOperations: false,
    hasLabs: false
};
const $0742c9f41a91d77b$var$ItsmFeatures = ()=>{
    const [{ match: match }] = (0, $lB25E.useRouter)();
    const isJCS = (0, $khSOi.useIsJCS)();
    const featureVisibilityProps = isJCS ? $0742c9f41a91d77b$var$jcsFeatures : {};
    return (0, $1ybV0.ff)('add-error-boundary-to-issue-type-package-components_2ds9q') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "itsm-features"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kCywN.ProjectSettingsController), {
        projectKey: match.params.projectKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: (0, $frZnw.APP_NAMES).ITSM_FEATURES_SETTINGS,
        packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).ITSM_FEATURES_SETTINGS),
        teamName: "jsd-shield",
        fallback: "flag",
        attributes: {
            projectType: isJCS ? (0, $7ZZxN.CUSTOMER_SERVICE_PROJECT) : (0, $7ZZxN.SERVICE_DESK_PROJECT)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6M8Uw.MarkProductStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eMtcB.FeatureVisibilityProvider), featureVisibilityProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ZrysJ.default), null))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "itsm-features"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kCywN.ProjectSettingsController), {
        projectKey: match.params.projectKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6M8Uw.MarkProductStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eMtcB.FeatureVisibilityProvider), featureVisibilityProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ZrysJ.default), null))));
};
var $0742c9f41a91d77b$export$2e2bcd8739ae039 = $0742c9f41a91d77b$var$ItsmFeatures;

});
parcelRegister("eMtcB", function(module, exports) {

$parcel$export(module.exports, "useFeatureVisibility", () => $328a08cc6697f657$export$1b08954f245aaed1);
$parcel$export(module.exports, "FeatureVisibilityProvider", () => $328a08cc6697f657$export$135eb168dffdafff);

var $eUqFw = parcelRequire("eUqFw");

var $eI5EY = parcelRequire("eI5EY");
const $328a08cc6697f657$export$3cdeb0d8b91ea6ee = {
    hasViews: true,
    hasChannels: true,
    hasEssentials: true,
    hasPractices: true,
    hasCustomerService: true,
    hasOperations: true,
    hasLabs: true
};
const $328a08cc6697f657$var$FeatureVisibilityContext = /*#__PURE__*/ (0, $eUqFw.createContext)($328a08cc6697f657$export$3cdeb0d8b91ea6ee);
const $328a08cc6697f657$export$6fea6df00057ef61 = ()=>(0, $eUqFw.useContext)($328a08cc6697f657$var$FeatureVisibilityContext);
const $328a08cc6697f657$export$1b08954f245aaed1 = ()=>{
    if (!(0, $eI5EY.fg)('jcs_master_flag')) return $328a08cc6697f657$export$3cdeb0d8b91ea6ee;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return $328a08cc6697f657$export$6fea6df00057ef61();
};
const $328a08cc6697f657$export$135eb168dffdafff = ({ children: children, ...props })=>{
    if (!(0, $eI5EY.fg)('jcs_master_flag')) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($328a08cc6697f657$var$FeatureVisibilityContext.Provider, {
        value: {
            ...$328a08cc6697f657$export$3cdeb0d8b91ea6ee,
            ...props
        }
    }, children);
};

});

parcelRegister("ZrysJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $678e70877b8ba629$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $eI5EY = parcelRequire("eI5EY");

var $8WuJm = parcelRequire("8WuJm");

var $bNe1g = parcelRequire("bNe1g");

var $iVSJI = parcelRequire("iVSJI");

var $2d7Sj = parcelRequire("2d7Sj");

var $iJHZm = parcelRequire("iJHZm");

var $lB25E = parcelRequire("lB25E");

var $lU4Wl = parcelRequire("lU4Wl");
const $678e70877b8ba629$var$ItsmFeatures = ()=>{
    const [projectKey = ''] = (0, $lB25E.usePathParam)('projectKey');
    const { data: projectContext } = (0, $bNe1g.useProjectContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        containerType: "project",
        containerId: projectKey,
        sourceName: "jsdItsmFeaturesSettings",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
    }, projectContext && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2d7Sj.ServiceDeskDocumentTitle), {
        projectName: projectContext.projectName,
        section: "itsmFeatures"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iVSJI.ServiceDeskAnalyticsContext), {
        forceRenderWhileLoading: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lU4Wl.default), null), (0, $eI5EY.fg)('jsm_simplified_project_settings_navigation') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJHZm.SpaStatePageReady), null)));
};
var $678e70877b8ba629$export$2e2bcd8739ae039 = $678e70877b8ba629$var$ItsmFeatures;

});
// SCREENS
const $41ea3621645e2acc$export$f636b5b56f1d624a = 'Screen';
const $41ea3621645e2acc$export$9d2de6eebf7462b5 = 'Drawer';
const $41ea3621645e2acc$export$1171103ea9083ffa = 'Modal';
const $41ea3621645e2acc$export$cae2783c9279926 = 'InlineDialog';
const $41ea3621645e2acc$export$d1123261ca8831d2 = 'Dropdown';
const $41ea3621645e2acc$export$238d30785c4bca84 = 'Banner';
const $41ea3621645e2acc$export$a1562d08625f5d7e = 'UI';
const $41ea3621645e2acc$export$947dac6c72b26f81 = 'TRACK';
const $41ea3621645e2acc$export$f1d537d508d2945a = 'SCREEN';
const $41ea3621645e2acc$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("2d7Sj", function(module, exports) {

$parcel$export(module.exports, "PageTitle", () => $0653f34646647329$export$155581e8dc02007a);
$parcel$export(module.exports, "ServiceDeskDocumentTitle", () => $0653f34646647329$export$c7841d2c1c13065e);

var $eUqFw = parcelRequire("eUqFw");

var $knPb9 = parcelRequire("knPb9");

var $heNSb = parcelRequire("heNSb");

var $giAhk = parcelRequire("giAhk");

var $f9Osc = parcelRequire("f9Osc");
const $0653f34646647329$export$155581e8dc02007a = (props)=>{
    const { DocumentTitle: DocumentTitle, section: section, intl: { formatMessage: formatMessage }, projectName: projectName, subsection: subsection } = props;
    const title = subsection ? // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ proformaForms: MessageDescriptorV2; chat: MessageDescriptorV2; incidentManagementSettings: MessageDescriptorV2; ... 32 more ...; serviceProject: MessageDescriptorV2; }'.
    `${projectName} - ${formatMessage((0, $f9Osc.default)[section])} - ${subsection} - ${formatMessage((0, $f9Osc.default).serviceProject)}` : // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ proformaForms: MessageDescriptorV2; chat: MessageDescriptorV2; incidentManagementSettings: MessageDescriptorV2; ... 32 more ...; serviceProject: MessageDescriptorV2; }'.
    `${projectName} - ${formatMessage((0, $f9Osc.default)[section])} - ${formatMessage((0, $f9Osc.default).serviceProject)}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DocumentTitle, {
        title: title
    });
};
const $0653f34646647329$var$InjectedPage = (0, $knPb9.default)($0653f34646647329$export$155581e8dc02007a, {
    DocumentTitle: (0, $heNSb.DocumentTitle)
});
const $0653f34646647329$export$c7841d2c1c13065e = (0, $giAhk.injectIntlV2)($0653f34646647329$var$InjectedPage);
var $0653f34646647329$export$2e2bcd8739ae039 = $0653f34646647329$export$c7841d2c1c13065e;

});
parcelRegister("heNSb", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $44af95caa6ad02db$export$dd5ad0b65cf665da);

var $eUqFw = parcelRequire("eUqFw");

var $1TtYL = parcelRequire("1TtYL");

class $44af95caa6ad02db$export$dd5ad0b65cf665da extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $1TtYL.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1TtYL.DocumentTitleHelper), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}

});

parcelRegister("f9Osc", function(module, exports) {

$parcel$export(module.exports, "default", () => $7be746c19c254767$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7be746c19c254767$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    atlassianAnalytics: {
        "id": "servicedesk-spa-commons.common.utils.document-title.atlassian-analytics",
        "defaultMessage": "Atlassian Analytics"
    },
    serviceProject: {
        "id": "servicedesk-spa-commons.common.utils.document-title.service-project",
        "defaultMessage": "Service project"
    },
    knowledge: {
        "id": "servicedesk-spa-commons.common.utils.document-title.knowledge",
        "defaultMessage": "Knowledge base"
    },
    itsmFeatures: {
        "id": "servicedesk-spa-commons.common.utils.document-title.itsm-features",
        "defaultMessage": "Features"
    },
    queues: {
        "id": "servicedesk-spa-commons.common.utils.document-title.queues",
        "defaultMessage": "Queues"
    },
    customers: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customers",
        "defaultMessage": "Customers"
    },
    organizations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.organizations",
        "defaultMessage": "Organizations"
    },
    customerServiceEscalations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-service-escalations",
        "defaultMessage": "Developer escalations"
    },
    reports: {
        "id": "servicedesk-spa-commons.common.utils.document-title.reports",
        "defaultMessage": "Reports"
    },
    services: {
        "id": "servicedesk-spa-commons.common.utils.document-title.services",
        "defaultMessage": "Services"
    },
    oncall: {
        "id": "servicedesk-spa-commons.common.utils.document-title.oncall",
        "defaultMessage": "On-call"
    },
    email: {
        "id": "servicedesk-spa-commons.common.utils.document-title.email",
        "defaultMessage": "Email request"
    },
    sla: {
        "id": "servicedesk-spa-commons.common.utils.document-title.sla",
        "defaultMessage": "Service level agreements"
    },
    csat: {
        "id": "servicedesk-spa-commons.common.utils.document-title.csat",
        "defaultMessage": "Customer satisfaction"
    },
    details: {
        "id": "servicedesk-spa-commons.common.utils.document-title.details",
        "defaultMessage": "Details"
    },
    portal: {
        "id": "servicedesk-spa-commons.common.utils.document-title.portal",
        "defaultMessage": "Customer portal"
    },
    externalLinks: {
        "id": "servicedesk-spa-commons.common.utils.document-title.external-links",
        "defaultMessage": "Links"
    },
    portalSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.portal-settings",
        "defaultMessage": "Portal settings"
    },
    automation: {
        "id": "servicedesk-spa-commons.common.utils.document-title.automation",
        "defaultMessage": "Automation"
    },
    advanced: {
        "id": "servicedesk-spa-commons.common.utils.document-title.advanced",
        "defaultMessage": "Advanced"
    },
    languageSupport: {
        "id": "servicedesk-spa-commons.common.utils.document-title.language-support",
        "defaultMessage": "Language support"
    },
    languageTranslations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.language-translations",
        "defaultMessage": "Language translations"
    },
    notificationEmail: {
        "id": "servicedesk-spa-commons.common.utils.document-title.notification-email",
        "defaultMessage": "Notification email"
    },
    notifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.notifications",
        "defaultMessage": "Notifications"
    },
    internalNotifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.internal-notifications",
        "defaultMessage": "Internal notifications"
    },
    customerNotifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-notifications",
        "defaultMessage": "Customer notifications"
    },
    widget: {
        "id": "servicedesk-spa-commons.common.utils.document-title.widget",
        "defaultMessage": "Widget"
    },
    customerPermissions: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-permissions",
        "defaultMessage": "Customer permissions"
    },
    people: {
        "id": "servicedesk-spa-commons.common.utils.document-title.people",
        "defaultMessage": "Internal access"
    },
    issueType: {
        "id": "servicedesk-spa-commons.common.utils.document-title.issue-type",
        "defaultMessage": "Request types"
    },
    connectAppControls: {
        "id": "servicedesk-spa-commons.common.utils.document-title.connect-app-controls",
        "defaultMessage": "Apps"
    },
    features: {
        "id": "servicedesk-spa-commons.common.utils.document-title.features",
        "defaultMessage": "Features"
    },
    calendar: {
        "id": "servicedesk-spa-commons.common.utils.document-title.calendar",
        "defaultMessage": "Calendar"
    },
    changeCalendar: {
        "id": "servicedesk-spa-commons.common.utils.document-title.change-calendar",
        "defaultMessage": "Change calendar"
    },
    changeManagementSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.change-management-settings",
        "defaultMessage": "Change management"
    },
    incidentManagementSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.incident-management-settings",
        "defaultMessage": "Incident management"
    },
    virtualAgentConversations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-conversations",
        "defaultMessage": "Conversations"
    },
    virtualAgentIntents: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-intents",
        "defaultMessage": "Intents"
    },
    virtualAgentStandardFlows: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-standard-flows",
        "defaultMessage": "Standard flows"
    },
    virtualAgentSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-settings",
        "defaultMessage": "Settings"
    },
    virtualAgentLanding: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-landing",
        "defaultMessage": "Virtual agent"
    },
    chat: {
        "id": "servicedesk-spa-commons.common.utils.document-title.chat",
        "defaultMessage": "Chat"
    },
    proformaForms: {
        "id": "servicedesk-spa-commons.common.utils.document-title.proforma-forms",
        "defaultMessage": "Forms"
    },
    playbooks: {
        "id": "servicedesk-spa-commons.common.utils.document-title.playbooks-non-final",
        "defaultMessage": "Playbooks"
    },
    dataClassifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.data-classifications",
        "defaultMessage": "Data classification"
    },
    // EAX-256 - Finalise this string
    fieldsNonFinal: {
        "id": "servicedesk-spa-commons.common.utils.document-title.fields-non-final",
        "defaultMessage": "Fields"
    },
    workflowScheme: {
        "id": "servicedesk-spa-commons.common.utils.document-title.workflow-scheme",
        "defaultMessage": "Workflows"
    },
    journeysNonFinal: {
        "id": "servicedesk-spa-commons.common.utils.document-title.journeys-non-final",
        "defaultMessage": "Journeys"
    },
    journeyConfigNonFinal: {
        "id": "servicedesk-spa-commons.common.utils.document-title.journey-config-non-final",
        "defaultMessage": "Journey configuration"
    }
});

});


parcelRegister("lU4Wl", function(module, exports) {

$parcel$export(module.exports, "default", () => $60a424c589101e80$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $6FP8W = parcelRequire("6FP8W");

var $d6f6c = parcelRequire("d6f6c");

var $7vf5z = parcelRequire("7vf5z");

var $5Glt5 = parcelRequire("5Glt5");

var $kDb0Y = parcelRequire("kDb0Y");

var $eMtcB = parcelRequire("eMtcB");

var $3KRtq = parcelRequire("3KRtq");

var $5v6cG = parcelRequire("5v6cG");

var $avTtY = parcelRequire("avTtY");

var $kO1Zr = parcelRequire("kO1Zr");

var $qHoPu = parcelRequire("qHoPu");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $60a424c589101e80$var$App = /*#__PURE__*/ (0, $eUqFw.memo)(()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    (0, $kDb0Y.default)();
    const { hasLabs: hasLabs } = (0, $eMtcB.useFeatureVisibility)();
    const PageWrapper = (0, $6FP8W.getWillShowNav4)() ? $60a424c589101e80$var$PageWrapperNew : $60a424c589101e80$var$PageWrapperOld;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(PageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3KRtq.default), {
        title: formatMessage((0, $5v6cG.default).pageHeader)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, formatMessage((0, $5v6cG.default).pageDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $qHoPu.CmdbUpsellWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5Glt5.FeaturesUpsellBanner), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kO1Zr.default), null), (!(0, $eI5EY.fg)('jcs_master_flag') || hasLabs) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $avTtY.default), null)), // eslint-disable-next-line jira/ff/no-preconditioning
    (0, $eI5EY.fg)('jsm_boards_promo_gate') && window.location.href?.includes('?queues-board-promotion=true') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), {
        attributes: {
            isPracticeModularity: true,
            queuesBoardPromotion: true
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), {
        attributes: {
            isPracticeModularity: true
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7vf5z.default), null));
});
var $60a424c589101e80$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $60a424c589101e80$var$App;
const $60a424c589101e80$var$PageWrapperNew = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _1yt41e2i _1bsb1c3h",
            __cmplp.className
        ])
    });
});
const $60a424c589101e80$var$PageWrapperOld = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _1yt41e2i _1bsb1c3h _1reo1wug _18m91wug",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7vf5z", function(module, exports) {

$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $074ba9858fda469d$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $074ba9858fda469d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $074ba9858fda469d$export$9b3029ee6188a41f);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $3iMaY = parcelRequire("3iMaY");

var $eJ3kO = parcelRequire("eJ3kO");

var $51JrV = parcelRequire("51JrV");

var $4nnPJ = parcelRequire("4nnPJ");

var $22iQy = parcelRequire("22iQy");

var $brm1D = parcelRequire("brm1D");

var $ifyPR = parcelRequire("ifyPR");

var $aS0xb = parcelRequire("aS0xb");

var $45wsB = parcelRequire("45wsB");
const $074ba9858fda469d$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $074ba9858fda469d$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame, waitForLongTaskIdleTTI: waitForLongTaskIdleTTI } = this.props;
        $074ba9858fda469d$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $1ybV0.ff)('uip.ufo') && (0, $4nnPJ.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $aS0xb.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $ifyPR.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $45wsB.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3iMaY.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eJ3kO.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $brm1D.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $51JrV.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $22iQy.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame,
            waitForLongTaskIdleTTI: waitForLongTaskIdleTTI
        }));
    }
}
const $074ba9858fda469d$export$9b3029ee6188a41f = $074ba9858fda469d$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("eJ3kO", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $8841aa10a213faf4$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $8841aa10a213faf4$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $8841aa10a213faf4$export$d93d677ef2f33c5c);

var $eUqFw = parcelRequire("eUqFw");

var $3Hphq = parcelRequire("3Hphq");

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");
function $8841aa10a213faf4$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $8841aa10a213faf4$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $eUqFw.useContext)((0, $3Hphq.default));
    const interactionId = (0, $51JrV.getInteractionId)().current;
    (0, $eUqFw.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $fYqUr.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $8841aa10a213faf4$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $8841aa10a213faf4$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $51JrV.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $fYqUr.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $8841aa10a213faf4$export$f02972da195a43bb(marks, timingsConfig);
        (0, $fYqUr.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("22iQy", function(module, exports) {

$parcel$export(module.exports, "StopBrowserMetrics3", () => $c48b51f586335ad5$export$575e93c0f9905999);

var $eUqFw = parcelRequire("eUqFw");

var $acbV3 = parcelRequire("acbV3");

var $6iz4v = parcelRequire("6iz4v");

var $6xYPC = parcelRequire("6xYPC");

var $1ybV0 = parcelRequire("1ybV0");

var $cNlZD = parcelRequire("cNlZD");

var $6M8Uw = parcelRequire("6M8Uw");

var $2B87Z = parcelRequire("2B87Z");

var $87isp = parcelRequire("87isp");

var $3Hphq = parcelRequire("3Hphq");

const $c48b51f586335ad5$var$emitMetrics = (metric, customData, stopTime)=>{
    !(0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) {
        if (!(0, $1ybV0.ff)('bm3.wait-for-long-task')) {
            metric.mark((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
            (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
            (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $37f655a4e4d5690e$export$99c08ec92759c71c));
        }
        metric.stop({
            customData: customData,
            stopTime: stopTime
        });
    } else metric.stop({
        customData: customData
    });
    if ((0, $87isp.isAutomaticExposureCollectionEnabled)()) (0, $6xYPC.stopLowPriorityEventDelay)();
};
class $c48b51f586335ad5$export$575e93c0f9905999 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $1ybV0.ff)('bm3.wait-for-long-task') ? (0, $acbV3.browserMetrics).getPageLoadMetric().getData()?.start || 0 : 0;
        (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_END');
        (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (this.props.waitForLongTaskIdleTTI) {
            const stopTime = performance.now();
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            (0, $cNlZD.getTTIValue)().then((tti)=>{
                (0, $cNlZD.resetTTIObserver)();
                (0, $6iz4v.setMark)('BROWSER_METRICS_LONG_TASK_TTI_END', {
                    startTime: tti
                });
                (0, $6iz4v.setMeasure)('BROWSER_METRICS_LONG_TASK_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_LONG_TASK_TTI_END');
                $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
            });
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
        } else if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                if ((0, $1ybV0.ff)('bm3.wait-for-long-task')) {
                    metric.mark((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                    (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                    (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                }
                if ((0, $1ybV0.ff)('bm3.wait-for-long-task')) setTimeout(()=>{
                    $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
                }, 500);
                else $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            $c48b51f586335ad5$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $3Hphq.default);
    }
    render() {
        return null;
    }
}

});
parcelRegister("cNlZD", function(module, exports) {

$parcel$export(module.exports, "resetTTIObserver", () => $2134fd1f8b4ec9b6$export$1250c0c41b64ee5c);
$parcel$export(module.exports, "startTTIObserver", () => $2134fd1f8b4ec9b6$export$d2209a9a3184ff99);
$parcel$export(module.exports, "getTTIValue", () => $2134fd1f8b4ec9b6$export$e67176cf000b0a2e);

var $ba8ih = parcelRequire("ba8ih");
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
let $2134fd1f8b4ec9b6$var$resolveTti = (_v)=>{};
let $2134fd1f8b4ec9b6$var$observerStarted = false;
/**
 * Initialize module state and return the promise a consumer can use to wait
 * for the TTI event.
 */ function $2134fd1f8b4ec9b6$var$initTtiPromise() {
    return new Promise((resolve)=>{
        let hasResolved = false;
        const callback = (ttiResult)=>{
            if (hasResolved) return;
            hasResolved = true;
            resolve(ttiResult);
        };
        $2134fd1f8b4ec9b6$var$resolveTti = callback;
    });
}
let $2134fd1f8b4ec9b6$var$ttiPromise = $2134fd1f8b4ec9b6$var$initTtiPromise();
function $2134fd1f8b4ec9b6$export$1250c0c41b64ee5c() {
    $2134fd1f8b4ec9b6$var$ttiPromise = $2134fd1f8b4ec9b6$var$initTtiPromise();
    $2134fd1f8b4ec9b6$var$observerStarted = false;
}
function $2134fd1f8b4ec9b6$export$d2209a9a3184ff99() {
    $2134fd1f8b4ec9b6$var$observerStarted = true;
    let cleanupObserver = null;
    let lastSeenEventTime = performance.now();
    const callback = ()=>{
        cleanupObserver?.();
        $2134fd1f8b4ec9b6$var$resolveTti(lastSeenEventTime);
    };
    let timeoutId = setTimeout(callback, 5000);
    cleanupObserver = (0, $ba8ih.startLongTaskObserver)(()=>{
        lastSeenEventTime = performance.now();
        clearTimeout(timeoutId);
        timeoutId = setTimeout(callback, 5000);
    });
}
function $2134fd1f8b4ec9b6$export$e67176cf000b0a2e() {
    const promise = $2134fd1f8b4ec9b6$var$ttiPromise ?? $2134fd1f8b4ec9b6$var$initTtiPromise();
    if (!$2134fd1f8b4ec9b6$var$observerStarted) $2134fd1f8b4ec9b6$export$d2209a9a3184ff99();
    return promise;
}

});
parcelRegister("ba8ih", function(module, exports) {

$parcel$export(module.exports, "startLongTaskObserver", () => $c3f66a1c0c2d8c9c$export$af412d3da3bf848a);
/**
 * Starts a long-task observer that will call `cb` on each observation.
 * Returns a disposal function
 */ function $c3f66a1c0c2d8c9c$export$af412d3da3bf848a(cb) {
    const observer = new PerformanceObserver(()=>{
        cb();
    });
    observer.observe({
        type: 'longtask'
    });
    return ()=>{
        observer.disconnect();
    };
}

});


parcelRegister("6M8Uw", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $e57b25b6033962a3$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $e57b25b6033962a3$export$2a999c5f84501025);

var $6iz4v = parcelRequire("6iz4v");
const $e57b25b6033962a3$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $e57b25b6033962a3$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($e57b25b6033962a3$export$8e54fca0a680fdfd);
        (0, $6iz4v.setMark)($e57b25b6033962a3$export$8e54fca0a680fdfd);
    }
    return null;
};

});

const $37f655a4e4d5690e$export$56940a9488e85199 = 'jira.fe.spa-';
const $37f655a4e4d5690e$export$45c4b6bf7935c69a = `${$37f655a4e4d5690e$export$56940a9488e85199}start`;
const $37f655a4e4d5690e$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $37f655a4e4d5690e$export$ff834eccc35b9089 = 'appBundleReady';
const $37f655a4e4d5690e$export$86b05e34d462ead8 = 'prefetchApiReady';
const $37f655a4e4d5690e$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $37f655a4e4d5690e$export$1211adfff27a31fe = 'issueViewInitialDataReady';
const $37f655a4e4d5690e$export$3ae43cc1782d058f = 'jswRenderStart';
const $37f655a4e4d5690e$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $37f655a4e4d5690e$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $37f655a4e4d5690e$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $37f655a4e4d5690e$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $37f655a4e4d5690e$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $37f655a4e4d5690e$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $37f655a4e4d5690e$export$99c08ec92759c71c = 'tti-raf-mark';
const $37f655a4e4d5690e$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("brm1D", function(module, exports) {

$parcel$export(module.exports, "StopUfo", () => $aa08c3eb931d9705$export$d91154f099475c5);

var $eUqFw = parcelRequire("eUqFw");

var $3Hphq = parcelRequire("3Hphq");

var $4nnPJ = parcelRequire("4nnPJ");
class $aa08c3eb931d9705$export$d91154f099475c5 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $4nnPJ.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $4nnPJ.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $3Hphq.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("ifyPR", function(module, exports) {

$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $d6714c8d166fb68b$export$bf239ac2bfb04967);

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");
function $d6714c8d166fb68b$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $51JrV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $fYqUr.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("aS0xb", function(module, exports) {

$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $714e33db0dc77e43$export$e63862cd888fe05a);

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");

var $4nnPJ = parcelRequire("4nnPJ");
var $aPkDp = parcelRequire("aPkDp");
async function $714e33db0dc77e43$export$e63862cd888fe05a() {
    const interactionId = (0, $51JrV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $4nnPJ.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $aPkDp.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $fYqUr.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("45wsB", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $58cb476ec3ec20ed$export$f00f1e874ce869e9);

var $aWbzA = parcelRequire("aWbzA");

var $51JrV = parcelRequire("51JrV");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $58cb476ec3ec20ed$export$7b4abba432e57989 = (value)=>$58cb476ec3ec20ed$var$isString(value) && $58cb476ec3ec20ed$var$startsAsObject(value) || $58cb476ec3ec20ed$var$isObject(value);
const $58cb476ec3ec20ed$export$fcc03ee4c944962f = (featureFlagValue)=>$58cb476ec3ec20ed$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $58cb476ec3ec20ed$export$d2818866b4acbea4 = new Map();
const $58cb476ec3ec20ed$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $51JrV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $aWbzA.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $58cb476ec3ec20ed$export$fcc03ee4c944962f(value);
            $58cb476ec3ec20ed$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});


parcelRegister("5Glt5", function(module, exports) {

$parcel$export(module.exports, "ServicesUpsellBanner", () => $9e4cc0af4a3cfddb$export$408cd4e598d3fbe1);
$parcel$export(module.exports, "FeaturesUpsellBanner", () => $9e4cc0af4a3cfddb$export$a1cb3c73153effba);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $fXCyX = parcelRequire("fXCyX");

var $kWOx5 = parcelRequire("kWOx5");

var $6CGJY = parcelRequire("6CGJY");
const $9e4cc0af4a3cfddb$var$LearnMoreButton = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "link",
        spacing: "none",
        href: "https://www.atlassian.com/software/jira/service-management/features/asset-and-configuration-management",
        target: "_blank",
        onClick: (_, analyticsEvent)=>{
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'cmdbUpsellLearnMore');
        }
    }, formatMessage((0, $6CGJY.messages).learnMore));
};
const $9e4cc0af4a3cfddb$export$408cd4e598d3fbe1 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kWOx5.CmdbUpsellCommonBase), {
        variation: "services"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fXCyX.UpsellBanner), {
        title: formatMessage((0, $6CGJY.messages).servicesTitle),
        primaryAction: formatMessage((0, $6CGJY.messages).tryItNow),
        secondaryAction: formatMessage((0, $6CGJY.messages).maybeLater),
        bannerArea: "services"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $6CGJY.messages).servicesDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9e4cc0af4a3cfddb$var$ContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9e4cc0af4a3cfddb$var$LearnMoreButton, null))));
};
const $9e4cc0af4a3cfddb$export$a1cb3c73153effba = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kWOx5.CmdbUpsellCommonBase), {
        variation: "features"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fXCyX.UpsellBanner), {
        title: formatMessage((0, $6CGJY.messages).featuresTitle),
        primaryAction: formatMessage((0, $6CGJY.messages).tryItNow),
        secondaryAction: formatMessage((0, $6CGJY.messages).maybeLater),
        bannerArea: "features"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $6CGJY.messages).featuresDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9e4cc0af4a3cfddb$var$ContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9e4cc0af4a3cfddb$var$LearnMoreButton, null))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9e4cc0af4a3cfddb$var$ContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_y3gn1e5h",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fXCyX", function(module, exports) {

$parcel$export(module.exports, "UpsellBanner", () => $f80fb71448ae46c3$export$3a4cc40494f3933e);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4q38b = parcelRequire("4q38b");

var $67MTZ = parcelRequire("67MTZ");

var $jMP2a = parcelRequire("jMP2a");

var $gd0Sp = parcelRequire("gd0Sp");

var $aUBpV = parcelRequire("aUBpV");

var $2zwXn = parcelRequire("2zwXn");
const $f80fb71448ae46c3$export$3a4cc40494f3933e = (props)=>{
    const { title: title, primaryAction: primaryAction, secondaryAction: secondaryAction, bannerArea: bannerArea = 'services', children: children } = props;
    const { cloudId: cloudId, isSiteAdmin: isSiteAdmin } = (0, $gd0Sp.useTenantContext)();
    const { dismissBanner: dismissBanner } = (0, $aUBpV.useCmdbUpsellBannerStoreActions)();
    const tryNowURL = `${(0, $67MTZ.getAdminBaseUrl)()}/s/${cloudId}/billing/applications/change-edition/jira-servicedesk.ondemand?utm_campaign=P%3Ajira%7CO%3Ajsm%7CI%3Acmdb-upsell-banner-${bannerArea}&utm_source=product&utm_medium=product&utm_content=version_1`;
    const { colorMode: colorMode } = (0, $4q38b.default)();
    const isDarkMode = colorMode === 'dark';
    const actions = (0, $eUqFw.useMemo)(()=>{
        const actionsCandidates = [];
        // Only site admins should be shown the link to a free trial
        if (isSiteAdmin) actionsCandidates.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2zwXn.SectionMessageAction), {
            key: "1",
            isPrimaryAction: true,
            href: tryNowURL,
            target: "_blank",
            onClick: (_, analyticsEvent)=>{
                (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'cmdbUpsellTryNow');
            }
        }, primaryAction));
        actionsCandidates.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2zwXn.SectionMessageAction), {
            key: "2",
            isPrimaryAction: false,
            onClick: (_, analyticsEvent)=>{
                (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'cmdbUpsellMaybeLater');
                dismissBanner();
            }
        }, secondaryAction));
        return actionsCandidates;
    }, [
        isSiteAdmin,
        secondaryAction,
        tryNowURL,
        primaryAction,
        dismissBanner
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f80fb71448ae46c3$var$BannerWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2zwXn.default), {
        isDarkMode: isDarkMode,
        title: title,
        actions: actions
    }, children));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f80fb71448ae46c3$var$BannerWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_p12f1c3h _1ul9dgin",
            __cmplp.className
        ])
    });
});

});
parcelRegister("67MTZ", function(module, exports) {

$parcel$export(module.exports, "getAdminBaseUrl", () => $fac65a5b25902587$export$76bb37a926058cca);

var $bW292 = parcelRequire("bW292");
const $fac65a5b25902587$export$76bb37a926058cca = ()=>`https://${(0, $bW292.getATLContextDomain)('admin')}`;

});

parcelRegister("aUBpV", function(module, exports) {

$parcel$export(module.exports, "CmdbUpsellStoreContainer", () => $346676c4a2121ffe$export$10d39ca8d443a874);
$parcel$export(module.exports, "useCmdbUpsellBannerStoreActions", () => $346676c4a2121ffe$export$6082548bf908c09d);
$parcel$export(module.exports, "CmdbUpsellStoreSubscriber", () => $346676c4a2121ffe$export$6f133766965cfb02);

var $WBLbN = parcelRequire("WBLbN");

var $65xZd = parcelRequire("65xZd");
var $d4mqk = parcelRequire("d4mqk");
const $346676c4a2121ffe$export$10d39ca8d443a874 = (0, $WBLbN.createContainer)();
const $346676c4a2121ffe$var$initialState = {
    userHasDismissed: undefined
};
const $346676c4a2121ffe$var$store = (0, $WBLbN.createStore)({
    initialState: $346676c4a2121ffe$var$initialState,
    actions: $65xZd,
    containedBy: $346676c4a2121ffe$export$10d39ca8d443a874,
    handlers: {
        onInit: $d4mqk.fetchInitialState
    }
});
const $346676c4a2121ffe$export$45244e717816292c = (0, $WBLbN.createHook)($346676c4a2121ffe$var$store);
const $346676c4a2121ffe$export$6082548bf908c09d = (0, $WBLbN.createActionsHook)($346676c4a2121ffe$var$store);
const $346676c4a2121ffe$export$6f133766965cfb02 = (0, $WBLbN.createSubscriber)($346676c4a2121ffe$var$store);

});
parcelRegister("65xZd", function(module, exports) {

$parcel$export(module.exports, "fetchInitialState", () => (parcelRequire("d4mqk")).fetchInitialState);
$parcel$export(module.exports, "dismissBanner", () => (parcelRequire("lwI2V")).dismissBanner);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $d4mqk = parcelRequire("d4mqk");

var $lwI2V = parcelRequire("lwI2V");

});
parcelRegister("d4mqk", function(module, exports) {

$parcel$export(module.exports, "fetchInitialState", () => $2d4615dee0f68063$export$84ded0ac7058ab7a);

var $48bs8 = parcelRequire("48bs8");

var $7byHA = parcelRequire("7byHA");

var $eZfBZ = parcelRequire("eZfBZ");

const $2d4615dee0f68063$export$84ded0ac7058ab7a = ()=>async ({ setState: setState }, { atlassianAccountId: atlassianAccountId })=>{
        try {
            await (0, $48bs8.getUserProperty)(atlassianAccountId, (0, $bf331b3210afa3da$export$4624ff00cd96e554));
            setState({
                userHasDismissed: true
            });
        } catch (error) {
            if (error instanceof (0, $7byHA.default) && error.statusCode === 404) setState({
                userHasDismissed: false
            });
            else (0, $eZfBZ.fireJsonOnlyErrorAnalytics)({
                error: error instanceof Error ? error : undefined,
                meta: {
                    id: 'fetchUpsellDismissedProperty',
                    packageName: 'jiraServiceManagementCmdbUpsellBanner'
                }
            });
        }
    };

});
parcelRegister("eZfBZ", function(module, exports) {

$parcel$export(module.exports, "ANALYTIC_CONTEXTS", () => $6d93f232242cadb5$export$ca021921d5c56515);
$parcel$export(module.exports, "ttiRecommendedSlo", () => $6d93f232242cadb5$export$dc391c7d81907d3a);
$parcel$export(module.exports, "trackJsdFetchErrors", () => $6d93f232242cadb5$export$ebdbd98df5a27905);
$parcel$export(module.exports, "fireJsonOnlyErrorAnalytics", () => $6d93f232242cadb5$export$32233c6edb041cf2);

var $guiFP = parcelRequire("guiFP");

var $fV97Z = parcelRequire("fV97Z");
const $6d93f232242cadb5$export$ca021921d5c56515 = {
    AUTOMATION_SETTINGS: 'AutomationSettings',
    KNOWLEDGE: 'Knowledge',
    QUEUES: 'Queues',
    CSAT: 'Csat'
};
const $6d93f232242cadb5$export$cca3c4e11cb0a5ce = 1000;
const $6d93f232242cadb5$export$dc391c7d81907d3a = 4000;
const $6d93f232242cadb5$export$ebdbd98df5a27905 = async (payload)=>{
    const { error: error, attributes: attributes } = payload;
    if (error instanceof (0, $fV97Z.JsdFetchError)) {
        const { reasonKey: reasonKey } = error;
        (0, $guiFP.trackFetchErrors)({
            ...payload,
            attributes: {
                ...attributes,
                reasonKey: reasonKey
            }
        });
        return;
    }
    (0, $guiFP.trackFetchErrors)(payload);
};
function $6d93f232242cadb5$export$32233c6edb041cf2({ error: error, ...rest }) {
    let useError = false;
    if (error instanceof Error) try {
        JSON.parse(error.message);
        useError = true;
    } catch (e) {
        useError = false;
    }
    (0, $guiFP.default)({
        error: error instanceof Error && useError ? error : undefined,
        ...rest
    });
}

});
parcelRegister("fV97Z", function(module, exports) {

$parcel$export(module.exports, "JsdFetchError", () => $c9869c00ba1fbd5b$export$fee0012ae6cb3438);
$parcel$export(module.exports, "performGetRequest", () => $c9869c00ba1fbd5b$export$4a53ae1be8ec80c7);
$parcel$export(module.exports, "performPutRequest", () => $c9869c00ba1fbd5b$export$9ead1f9103e6de6b);
$parcel$export(module.exports, "performPostRequest", () => $c9869c00ba1fbd5b$export$692a4d9808143175);
$parcel$export(module.exports, "performDeleteRequest", () => $c9869c00ba1fbd5b$export$8ef51cba9d28f819);

var $8blac = parcelRequire("8blac");

var $kkgbD = parcelRequire("kkgbD");

var $fVqUX = parcelRequire("fVqUX");


var $88Osm = parcelRequire("88Osm");

var $7byHA = parcelRequire("7byHA");

var $lRmyA = parcelRequire("lRmyA");
const $c9869c00ba1fbd5b$var$VALIDATION_ERROR_KEY = 'validation.error';
class $c9869c00ba1fbd5b$export$fee0012ae6cb3438 extends (0, $7byHA.default) {
    constructor(statusCode, message, reasonKey, response){
        super(statusCode, (0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(message) ? `Fetch call failed with status code: ${statusCode}` : message);
        this.name = 'JsdFetchError';
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($kkgbD)))(reasonKey)) this.reasonKey = reasonKey;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($kkgbD)))(response)) this.response = response;
    }
}
const $c9869c00ba1fbd5b$var$transformMessageErrorsFromServer = (errors = [])=>errors.reduce((messages, { errorMessage: errorMessage })=>{
        messages.push(errorMessage);
        return messages;
    }, []).join(' ');
const $c9869c00ba1fbd5b$var$putOptions = {
    ...(0, $fVqUX.default),
    method: 'PUT'
};
const $c9869c00ba1fbd5b$var$postOptions = {
    ...(0, $fVqUX.default),
    method: 'POST'
};
const $c9869c00ba1fbd5b$var$deleteOptions = {
    ...(0, $fVqUX.default),
    method: 'DELETE'
};
const $c9869c00ba1fbd5b$var$patchOptions = {
    ...(0, $fVqUX.default),
    method: 'PATCH'
};
const $c9869c00ba1fbd5b$var$processResponse = async (response)=>{
    if ((0, $1c3fbb431a173cc6$export$9de493bcd9b1d977) === response.status) {
        const jsonResponse = await response.json();
        const { errors: errors, reasonKey: reasonKey } = jsonResponse;
        if (reasonKey === $c9869c00ba1fbd5b$var$VALIDATION_ERROR_KEY) throw (0, $lRmyA.transformValidationErrorFromServer)(jsonResponse);
        const message = $c9869c00ba1fbd5b$var$transformMessageErrorsFromServer(errors);
        throw new $c9869c00ba1fbd5b$export$fee0012ae6cb3438(response.status, message, reasonKey, jsonResponse);
    }
    if (!response.ok) {
        const traceId = response.headers.get((0, $88Osm.TRACE_ID_HEADER));
        if (traceId != null && traceId !== '') throw new (0, $7byHA.default)(response.status, `Error server response: ${response.status}`, traceId);
        else throw new (0, $7byHA.default)(response.status, `Error server response: ${response.status}`);
    }
    if (response.status === (0, $1c3fbb431a173cc6$export$3288b14b6745c572)) return Promise.resolve(null);
    return response.text().then((text)=>text ? JSON.parse(text) : null);
};
const $c9869c00ba1fbd5b$export$4a53ae1be8ec80c7 = (url, options = {})=>fetch(url, {
        ...(0, $fVqUX.default),
        ...options
    }).then($c9869c00ba1fbd5b$var$processResponse);
const $c9869c00ba1fbd5b$export$9ead1f9103e6de6b = (url, options = {})=>fetch(url, {
        ...$c9869c00ba1fbd5b$var$putOptions,
        ...options
    }).then($c9869c00ba1fbd5b$var$processResponse);
const $c9869c00ba1fbd5b$export$692a4d9808143175 = (url, options = {})=>fetch(url, {
        ...$c9869c00ba1fbd5b$var$postOptions,
        ...options
    }).then($c9869c00ba1fbd5b$var$processResponse);
const $c9869c00ba1fbd5b$export$8ef51cba9d28f819 = (url, options = {})=>fetch(url, {
        ...$c9869c00ba1fbd5b$var$deleteOptions,
        ...options
    }).then($c9869c00ba1fbd5b$var$processResponse);
const $c9869c00ba1fbd5b$export$52be6ab13d7e758d = (url, options = {})=>fetch(url, {
        ...$c9869c00ba1fbd5b$var$patchOptions,
        ...options
    }).then($c9869c00ba1fbd5b$var$processResponse);

});
const $1c3fbb431a173cc6$export$ff39ebd4bb12b718 = 201;
const $1c3fbb431a173cc6$export$3288b14b6745c572 = 204;
const $1c3fbb431a173cc6$export$9de493bcd9b1d977 = 400;
const $1c3fbb431a173cc6$export$67d19e9a991baa07 = 401;
const $1c3fbb431a173cc6$export$a3269a3914b007e3 = 403;
const $1c3fbb431a173cc6$export$8bca792d963eb0ef = 404;
const $1c3fbb431a173cc6$export$4a3cb39801694eee = 407;
const $1c3fbb431a173cc6$export$fa405bbf47d510e2 = 408;
const $1c3fbb431a173cc6$export$c09e7ea0fc79f34f = 409;
const $1c3fbb431a173cc6$export$5244030134e99 = 412;
const $1c3fbb431a173cc6$export$f90ac1df0b60853d = 413;
const $1c3fbb431a173cc6$export$a447d0a965e16776 = 422;
const $1c3fbb431a173cc6$export$3b48aba8957000cd = 426;
const $1c3fbb431a173cc6$export$6763168a631449a2 = 429;
const $1c3fbb431a173cc6$export$e813cd7045fcc98d = 500;
const $1c3fbb431a173cc6$export$2ce38d41a306034e = 502;
const $1c3fbb431a173cc6$export$974c37534b0191b1 = 503;
const $1c3fbb431a173cc6$export$5400e8dddac3fcf3 = 504;



const $bf331b3210afa3da$export$4624ff00cd96e554 = 'jsm-cmdb-upsell-banner-dismissed';


parcelRegister("lwI2V", function(module, exports) {

$parcel$export(module.exports, "dismissBanner", () => $7b9609f8f0b2f26a$export$775e775a1048dbdb);

var $48bs8 = parcelRequire("48bs8");

var $eZfBZ = parcelRequire("eZfBZ");

const $7b9609f8f0b2f26a$export$775e775a1048dbdb = ()=>async ({ setState: setState }, { atlassianAccountId: atlassianAccountId })=>{
        // Optimistically close the banner immediately
        setState({
            userHasDismissed: true
        });
        try {
            // The specific value being set doesn't matter as long as the property *has* been set
            await (0, $48bs8.setUserProperties)(atlassianAccountId, (0, $bf331b3210afa3da$export$4624ff00cd96e554), '1');
        } catch (error) {
            (0, $eZfBZ.fireJsonOnlyErrorAnalytics)({
                error: error,
                meta: {
                    id: 'fetchUpsellDismissedProperty',
                    packageName: 'jiraServiceManagementCmdbUpsellBanner'
                }
            });
        }
    };

});



parcelRegister("2zwXn", function(module, exports) {

$parcel$export(module.exports, "SectionMessageAction", () => $80f6352c913eb6dc$export$22cf410f36f6c7c1);
$parcel$export(module.exports, "default", () => $80f6352c913eb6dc$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $bbaTG = parcelRequire("bbaTG");

var $7u4fN = parcelRequire("7u4fN");

var $1n6uL = parcelRequire("1n6uL");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");


var $dzpl6 = parcelRequire("dzpl6");

var $2cA7B = parcelRequire("2cA7B");

var $4fxB6 = parcelRequire("4fxB6");
const $80f6352c913eb6dc$export$bdc3c19374266b98 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pku2gc _2rko1l7b",
            __cmplp.className
        ])
    });
});
const $80f6352c913eb6dc$var$defaultBlue = "var(--ds-background-accent-blue-bolder-hovered, #0C66E4)";
const $80f6352c913eb6dc$var$hoverBlue = "var(--ds-background-accent-blue-bolder, #0055CC)";
const $80f6352c913eb6dc$var$activeBlue = "var(--ds-background-accent-blue-bolder-hovered, #09326C)";
const $80f6352c913eb6dc$var$defaultPurple = "var(--ds-background-accent-purple-bolder-hovered, #6E5DC6)";
const $80f6352c913eb6dc$var$hoverPurple = "var(--ds-background-accent-purple-bolder, #5E4DB2)";
const $80f6352c913eb6dc$var$activePurple = "var(--ds-background-accent-purple-bolder-hovered, #352C63)";
const $80f6352c913eb6dc$var$gradientButtonTheme = (0, $dzpl6.getTheme)({
    buttonStyles: {
        default: {
            background: {
                // @ts-expect-error - TS2322 - Type '{ background: { default: string; focus: string; hover: string; active: string; }; color: { default: string; focus: string; hover: string; active: string; disabled: string; }; }' is not assignable to type 'CSSInterpolation'.
                default: `linear-gradient(to right, ${$80f6352c913eb6dc$var$defaultPurple}, ${$80f6352c913eb6dc$var$defaultBlue})`,
                focus: `linear-gradient(to right, ${$80f6352c913eb6dc$var$defaultPurple}, ${$80f6352c913eb6dc$var$defaultBlue})`,
                hover: `linear-gradient(to right, ${$80f6352c913eb6dc$var$hoverPurple}, ${$80f6352c913eb6dc$var$hoverBlue})`,
                active: `linear-gradient(to right, ${$80f6352c913eb6dc$var$activePurple}, ${$80f6352c913eb6dc$var$activeBlue})`
            },
            color: {
                default: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
                focus: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
                hover: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
                active: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`
            }
        }
    }
});
const $80f6352c913eb6dc$export$22cf410f36f6c7c1 = /*#__PURE__*/ (0, $eUqFw.memo)(({ children: children, onClick: onClick, href: href, testId: testId, linkComponent: linkComponent, isPrimaryAction: isPrimaryAction, target: target })=>isPrimaryAction ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($80f6352c913eb6dc$export$bdc3c19374266b98, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbaTG.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1n6uL))), {
            label: ""
        }),
        theme: $80f6352c913eb6dc$var$gradientButtonTheme,
        testId: testId,
        target: target,
        shouldFitContainer: true,
        href: href,
        component: href ? linkComponent : undefined,
        onClick: onClick
    }, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($80f6352c913eb6dc$export$bdc3c19374266b98, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: testId,
        onClick: onClick
    }, children)));
$80f6352c913eb6dc$export$22cf410f36f6c7c1.displayName = 'SectionMessageAction';
const $80f6352c913eb6dc$var$commonSectionStyles = (0, $1ZAYh.xcss)({
    border: '1px solid #0000',
    wordBreak: 'break-word',
    borderRadius: 'border.radius.300',
    backgroundRepeat: 'no-repeat, no-repeat, no-repeat',
    backgroundPosition: 'top right, center, center'
});
const $80f6352c913eb6dc$var$sectionMessageLightStyles = (0, $1ZAYh.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    background: `url(${(0, (/*@__PURE__*/$parcel$interopDefault($4fxB6)))}), linear-gradient(239deg, #F3F0FF 12.51%, #E9F2FF 51.64%, #E3FAFC 87.92%) padding-box,linear-gradient(94.37deg, #9F8FEF 7.1%, #85B8FF 50.72%, #C1F0F5 92.9%) border-box;`,
    backgroundSize: '74px 62px, cover, cover'
});
const $80f6352c913eb6dc$var$sectionMessageDarkStyles = (0, $1ZAYh.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    background: `url(${(0, (/*@__PURE__*/$parcel$interopDefault($2cA7B)))}), linear-gradient(269.14deg, #2B2451 4.98%, #092957 83.89%) padding-box, linear-gradient(224.93deg, #8F7EE7 0.49%, #388BFF 99.95%) border-box;`,
    backgroundSize: '74px 62px, cover, cover'
});
const $80f6352c913eb6dc$export$a36903bd214cec06 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, actions: actions, title: title, testId: testId, isDarkMode: isDarkMode }, ref)=>{
    const actionElements = actions;
    const actionsArray = (0, $eUqFw.Children).toArray(actionElements);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "section",
        paddingBlock: "space.200",
        paddingInline: "space.300",
        testId: testId,
        ref: ref,
        xcss: [
            isDarkMode ? $80f6352c913eb6dc$var$sectionMessageDarkStyles : $80f6352c913eb6dc$var$sectionMessageLightStyles,
            $80f6352c913eb6dc$var$commonSectionStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.200",
        alignBlock: "stretch"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.100",
        testId: testId && `${testId}--content`
    }, !!title && // To avoid overlap with the background image
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        paddingInlineEnd: "space.600"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("h4", null, title)), children, actionsArray.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        shouldWrap: true,
        testId: testId && `${testId}--actions`,
        space: "space.150",
        rowSpace: "space.0"
    }, actionsArray))));
});
$80f6352c913eb6dc$export$a36903bd214cec06.displayName = 'SectionMessage';
var $80f6352c913eb6dc$export$2e2bcd8739ae039 = $80f6352c913eb6dc$export$a36903bd214cec06;

});
var $73a5c9d720aa66e1$exports = {};

$parcel$export($73a5c9d720aa66e1$exports, "R50", () => $73a5c9d720aa66e1$export$4b84fd0e2c617bd);
$parcel$export($73a5c9d720aa66e1$exports, "R75", () => $73a5c9d720aa66e1$export$b34b069eff244586);
$parcel$export($73a5c9d720aa66e1$exports, "R100", () => $73a5c9d720aa66e1$export$be802dd0d8b57f35);
$parcel$export($73a5c9d720aa66e1$exports, "R200", () => $73a5c9d720aa66e1$export$60847d42f9da92a6);
$parcel$export($73a5c9d720aa66e1$exports, "R300", () => $73a5c9d720aa66e1$export$4a7404f376229999);
$parcel$export($73a5c9d720aa66e1$exports, "R400", () => $73a5c9d720aa66e1$export$2010d0fb4295b346);
$parcel$export($73a5c9d720aa66e1$exports, "R500", () => $73a5c9d720aa66e1$export$2837b5a1a71d5c02);
$parcel$export($73a5c9d720aa66e1$exports, "Y50", () => $73a5c9d720aa66e1$export$8d9596b529bbb9cf);
$parcel$export($73a5c9d720aa66e1$exports, "Y75", () => $73a5c9d720aa66e1$export$41060a744ab0b7ae);
$parcel$export($73a5c9d720aa66e1$exports, "Y100", () => $73a5c9d720aa66e1$export$1cc05bbbf340e559);
$parcel$export($73a5c9d720aa66e1$exports, "Y200", () => $73a5c9d720aa66e1$export$5aae31392d72caaa);
$parcel$export($73a5c9d720aa66e1$exports, "Y300", () => $73a5c9d720aa66e1$export$c6930421db9fa514);
$parcel$export($73a5c9d720aa66e1$exports, "Y400", () => $73a5c9d720aa66e1$export$59619663aa6500fb);
$parcel$export($73a5c9d720aa66e1$exports, "Y500", () => $73a5c9d720aa66e1$export$874739ea9e379ab6);
$parcel$export($73a5c9d720aa66e1$exports, "G50", () => $73a5c9d720aa66e1$export$8a6341c32b6a3ee6);
$parcel$export($73a5c9d720aa66e1$exports, "G75", () => $73a5c9d720aa66e1$export$69a3bf21b9686c2b);
$parcel$export($73a5c9d720aa66e1$exports, "G100", () => $73a5c9d720aa66e1$export$afbce1382ec95f73);
$parcel$export($73a5c9d720aa66e1$exports, "G200", () => $73a5c9d720aa66e1$export$747d86715d4175de);
$parcel$export($73a5c9d720aa66e1$exports, "G300", () => $73a5c9d720aa66e1$export$940e1f69e873f202);
$parcel$export($73a5c9d720aa66e1$exports, "G400", () => $73a5c9d720aa66e1$export$a49394138f7b8e85);
$parcel$export($73a5c9d720aa66e1$exports, "G500", () => $73a5c9d720aa66e1$export$6fa04827ac68a4fb);
$parcel$export($73a5c9d720aa66e1$exports, "B50", () => $73a5c9d720aa66e1$export$226de0355ed012f8);
$parcel$export($73a5c9d720aa66e1$exports, "B75", () => $73a5c9d720aa66e1$export$8c13c2ee36917869);
$parcel$export($73a5c9d720aa66e1$exports, "B100", () => $73a5c9d720aa66e1$export$ecfc1dff386a3e7a);
$parcel$export($73a5c9d720aa66e1$exports, "B200", () => $73a5c9d720aa66e1$export$215b7063051591f1);
$parcel$export($73a5c9d720aa66e1$exports, "B300", () => $73a5c9d720aa66e1$export$e62e8919cca44969);
$parcel$export($73a5c9d720aa66e1$exports, "B400", () => $73a5c9d720aa66e1$export$b3de0ae08da2ce64);
$parcel$export($73a5c9d720aa66e1$exports, "B500", () => $73a5c9d720aa66e1$export$a6ee3d71bc067634);
$parcel$export($73a5c9d720aa66e1$exports, "P50", () => $73a5c9d720aa66e1$export$363e4475840015bb);
$parcel$export($73a5c9d720aa66e1$exports, "P75", () => $73a5c9d720aa66e1$export$4b0a4417ed59760f);
$parcel$export($73a5c9d720aa66e1$exports, "P100", () => $73a5c9d720aa66e1$export$6011520a64d9a187);
$parcel$export($73a5c9d720aa66e1$exports, "P200", () => $73a5c9d720aa66e1$export$a7175d4e9206bc80);
$parcel$export($73a5c9d720aa66e1$exports, "P300", () => $73a5c9d720aa66e1$export$b48405b95304b5a1);
$parcel$export($73a5c9d720aa66e1$exports, "P400", () => $73a5c9d720aa66e1$export$c71e4279dd54a18d);
$parcel$export($73a5c9d720aa66e1$exports, "P500", () => $73a5c9d720aa66e1$export$147899de772240ec);
$parcel$export($73a5c9d720aa66e1$exports, "T50", () => $73a5c9d720aa66e1$export$2cf711fe14c66f06);
$parcel$export($73a5c9d720aa66e1$exports, "T75", () => $73a5c9d720aa66e1$export$7a8f4d33f6f9772c);
$parcel$export($73a5c9d720aa66e1$exports, "T100", () => $73a5c9d720aa66e1$export$776c9c497ef08533);
$parcel$export($73a5c9d720aa66e1$exports, "T200", () => $73a5c9d720aa66e1$export$69cb3ca10c1e330e);
$parcel$export($73a5c9d720aa66e1$exports, "T300", () => $73a5c9d720aa66e1$export$9dc1ef0f3f48059b);
$parcel$export($73a5c9d720aa66e1$exports, "T400", () => $73a5c9d720aa66e1$export$7c835c78b6fcdef8);
$parcel$export($73a5c9d720aa66e1$exports, "T500", () => $73a5c9d720aa66e1$export$6036577f95c3877e);
$parcel$export($73a5c9d720aa66e1$exports, "N0", () => $73a5c9d720aa66e1$export$29a4f05edc054374);
$parcel$export($73a5c9d720aa66e1$exports, "N10", () => $73a5c9d720aa66e1$export$e655ef011c4aa1a2);
$parcel$export($73a5c9d720aa66e1$exports, "N20", () => $73a5c9d720aa66e1$export$9fdfb749e33cdf97);
$parcel$export($73a5c9d720aa66e1$exports, "N30", () => $73a5c9d720aa66e1$export$3e51e8f1440314ba);
$parcel$export($73a5c9d720aa66e1$exports, "N40", () => $73a5c9d720aa66e1$export$1ce2d1575d444ceb);
$parcel$export($73a5c9d720aa66e1$exports, "N50", () => $73a5c9d720aa66e1$export$8754fc7e6d8b3000);
$parcel$export($73a5c9d720aa66e1$exports, "N60", () => $73a5c9d720aa66e1$export$c2e91cbeada39b8b);
$parcel$export($73a5c9d720aa66e1$exports, "N70", () => $73a5c9d720aa66e1$export$5f71e19f3a7ad9de);
$parcel$export($73a5c9d720aa66e1$exports, "N80", () => $73a5c9d720aa66e1$export$eaa8c8a70ac22806);
$parcel$export($73a5c9d720aa66e1$exports, "N90", () => $73a5c9d720aa66e1$export$7c87d337fb91a97d);
$parcel$export($73a5c9d720aa66e1$exports, "N100", () => $73a5c9d720aa66e1$export$d6447c357493214f);
$parcel$export($73a5c9d720aa66e1$exports, "N200", () => $73a5c9d720aa66e1$export$f563ee71e9ee74cd);
$parcel$export($73a5c9d720aa66e1$exports, "N300", () => $73a5c9d720aa66e1$export$e2ef2124cf4024b1);
$parcel$export($73a5c9d720aa66e1$exports, "N400", () => $73a5c9d720aa66e1$export$eece5f492e429f08);
$parcel$export($73a5c9d720aa66e1$exports, "N500", () => $73a5c9d720aa66e1$export$c39c0fe0f26207ae);
$parcel$export($73a5c9d720aa66e1$exports, "N600", () => $73a5c9d720aa66e1$export$7090862dc3038a9f);
$parcel$export($73a5c9d720aa66e1$exports, "N700", () => $73a5c9d720aa66e1$export$ad0bacf983b7ddaa);
$parcel$export($73a5c9d720aa66e1$exports, "N800", () => $73a5c9d720aa66e1$export$7d61b15e0da132af);
$parcel$export($73a5c9d720aa66e1$exports, "N900", () => $73a5c9d720aa66e1$export$fbda843f0a27fe96);
$parcel$export($73a5c9d720aa66e1$exports, "N10A", () => $73a5c9d720aa66e1$export$791e57b27ca738ef);
$parcel$export($73a5c9d720aa66e1$exports, "N20A", () => $73a5c9d720aa66e1$export$8d43898f60b96a82);
$parcel$export($73a5c9d720aa66e1$exports, "N30A", () => $73a5c9d720aa66e1$export$920c0d5c49070351);
$parcel$export($73a5c9d720aa66e1$exports, "N40A", () => $73a5c9d720aa66e1$export$46987b49aab6d1a8);
$parcel$export($73a5c9d720aa66e1$exports, "N50A", () => $73a5c9d720aa66e1$export$7d3359664e8bb0e5);
$parcel$export($73a5c9d720aa66e1$exports, "N60A", () => $73a5c9d720aa66e1$export$d2d3bedfb276cac0);
$parcel$export($73a5c9d720aa66e1$exports, "N70A", () => $73a5c9d720aa66e1$export$6e5e7499ff054f6d);
$parcel$export($73a5c9d720aa66e1$exports, "N80A", () => $73a5c9d720aa66e1$export$59264b346c877fa7);
$parcel$export($73a5c9d720aa66e1$exports, "N90A", () => $73a5c9d720aa66e1$export$d092757d7c64925c);
$parcel$export($73a5c9d720aa66e1$exports, "N100A", () => $73a5c9d720aa66e1$export$486ab785e4bac3c6);
$parcel$export($73a5c9d720aa66e1$exports, "N200A", () => $73a5c9d720aa66e1$export$fba592bbc6419fea);
$parcel$export($73a5c9d720aa66e1$exports, "N300A", () => $73a5c9d720aa66e1$export$13609db0e6812ab8);
$parcel$export($73a5c9d720aa66e1$exports, "N400A", () => $73a5c9d720aa66e1$export$fbae4efaa892d883);
$parcel$export($73a5c9d720aa66e1$exports, "N500A", () => $73a5c9d720aa66e1$export$f13946d26f440ce6);
$parcel$export($73a5c9d720aa66e1$exports, "N600A", () => $73a5c9d720aa66e1$export$19f58225ac52a306);
$parcel$export($73a5c9d720aa66e1$exports, "N700A", () => $73a5c9d720aa66e1$export$6384f09da70e7b62);
$parcel$export($73a5c9d720aa66e1$exports, "N800A", () => $73a5c9d720aa66e1$export$d0dccc730683edc2);
$parcel$export($73a5c9d720aa66e1$exports, "DN900", () => $73a5c9d720aa66e1$export$2f6319cf7d736c2a);
$parcel$export($73a5c9d720aa66e1$exports, "DN800", () => $73a5c9d720aa66e1$export$95126bc8884d6634);
$parcel$export($73a5c9d720aa66e1$exports, "DN700", () => $73a5c9d720aa66e1$export$8338d8c35d44ff1);
$parcel$export($73a5c9d720aa66e1$exports, "DN600", () => $73a5c9d720aa66e1$export$5368d76ae4fbbda7);
$parcel$export($73a5c9d720aa66e1$exports, "DN500", () => $73a5c9d720aa66e1$export$9f0a771d16ec8d36);
$parcel$export($73a5c9d720aa66e1$exports, "DN400", () => $73a5c9d720aa66e1$export$abcf8c38338b4aa5);
$parcel$export($73a5c9d720aa66e1$exports, "DN300", () => $73a5c9d720aa66e1$export$97e81faa16a182c7);
$parcel$export($73a5c9d720aa66e1$exports, "DN200", () => $73a5c9d720aa66e1$export$bfe21c59123ecf33);
$parcel$export($73a5c9d720aa66e1$exports, "DN100", () => $73a5c9d720aa66e1$export$ee82aa2ea6a1558);
$parcel$export($73a5c9d720aa66e1$exports, "DN90", () => $73a5c9d720aa66e1$export$682927c6ed76be02);
$parcel$export($73a5c9d720aa66e1$exports, "DN80", () => $73a5c9d720aa66e1$export$91fd9994c5be9757);
$parcel$export($73a5c9d720aa66e1$exports, "DN70", () => $73a5c9d720aa66e1$export$d281fbfe3cff2df6);
$parcel$export($73a5c9d720aa66e1$exports, "DN60", () => $73a5c9d720aa66e1$export$3902c91d8b98a753);
$parcel$export($73a5c9d720aa66e1$exports, "DN50", () => $73a5c9d720aa66e1$export$8e8133c1ba5845b5);
$parcel$export($73a5c9d720aa66e1$exports, "DN40", () => $73a5c9d720aa66e1$export$33ff357f6620b39);
$parcel$export($73a5c9d720aa66e1$exports, "DN30", () => $73a5c9d720aa66e1$export$633847cf062b69e0);
$parcel$export($73a5c9d720aa66e1$exports, "DN20", () => $73a5c9d720aa66e1$export$9776a6e503bdbf76);
$parcel$export($73a5c9d720aa66e1$exports, "DN10", () => $73a5c9d720aa66e1$export$6c813d5160dff5db);
$parcel$export($73a5c9d720aa66e1$exports, "DN0", () => $73a5c9d720aa66e1$export$3d4f271a500072a);
$parcel$export($73a5c9d720aa66e1$exports, "DN800A", () => $73a5c9d720aa66e1$export$fe151285c22759ec);
$parcel$export($73a5c9d720aa66e1$exports, "DN700A", () => $73a5c9d720aa66e1$export$a101c6190d0da34);
$parcel$export($73a5c9d720aa66e1$exports, "DN600A", () => $73a5c9d720aa66e1$export$4b16f52932fda51);
$parcel$export($73a5c9d720aa66e1$exports, "DN500A", () => $73a5c9d720aa66e1$export$a74bcd7b9845b0d8);
$parcel$export($73a5c9d720aa66e1$exports, "DN400A", () => $73a5c9d720aa66e1$export$9209c179316d1751);
$parcel$export($73a5c9d720aa66e1$exports, "DN300A", () => $73a5c9d720aa66e1$export$88f55133f636c8dd);
$parcel$export($73a5c9d720aa66e1$exports, "DN200A", () => $73a5c9d720aa66e1$export$51126f85d1009512);
$parcel$export($73a5c9d720aa66e1$exports, "DN100A", () => $73a5c9d720aa66e1$export$a069b547bd23af78);
$parcel$export($73a5c9d720aa66e1$exports, "DN90A", () => $73a5c9d720aa66e1$export$40cce05af3b2600a);
$parcel$export($73a5c9d720aa66e1$exports, "DN80A", () => $73a5c9d720aa66e1$export$b78942185925a0d);
$parcel$export($73a5c9d720aa66e1$exports, "DN70A", () => $73a5c9d720aa66e1$export$e058fb44b8eaafca);
$parcel$export($73a5c9d720aa66e1$exports, "DN60A", () => $73a5c9d720aa66e1$export$92b0b8de26920c18);
$parcel$export($73a5c9d720aa66e1$exports, "DN50A", () => $73a5c9d720aa66e1$export$67564f7459d3fc9e);
$parcel$export($73a5c9d720aa66e1$exports, "DN40A", () => $73a5c9d720aa66e1$export$77868e1ca884ffa3);
$parcel$export($73a5c9d720aa66e1$exports, "DN30A", () => $73a5c9d720aa66e1$export$2afd71d7d3ea2cd5);
$parcel$export($73a5c9d720aa66e1$exports, "DN20A", () => $73a5c9d720aa66e1$export$f2a0acaab9972c70);
$parcel$export($73a5c9d720aa66e1$exports, "DN10A", () => $73a5c9d720aa66e1$export$9ab70e67d6475361);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $73a5c9d720aa66e1$export$4b84fd0e2c617bd = '#FFEBE6';
const $73a5c9d720aa66e1$export$b34b069eff244586 = '#FFBDAD';
const $73a5c9d720aa66e1$export$be802dd0d8b57f35 = '#FF8F73';
const $73a5c9d720aa66e1$export$60847d42f9da92a6 = '#FF7452';
const $73a5c9d720aa66e1$export$4a7404f376229999 = '#FF5630';
const $73a5c9d720aa66e1$export$2010d0fb4295b346 = '#DE350B';
const $73a5c9d720aa66e1$export$2837b5a1a71d5c02 = '#BF2600';
const $73a5c9d720aa66e1$export$8d9596b529bbb9cf = '#FFFAE6';
const $73a5c9d720aa66e1$export$41060a744ab0b7ae = '#FFF0B3';
const $73a5c9d720aa66e1$export$1cc05bbbf340e559 = '#FFE380';
const $73a5c9d720aa66e1$export$5aae31392d72caaa = '#FFC400';
const $73a5c9d720aa66e1$export$c6930421db9fa514 = '#FFAB00';
const $73a5c9d720aa66e1$export$59619663aa6500fb = '#FF991F';
const $73a5c9d720aa66e1$export$874739ea9e379ab6 = '#FF8B00';
const $73a5c9d720aa66e1$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $73a5c9d720aa66e1$export$69a3bf21b9686c2b = '#ABF5D1';
const $73a5c9d720aa66e1$export$afbce1382ec95f73 = '#79F2C0';
const $73a5c9d720aa66e1$export$747d86715d4175de = '#57D9A3';
const $73a5c9d720aa66e1$export$940e1f69e873f202 = '#36B37E';
const $73a5c9d720aa66e1$export$a49394138f7b8e85 = '#00875A';
const $73a5c9d720aa66e1$export$6fa04827ac68a4fb = '#006644';
const $73a5c9d720aa66e1$export$226de0355ed012f8 = '#DEEBFF';
const $73a5c9d720aa66e1$export$8c13c2ee36917869 = '#B3D4FF';
const $73a5c9d720aa66e1$export$ecfc1dff386a3e7a = '#4C9AFF';
const $73a5c9d720aa66e1$export$215b7063051591f1 = '#2684FF';
const $73a5c9d720aa66e1$export$e62e8919cca44969 = '#0065FF';
const $73a5c9d720aa66e1$export$b3de0ae08da2ce64 = '#0052CC';
const $73a5c9d720aa66e1$export$a6ee3d71bc067634 = '#0747A6';
const $73a5c9d720aa66e1$export$363e4475840015bb = '#EAE6FF';
const $73a5c9d720aa66e1$export$4b0a4417ed59760f = '#C0B6F2';
const $73a5c9d720aa66e1$export$6011520a64d9a187 = '#998DD9';
const $73a5c9d720aa66e1$export$a7175d4e9206bc80 = '#8777D9';
const $73a5c9d720aa66e1$export$b48405b95304b5a1 = '#6554C0';
const $73a5c9d720aa66e1$export$c71e4279dd54a18d = '#5243AA';
const $73a5c9d720aa66e1$export$147899de772240ec = '#403294';
const $73a5c9d720aa66e1$export$2cf711fe14c66f06 = '#E6FCFF';
const $73a5c9d720aa66e1$export$7a8f4d33f6f9772c = '#B3F5FF';
const $73a5c9d720aa66e1$export$776c9c497ef08533 = '#79E2F2';
const $73a5c9d720aa66e1$export$69cb3ca10c1e330e = '#00C7E6';
const $73a5c9d720aa66e1$export$9dc1ef0f3f48059b = '#00B8D9';
const $73a5c9d720aa66e1$export$7c835c78b6fcdef8 = '#00A3BF';
const $73a5c9d720aa66e1$export$6036577f95c3877e = '#008DA6';
const $73a5c9d720aa66e1$export$29a4f05edc054374 = '#FFFFFF';
const $73a5c9d720aa66e1$export$e655ef011c4aa1a2 = '#FAFBFC';
const $73a5c9d720aa66e1$export$9fdfb749e33cdf97 = '#F4F5F7';
const $73a5c9d720aa66e1$export$3e51e8f1440314ba = '#EBECF0';
const $73a5c9d720aa66e1$export$1ce2d1575d444ceb = '#DFE1E6';
const $73a5c9d720aa66e1$export$8754fc7e6d8b3000 = '#C1C7D0';
const $73a5c9d720aa66e1$export$c2e91cbeada39b8b = '#B3BAC5';
const $73a5c9d720aa66e1$export$5f71e19f3a7ad9de = '#A5ADBA';
const $73a5c9d720aa66e1$export$eaa8c8a70ac22806 = '#97A0AF';
const $73a5c9d720aa66e1$export$7c87d337fb91a97d = '#8993A4';
const $73a5c9d720aa66e1$export$d6447c357493214f = '#7A869A';
const $73a5c9d720aa66e1$export$f563ee71e9ee74cd = '#6B778C';
const $73a5c9d720aa66e1$export$e2ef2124cf4024b1 = '#5E6C84';
const $73a5c9d720aa66e1$export$eece5f492e429f08 = '#505F79';
const $73a5c9d720aa66e1$export$c39c0fe0f26207ae = '#42526E';
const $73a5c9d720aa66e1$export$7090862dc3038a9f = '#344563';
const $73a5c9d720aa66e1$export$ad0bacf983b7ddaa = '#253858';
const $73a5c9d720aa66e1$export$7d61b15e0da132af = '#172B4D';
const $73a5c9d720aa66e1$export$fbda843f0a27fe96 = '#091E42';
const $73a5c9d720aa66e1$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $73a5c9d720aa66e1$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $73a5c9d720aa66e1$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $73a5c9d720aa66e1$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $73a5c9d720aa66e1$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $73a5c9d720aa66e1$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $73a5c9d720aa66e1$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $73a5c9d720aa66e1$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $73a5c9d720aa66e1$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $73a5c9d720aa66e1$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $73a5c9d720aa66e1$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $73a5c9d720aa66e1$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $73a5c9d720aa66e1$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $73a5c9d720aa66e1$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $73a5c9d720aa66e1$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $73a5c9d720aa66e1$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $73a5c9d720aa66e1$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $73a5c9d720aa66e1$export$2f6319cf7d736c2a = '#E6EDFA';
const $73a5c9d720aa66e1$export$95126bc8884d6634 = '#DCE5F5';
const $73a5c9d720aa66e1$export$8338d8c35d44ff1 = '#CED9EB';
const $73a5c9d720aa66e1$export$5368d76ae4fbbda7 = '#B8C7E0';
const $73a5c9d720aa66e1$export$9f0a771d16ec8d36 = '#ABBBD6';
const $73a5c9d720aa66e1$export$abcf8c38338b4aa5 = '#9FB0CC';
const $73a5c9d720aa66e1$export$97e81faa16a182c7 = '#8C9CB8';
const $73a5c9d720aa66e1$export$bfe21c59123ecf33 = '#7988A3';
const $73a5c9d720aa66e1$export$ee82aa2ea6a1558 = '#67758F';
const $73a5c9d720aa66e1$export$682927c6ed76be02 = '#56637A';
const $73a5c9d720aa66e1$export$91fd9994c5be9757 = '#455166';
const $73a5c9d720aa66e1$export$d281fbfe3cff2df6 = '#3B475C';
const $73a5c9d720aa66e1$export$3902c91d8b98a753 = '#313D52';
const $73a5c9d720aa66e1$export$8e8133c1ba5845b5 = '#283447';
const $73a5c9d720aa66e1$export$33ff357f6620b39 = '#202B3D';
const $73a5c9d720aa66e1$export$633847cf062b69e0 = '#1B2638';
const $73a5c9d720aa66e1$export$9776a6e503bdbf76 = '#121A29';
const $73a5c9d720aa66e1$export$6c813d5160dff5db = '#0E1624';
const $73a5c9d720aa66e1$export$3d4f271a500072a = '#0D1424';
const $73a5c9d720aa66e1$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $73a5c9d720aa66e1$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $73a5c9d720aa66e1$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $73a5c9d720aa66e1$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $73a5c9d720aa66e1$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $73a5c9d720aa66e1$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $73a5c9d720aa66e1$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $73a5c9d720aa66e1$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $73a5c9d720aa66e1$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $73a5c9d720aa66e1$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $73a5c9d720aa66e1$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $73a5c9d720aa66e1$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $73a5c9d720aa66e1$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $73a5c9d720aa66e1$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $73a5c9d720aa66e1$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $73a5c9d720aa66e1$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $73a5c9d720aa66e1$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';

parcelRegister("dzpl6", function(module, exports) {

$parcel$export(module.exports, "getTheme", () => $55e2e88bfdce03b8$export$89cbf1a0881c8b9c);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // @ts-expect-error - TS2614 - Module '"@atlaskit/button"' has no exported member 'ButtonTheme'. Did you mean to use 'import ButtonTheme from "@atlaskit/button"' instead?

const $55e2e88bfdce03b8$export$9e61512f2dc2cbb0 = (currentTheme, props)=>{
    const { buttonStyles: buttonStyles, ...rest } = currentTheme(props);
    const theme = {
        ...rest,
        buttonStyles: {
            ...buttonStyles,
            backgroundColor: (0, $73a5c9d720aa66e1$exports).P400,
            '> span': {
                color: (0, $73a5c9d720aa66e1$exports).N0
            }
        }
    };
    return theme;
};
const $55e2e88bfdce03b8$export$f9380c9a627682d3 = (newTheme, themeProps)=>{
    const { appearance: appearance, mode: mode, state: state } = themeProps;
    if (!appearance || !newTheme[appearance]) return undefined;
    const root = newTheme[appearance];
    // @ts-expect-error - TS2739 - Type 'Record<string, any>' is missing the following properties from type 'ThemeTokens': buttonStyles, spinnerStyles
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return Object.keys(root).reduce((acc, val)=>{
        let node = root;
        [
            val,
            state,
            mode
        ].forEach((item)=>{
            if (!item) return;
            if (!node[item] && node[item] !== 0) return;
            if (typeof node[item] !== 'object') {
                acc[val] = node[item];
                return;
            }
            // @ts-expect-error - TS2322 - Type 'string | number | { [key: string]: string | number; } | T' is not assignable to type '{ [key: string]: string | number; } | T'.
            node = node[item];
        });
        return acc;
    }, {});
};
const $55e2e88bfdce03b8$export$89cbf1a0881c8b9c = (overrides)=>(currentTheme, themeProps)=>{
        const theme = currentTheme(themeProps);
        // @ts-expect-error - TS2322 - Type 'Record<string, any>' is not assignable to type 'ThemeTokens'.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const styles = Object.entries(theme).reduce(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (acc, [key, value])=>{
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'Partial<ThemeTokens>'.
            if (!overrides?.[key]) {
                acc[key] = value;
                return acc;
            }
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'Partial<ThemeTokens>'.
            const overriddenStyles = $55e2e88bfdce03b8$export$f9380c9a627682d3(overrides[key], themeProps);
            acc[key] = {
                ...value,
                ...overriddenStyles
            };
            return acc;
        }, {});
        return styles;
    };

});

parcelRegister("2cA7B", function(module, exports) {
module.exports = new URL("crystal-rainbow-dark.060631f6.svg", import.meta.url).toString();

});

parcelRegister("4fxB6", function(module, exports) {
module.exports = new URL("crystal-rainbow.3a68bf32.svg", import.meta.url).toString();

});



parcelRegister("kWOx5", function(module, exports) {

$parcel$export(module.exports, "CmdbUpsellCommonBase", () => $fa1cbc1d97eb2855$export$3e345e5ff922b265);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");

var $gd0Sp = parcelRequire("gd0Sp");

var $jdyFs = parcelRequire("jdyFs");
const $fa1cbc1d97eb2855$export$3e345e5ff922b265 = (props)=>{
    const { isSiteAdmin: isSiteAdmin, appEditions: appEditions } = (0, $gd0Sp.useTenantContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: `${props.variation}-error-boundary`,
        packageName: "cmdb-upsell-banner",
        fallback: "unmount",
        teamName: "falcons"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: "Banner",
        sourceName: "cmdbUpsell",
        attributes: {
            cmdbUpsellBannerVariation: props.variation,
            servicedeskEdition: appEditions.serviceDesk,
            isSiteAdmin: isSiteAdmin
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jdyFs.UpsellVisibilityCheck), null, props.children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null))));
};

});
parcelRegister("jdyFs", function(module, exports) {

$parcel$export(module.exports, "UpsellVisibilityCheck", () => $5fc0801e13053c47$export$dab13fc37117b331);

var $eUqFw = parcelRequire("eUqFw");

var $8PehF = parcelRequire("8PehF");

var $aeCba = parcelRequire("aeCba");

var $gd0Sp = parcelRequire("gd0Sp");

var $aUBpV = parcelRequire("aUBpV");
const $5fc0801e13053c47$export$dab13fc37117b331 = (props)=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    if ((0, $aeCba.isPremiumInstance)(tenantContext) || !tenantContext.atlassianAccountId || !(0, $8PehF.isCMDBEnabledInEnvironment)()) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aUBpV.CmdbUpsellStoreContainer), {
        atlassianAccountId: tenantContext.atlassianAccountId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aUBpV.CmdbUpsellStoreSubscriber), null, ({ userHasDismissed: userHasDismissed })=>userHasDismissed === false && props.children));
};

});


parcelRegister("6CGJY", function(module, exports) {

$parcel$export(module.exports, "messages", () => $eb9be6315ba9ad37$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $eb9be6315ba9ad37$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    servicesTitle: {
        "id": "service-management-cmdb-upsell-banner.services-title",
        "defaultMessage": "Map your services with Assets"
    },
    servicesDescription: {
        "id": "service-management-cmdb-upsell-banner.services-description",
        "defaultMessage": "Get a deeper understanding of dependencies and other relationships. Upgrade to Premium to connect and consolidate your assets."
    },
    featuresTitle: {
        "id": "service-management-cmdb-upsell-banner.features-title",
        "defaultMessage": "Unlock asset and configuration management for your team"
    },
    featuresDescription: {
        "id": "service-management-cmdb-upsell-banner.features-description",
        "defaultMessage": "Get your team the data they need, when they need it. Connect and consolidate your assets, then surface them inside issues for your team to quickly access."
    },
    learnMore: {
        "id": "service-management-cmdb-upsell-banner.learn-more",
        "defaultMessage": "Learn more about Jira Service Management Premium features."
    },
    tryItNow: {
        "id": "service-management-cmdb-upsell-banner.try-it-now",
        "defaultMessage": "Try it now"
    },
    maybeLater: {
        "id": "service-management-cmdb-upsell-banner.maybe-later",
        "defaultMessage": "Maybe later"
    }
});

});


parcelRegister("kDb0Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $6fa9733cbaf62495$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $aSEj7 = parcelRequire("aSEj7");

var $78d1w = parcelRequire("78d1w");
const $6fa9733cbaf62495$var$useReviseFeaturesResource = ()=>{
    const [{ isInitialRender: isInitialRender }] = (0, $78d1w.useSpaStateTransition)();
    const { data: data, loading: loading, refresh: refresh } = (0, $aSEj7.default)();
    const isInitialResourceFetchRef = (0, $eUqFw.useRef)(!data && loading);
    (0, $eUqFw.useEffect)(()=>{
        if (!isInitialRender && !isInitialResourceFetchRef.current) refresh();
    }, [
        isInitialRender,
        refresh
    ]);
};
var $6fa9733cbaf62495$export$2e2bcd8739ae039 = $6fa9733cbaf62495$var$useReviseFeaturesResource;

});
parcelRegister("aSEj7", function(module, exports) {

$parcel$export(module.exports, "default", () => $d93f023cd162d6f9$export$2e2bcd8739ae039);

var $k1AKH = parcelRequire("k1AKH");

var $lB25E = parcelRequire("lB25E");
const $d93f023cd162d6f9$var$useServiceProjectFeatures = ()=>(0, $lB25E.useResource)((0, $k1AKH.featuresResource));
var $d93f023cd162d6f9$export$2e2bcd8739ae039 = $d93f023cd162d6f9$var$useServiceProjectFeatures;

});


parcelRegister("3KRtq", function(module, exports) {

$parcel$export(module.exports, "default", () => $179e4f2b7f5cb98f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $c76ap = parcelRequire("c76ap");

var $1YMP9 = parcelRequire("1YMP9");

var $dpXKE = parcelRequire("dpXKE");

var $3a8wJ = parcelRequire("3a8wJ");

var $bNe1g = parcelRequire("bNe1g");
const $179e4f2b7f5cb98f$var$Header = ({ title: title })=>{
    const { data: projectContext } = (0, $bNe1g.useProjectContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3a8wJ.default), {
        breadcrumbs: projectContext && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dpXKE.default), {
            baseUrl: "",
            projectKey: projectContext.projectKey,
            projectName: projectContext.projectName
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1YMP9.default), {
            baseUrl: "",
            projectKey: projectContext.projectKey,
            projectType: projectContext.projectType,
            isSimplified: projectContext.simplified
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c76ap.default), null)))
    }, title);
};
var $179e4f2b7f5cb98f$export$2e2bcd8739ae039 = $179e4f2b7f5cb98f$var$Header;

});
parcelRegister("1YMP9", function(module, exports) {

$parcel$export(module.exports, "default", () => $90e5325849889e8c$export$2e2bcd8739ae039);

var $giAhk = parcelRequire("giAhk");

var $7AJNu = parcelRequire("7AJNu");
var $90e5325849889e8c$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)((0, $7AJNu.default));

});
parcelRegister("7AJNu", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a78352310a6c306$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $aTgXo = parcelRequire("aTgXo");

var $5IARc = parcelRequire("5IARc");

var $jBULE = parcelRequire("jBULE");
const $8a78352310a6c306$var$ProjectSettingsBreadcrumb = ({ children: children, projectKey: projectKey, projectType: projectType, isSimplified: isSimplified = false, intl: { formatMessage: formatMessage } })=>projectType && // <- we need this first condition just to avoid Flow error at createProjectSettingsUrl
    (projectType === (0, $7ZZxN.CORE_PROJECT) || projectType === (0, $7ZZxN.SOFTWARE_PROJECT) || projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT)) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aTgXo.default), {
        breadcrumb: {
            href: (0, $5IARc.createProjectSettingsUrl)(projectKey, projectType, isSimplified),
            text: formatMessage((0, $jBULE.default).projectSettingsTitle),
            type: 'projectSettings'
        }
    }, children) : children;
var $8a78352310a6c306$export$2e2bcd8739ae039 = $8a78352310a6c306$var$ProjectSettingsBreadcrumb;

});
parcelRegister("jBULE", function(module, exports) {

$parcel$export(module.exports, "default", () => $b99c71c52f70e552$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b99c71c52f70e552$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    projectSettingsTitle: {
        "id": "platform.ui.breadcrumbs.common-breadcrumbs.project-settings.project-settings-title",
        "defaultMessage": "Project settings"
    }
});

});



parcelRegister("3a8wJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2992b0d4d3fe9569$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ /* This is a wrapper around @atlaskit/page-header to patch a bug where text alignment
 in actions is incorrect. This common component is no longer necessary when
 https://ecosystem.atlassian.net/browse/AK-6385 is resolved.
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $hFGUl = parcelRequire("hFGUl");
const $2992b0d4d3fe9569$var$PageHeader = ({ actions: actions, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hFGUl.default), {
        ...props,
        // @ts-expect-error - TS2322 - Type 'Element | null' is not assignable to type 'ReactElement<any, string | JSXElementConstructor<any>> | undefined'.
        actions: actions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2992b0d4d3fe9569$var$ActionsWrapper, null, actions) : null
    });
var $2992b0d4d3fe9569$export$2e2bcd8739ae039 = $2992b0d4d3fe9569$var$PageHeader;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2992b0d4d3fe9569$var$ActionsWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_y3gn1e5h",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hFGUl", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0ce2fac4b2f156d$export$2e2bcd8739ae039);
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ 
var $eUqFw = parcelRequire("eUqFw");

var $5ubTM = parcelRequire("5ubTM");
/**
 * __Page header__
 *
 * A page header defines the top of a page. It contains a title and can be optionally combined with
 * breadcrumbs buttons, search, and filters.
 *
 * - [Examples](https://atlassian.design/components/page-header/examples)
 * - [Code](https://atlassian.design/components/page-header/code)
 * - [Usage](https://atlassian.design/components/page-header/usage)
 */ const $f0ce2fac4b2f156d$var$PageHeader = ({ innerRef: innerRef, breadcrumbs: breadcrumbs, actions: actions, bottomBar: bottomBar, children: children, id: id, disableTitleStyles: disableTitleStyles = false, truncateTitle: truncateTitle = false })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.OuterWrapper), null, breadcrumbs, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.TitleWrapper), {
        truncateTitle: truncateTitle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.TitleContainer), {
        truncateTitle: truncateTitle
    }, disableTitleStyles ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.StyledTitleWrapper), {
        ref: innerRef,
        truncateTitle: truncateTitle,
        id: id
    }, children)), actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.ActionsWrapper), null, actions)), bottomBar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.BottomBarWrapper), null, " ", bottomBar, " "));
};
var $f0ce2fac4b2f156d$export$2e2bcd8739ae039 = $f0ce2fac4b2f156d$var$PageHeader;

});
parcelRegister("5ubTM", function(module, exports) {

$parcel$export(module.exports, "OuterWrapper", () => $fce98fdc5842132f$export$edaaad985a878983);
$parcel$export(module.exports, "StyledTitleWrapper", () => $fce98fdc5842132f$export$284be1ee64a3465c);
$parcel$export(module.exports, "TitleWrapper", () => $fce98fdc5842132f$export$585a3b23e887288b);
$parcel$export(module.exports, "TitleContainer", () => $fce98fdc5842132f$export$35e09ba17cc51c69);
$parcel$export(module.exports, "ActionsWrapper", () => $fce98fdc5842132f$export$c8223871eecc8f3a);
$parcel$export(module.exports, "BottomBarWrapper", () => $fce98fdc5842132f$export$6330225854c30dc);
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. The prop name concerned here is truncateTitle.
// This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ /**
                                                                          * @jsxRuntime classic
                                                                          * @jsx jsx
                                                                          */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
function $fce98fdc5842132f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $fce98fdc5842132f$var$truncateStyles = {
    name: "13oenf9",
    styles: "overflow-x:hidden;overflow-y:hidden;text-overflow:ellipsis;white-space:nowrap"
};
const $fce98fdc5842132f$var$outerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    margin: `${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-200, 16px)"} 0`
});
const $fce98fdc5842132f$var$titleStyles = {
    name: "1o56te0",
    styles: "color:var(--ds-text, #172B4D);font:var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);letter-spacing:normal;margin-block-start:0;outline:none"
};
const $fce98fdc5842132f$var$titleWrapperStyles = {
    name: "1wb76vg",
    styles: "display:flex;align-items:flex-start;flex-wrap:wrap"
};
const $fce98fdc5842132f$var$titleWrapperTruncateStyles = {
    name: "14gl6v0",
    styles: "flex-wrap:nowrap"
};
const $fce98fdc5842132f$var$titleContainerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    minWidth: 0,
    maxWidth: '100%',
    flex: '1 0 auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    flexShrink: undefined,
    marginBlockEnd: "var(--ds-space-100, 8px)"
});
const $fce98fdc5842132f$var$actionStyles = {
    name: "1ianfu6",
    styles: "max-width:100%;flex:0 0 auto;margin-block-end:var(--ds-space-100, 8px);margin-inline-start:auto;padding-inline-start:var(--ds-space-400, 32px);white-space:nowrap;>{text-align:right;}"
};
const $fce98fdc5842132f$var$titleContainerTruncateStyles = {
    name: "s2a4s9",
    styles: "flex-shrink:1"
};
const $fce98fdc5842132f$var$bottomBarStyles = (0, $1ZAYh.xcss)({
    marginBlockStart: 'space.200'
});
const $fce98fdc5842132f$export$edaaad985a878983 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $fce98fdc5842132f$var$outerStyles
    }, children);
};
const $fce98fdc5842132f$export$284be1ee64a3465c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(({ children: children, id: id, truncateTitle: truncateTitle }, ref)=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("h1", {
        css: [
            $fce98fdc5842132f$var$titleStyles,
            truncateTitle && $fce98fdc5842132f$var$truncateStyles
        ],
        ref: ref,
        tabIndex: -1,
        id: id
    }, children);
});
const $fce98fdc5842132f$export$585a3b23e887288b = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $fce98fdc5842132f$var$titleWrapperStyles,
            truncateTitle && $fce98fdc5842132f$var$titleWrapperTruncateStyles
        ]
    }, children);
};
const $fce98fdc5842132f$export$35e09ba17cc51c69 = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $fce98fdc5842132f$var$titleContainerStyles,
            truncateTitle && $fce98fdc5842132f$var$titleContainerTruncateStyles
        ]
    }, children);
};
const $fce98fdc5842132f$export$c8223871eecc8f3a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $fce98fdc5842132f$var$actionStyles
    }, children);
};
const $fce98fdc5842132f$export$6330225854c30dc = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        xcss: $fce98fdc5842132f$var$bottomBarStyles
    }, children);
};

});




parcelRegister("5v6cG", function(module, exports) {

$parcel$export(module.exports, "default", () => $380102ece4bb6900$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $380102ece4bb6900$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    pageHeader: {
        "id": "servicedesk-itsm-features.app.page-header",
        "defaultMessage": "Features"
    },
    pageDescription: {
        "id": "servicedesk-itsm-features.app.page-description",
        "defaultMessage": "Give teams access to features within this project. Enabled features appear in project navigation."
    }
});

});

parcelRegister("avTtY", function(module, exports) {

$parcel$export(module.exports, "default", () => $871a8b803dba1349$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $6zOB7 = parcelRequire("6zOB7");

var $hI5oG = parcelRequire("hI5oG");

var $iw0Y6 = parcelRequire("iw0Y6");

var $ffiyv = parcelRequire("ffiyv");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $bW292 = parcelRequire("bW292");
var $dfBCt = parcelRequire("dfBCt");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $3QLcd = parcelRequire("3QLcd");

var $8wbqg = parcelRequire("8wbqg");

var $b7RZi = parcelRequire("b7RZi");

var $eiNXE = parcelRequire("eiNXE");

var $lB6YN = parcelRequire("lB6YN");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $bNe1g = parcelRequire("bNe1g");

var $jD3pk = parcelRequire("jD3pk");


var $33vnX = parcelRequire("33vnX");

var $3e9vj = parcelRequire("3e9vj");

var $ksHP7 = parcelRequire("ksHP7");

var $dj40u = parcelRequire("dj40u");

var $co8Ny = parcelRequire("co8Ny");

var $2EAfK = parcelRequire("2EAfK");

var $fJdKO = parcelRequire("fJdKO");

var $iPgVt = parcelRequire("iPgVt");

var $h5WbH = parcelRequire("h5WbH");
const $871a8b803dba1349$var$renderGroupTitle = (message)=>{
    const headingLevel = (0, $eI5EY.fg)('jsmca11y-564-update-section-headings') ? 'h3' : 'h4';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "xsmall",
        as: headingLevel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($871a8b803dba1349$var$GroupTitle, null, message));
};
const $871a8b803dba1349$export$d891c31466b6cb8d = {
    prod: (0, $bW292.getATLContextUrl)('admin'),
    dev: 'https://admin.stg.atlassian.com',
    local: 'https://admin.stg.atlassian.com',
    staging: 'https://admin.stg.atlassian.com'
}; // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $871a8b803dba1349$var$LabsSection = /*#__PURE__*/ (0, $eUqFw.memo)(()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { data: data, saving: saving, update: update } = (0, $iPgVt.default)();
    const showSaveErrorFlag = (0, $fJdKO.default)();
    const isAdminHubAiToggleEnabled = (0, $2EAfK.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { data: projectContextData } = (0, $bNe1g.useProjectContext)();
    const { data: orgId } = (0, $jD3pk.useOrgId)();
    const environment = (0, $3e9vj.useEnvironment)();
    const isSimplifiedProject = Boolean(projectContextData?.simplified);
    const [showDefaultRequestTypeSettings, setShowDefaultRequestTypeSettings] = (0, $eUqFw.useState)(false);
    const onDefaultRequestTypeSettingsClick = (0, $eUqFw.useCallback)(()=>{
        setShowDefaultRequestTypeSettings(true);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'openDefaultRequestTypeModal');
    }, [
        setShowDefaultRequestTypeSettings,
        createAnalyticsEvent
    ]);
    const createOnChangeHandler = (0, $eUqFw.useCallback)((featureTitle)=>(feature, enabled, analyticEvent)=>{
            (0, $jMP2a.fireUIAnalytics)(analyticEvent, 'settingsToggle', {
                field: feature,
                toggleStatus: enabled
            });
            update({
                feature: feature,
                enabled: enabled,
                onFail: ()=>{
                    showSaveErrorFlag(featureTitle, enabled);
                }
            });
        }, [
        showSaveErrorFlag,
        update
    ]);
    const createOnDefaultRequestTypeChangeHandler = (0, $eUqFw.useCallback)((feature, enabled, analyticEvent)=>{
        if ((0, $1ybV0.ff)('jsm-default-request-types-none-option_4mnti')) {
            if (enabled) setShowDefaultRequestTypeSettings(true);
        }
        createOnChangeHandler(formatMessage((0, $h5WbH.default).defaultRequestTypesTitle))(feature, enabled, analyticEvent);
    }, [
        createOnChangeHandler,
        formatMessage
    ]);
    const createLearnMoreLink = (href, message, articleId, eventName)=>{
        const learnMoreLinkButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ksHP7.ExternalLink), {
            href: href
        }, message);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3QLcd.default), {
            articleId: articleId,
            appearance: "link",
            spacing: "none",
            fallbackComponent: learnMoreLinkButton,
            onClick: ()=>(0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'helpLink clicked', eventName, {
                    articleId: articleId
                })
        }, message);
    };
    const learnMoreAboutLabsDocs = createLearnMoreLink('https://support.atlassian.com/jira-service-management-cloud/docs/what-is-the-feature-lab/', formatMessage((0, $h5WbH.default).labsDocsLink), '3CH7d7kzG4SQH1kOzy8upV', 'learnMoreAboutFeatureLab');
    const learnMoreAboutSimilarRequests = createLearnMoreLink('https://support.atlassian.com/jira-service-management-cloud/docs/what-are-similar-requests/', formatMessage((0, $h5WbH.default).similarRequestsLink), '4Ok9cNp3kIzh05dO9uQTQj', 'learnMoreAboutSimilarRequestPanel');
    const learnMoreAboutSentimentField = createLearnMoreLink('https://support.atlassian.com/jira-service-management-cloud/docs/sentiment-analysis-using-atlassian-intelligence/', formatMessage((0, $h5WbH.default).sentimentLink), '15BayucZiHGq52j608lgaE', 'learnMoreAboutSimilarRequestPanel');
    const learnMoreAboutAutomaticallySettingRequestTypes = createLearnMoreLink('https://support.atlassian.com/jira-service-management-cloud/docs/choose-default-request-types-for-your-issue-types/', formatMessage((0, $h5WbH.default).defaultRequestTypesLink), '64ZIz1OHI0cPxVGYUEKQ0K', 'learnMoreAboutAutomaticallySettingRequestTypes');
    const learnMoreAboutJsmBoards = createLearnMoreLink('https://support.atlassian.com/jira-service-management-cloud/docs/manage-your-work-using-a-board/', formatMessage((0, $h5WbH.default).jsmBoardLink), '103YhAB4GHpQvY8MAc0Q2r', 'learnMoreAboutJsmBoards');
    const adminHubLink = `${$871a8b803dba1349$export$d891c31466b6cb8d[environment]}/o/${orgId}/atlassian-intelligence`;
    const sentimentFeaturePrerequisiteTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $h5WbH.default).sentimentFeaturePrerequisiteTooltip,
        values: {
            link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                    onMouseDown: ()=>window.open(adminHubLink),
                    target: "_blank",
                    href: adminHubLink
                }, chunks)
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dj40u.FeatureSection), {
        title: formatMessage((0, $h5WbH.default).labsSectionTitle),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...(0, $h5WbH.default).labsSectionDescription,
            values: {
                learnMoreLink: learnMoreAboutLabsDocs
            }
        })
    }, !(0, $1ybV0.ff)('jsm-feature-labs-views-extraction_3odmp') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, $871a8b803dba1349$var$renderGroupTitle(formatMessage((0, $h5WbH.default).jsmBoardGroupTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $co8Ny.FeatureToggleTile), {
        feature: (0, $89d8bb437c2044ff$export$1eb399d8c2d53748),
        title: formatMessage((0, $h5WbH.default).jsmBoardTitle),
        badge: (0, $1ybV0.ff)('jsm-kanban-board-lozenge_31x91') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
            appearance: "new"
        }, formatMessage((0, $h5WbH.default).newLozenge)),
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b7RZi.default), {
            alt: ""
        }),
        value: data?.[0, $89d8bb437c2044ff$export$1eb399d8c2d53748]?.status === (0, $89d8bb437c2044ff$export$e927a5d1b72f0b68),
        saving: saving[0, $89d8bb437c2044ff$export$1eb399d8c2d53748],
        onChange: createOnChangeHandler(formatMessage((0, $h5WbH.default).jsmBoardTitle))
    }, formatMessage((0, $h5WbH.default).jsmBoardDescription, {
        learnMoreLink: learnMoreAboutJsmBoards
    }))), !isSimplifiedProject && $871a8b803dba1349$var$renderGroupTitle(formatMessage((0, $h5WbH.default).issueViewTitle)), !(0, $dfBCt.isFedRamp)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $co8Ny.FeatureToggleTile), {
        feature: (0, $89d8bb437c2044ff$export$ed849d1eb34423e5),
        title: formatMessage((0, $h5WbH.default).similarRequestsPanelTitle),
        value: data?.[0, $89d8bb437c2044ff$export$ed849d1eb34423e5]?.status === (0, $89d8bb437c2044ff$export$e927a5d1b72f0b68),
        saving: saving[0, $89d8bb437c2044ff$export$ed849d1eb34423e5],
        onChange: createOnChangeHandler(formatMessage((0, $h5WbH.default).similarRequestsPanelTitle)),
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB6YN.default), {
            alt: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $h5WbH.default).similarRequestsPanelDescription,
        values: {
            learnMoreLink: learnMoreAboutSimilarRequests
        }
    })), !isSimplifiedProject && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $co8Ny.FeatureToggleTile), {
        feature: (0, $89d8bb437c2044ff$export$3d2ce10d3ca55e3c),
        title: formatMessage((0, $h5WbH.default).defaultRequestTypesTitle),
        value: data?.[0, $89d8bb437c2044ff$export$3d2ce10d3ca55e3c]?.status === (0, $89d8bb437c2044ff$export$e927a5d1b72f0b68),
        saving: saving[0, $89d8bb437c2044ff$export$3d2ce10d3ca55e3c],
        onChange: createOnDefaultRequestTypeChangeHandler,
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8wbqg.default), {
            alt: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $h5WbH.default).defaultRequestTypesDescription,
        values: {
            learnMoreLink: learnMoreAboutAutomaticallySettingRequestTypes
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: (0, $eI5EY.fg)('jsm_views_of_work_phase_1') ? $871a8b803dba1349$var$buttonWrapperStyles : $871a8b803dba1349$var$buttonWrapperStylesOld
    }, (0, $eI5EY.fg)('jsm_views_of_work_phase_1') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($iw0Y6))),
        onClick: onDefaultRequestTypeSettingsClick
    }, formatMessage((0, $h5WbH.default).defaultRequestTypeSettingsButtonText)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "link",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iw0Y6))), {
            label: ""
        }),
        onClick: onDefaultRequestTypeSettingsClick
    }, formatMessage((0, $h5WbH.default).defaultRequestTypeSettingsButtonText)), showDefaultRequestTypeSettings && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $33vnX.default), {
        onClose: ()=>setShowDefaultRequestTypeSettings(false)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $co8Ny.FeatureToggleTile), {
        feature: (0, $89d8bb437c2044ff$export$d4a1ed8524773042),
        title: formatMessage((0, $h5WbH.default).sentimentFieldTitle),
        value: data?.[0, $89d8bb437c2044ff$export$d4a1ed8524773042]?.status === (0, $89d8bb437c2044ff$export$e927a5d1b72f0b68),
        saving: saving[0, $89d8bb437c2044ff$export$d4a1ed8524773042],
        onChange: createOnChangeHandler(formatMessage((0, $h5WbH.default).sentimentFieldTitle)),
        aiFooterRequired: true,
        tooltip: sentimentFeaturePrerequisiteTooltip,
        disabled: !isAdminHubAiToggleEnabled,
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eiNXE.default), {
            alt: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $h5WbH.default).sentimenFieldDescription,
        values: {
            learnMoreLink: learnMoreAboutSentimentField
        }
    })));
});
var $871a8b803dba1349$export$2e2bcd8739ae039 = $871a8b803dba1349$var$LabsSection;
const $871a8b803dba1349$var$buttonWrapperStylesOld = (0, $1ZAYh.xcss)({
    marginTop: 'space.100',
    marginLeft: 'space.negative.200'
});
const $871a8b803dba1349$var$buttonWrapperStyles = (0, $1ZAYh.xcss)({
    marginTop: 'space.100'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $871a8b803dba1349$var$GroupTitle = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _syaz1ifp _otyrx0bf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3QLcd", function(module, exports) {

$parcel$export(module.exports, "useHelpPanelLink", () => $82adde900735644c$export$dc5c3cc39ce0d138);
$parcel$export(module.exports, "default", () => $82adde900735644c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $cEaY5 = parcelRequire("cEaY5");

var $zcJ0y = parcelRequire("zcJ0y");

var $1ybV0 = parcelRequire("1ybV0");

var $f2Poq = parcelRequire("f2Poq");

var $1zRTT = parcelRequire("1zRTT");

var $bUi2Q = parcelRequire("bUi2Q");
const $82adde900735644c$export$dc5c3cc39ce0d138 = (resetHistory = false)=>{
    const { openRightSidebar: openRightSidebar } = (0, $bUi2Q.useRightSidebarController)();
    const [, { setNavigationData: setNavigationData }] = (0, $1zRTT.useHelpPanelActions)();
    const isIphEnabled = (0, $1ybV0.ff)('iph.enabled') && !(0, $zcJ0y.isIE11)();
    const handleOnClick = (id, type = 'HELP_ARTICLE')=>{
        openRightSidebar((0, $f2Poq.HELP_PANEL_ID), (0, $f2Poq.HELP_PANEL_WIDTH), false, true);
        if (resetHistory) setNavigationData({
            articleId: {
                id: id,
                type: (0, $cEaY5.ARTICLE_TYPE)[type]
            },
            history: []
        });
        else setNavigationData({
            articleId: {
                id: id,
                type: (0, $cEaY5.ARTICLE_TYPE)[type]
            }
        });
    };
    return isIphEnabled ? handleOnClick : undefined;
};
const $82adde900735644c$var$HelpPanelLink = ({ articleId: articleId = '', type: type = 'HELP_ARTICLE', children: children, fallbackComponent: fallbackComponent = null, onClick: onClick, ...props })=>{
    const onOpenInProductHelpArticle = $82adde900735644c$export$dc5c3cc39ce0d138();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleOnClick = (event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent);
        onOpenInProductHelpArticle?.(articleId, (0, $cEaY5.ARTICLE_TYPE)[type]);
    };
    return onOpenInProductHelpArticle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        ...props,
        onClick: handleOnClick,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        className: (0, $7JEyt.default)([
            props.appearance === 'link' && "_4bfu18uv _1hms8stv _ajmmnqa1 _9oik18uv _1bnxglyw _jf4cnqa1"
        ])
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, fallbackComponent);
};
var $82adde900735644c$export$2e2bcd8739ae039 = $82adde900735644c$var$HelpPanelLink;
const $82adde900735644c$var$buttonWrapperStyles = null;

});

parcelRegister("8wbqg", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a8698665f5a588c$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = fj7jgg5338kktq9v553qjsfv
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/fj7jgg5338kktq9v553qjsfv

var $9TZf5 = parcelRequire("9TZf5");

var $d38Go = parcelRequire("d38Go");

var $8Yw44 = parcelRequire("8Yw44");
const $8a8698665f5a588c$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($8Yw44)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($d38Go))
});
var $8a8698665f5a588c$export$2e2bcd8739ae039 = $8a8698665f5a588c$var$Illustration;
// for advanced use only
const $8a8698665f5a588c$export$a179c88182cb9d56 = [
    0,
    0,
    227,
    217
];

});
parcelRegister("d38Go", function(module, exports) {
module.exports = new URL("tools-darkmode.8c16d867.svg", import.meta.url).toString();

});

parcelRegister("8Yw44", function(module, exports) {
module.exports = new URL("tools.8e209be9.svg", import.meta.url).toString();

});


parcelRegister("b7RZi", function(module, exports) {

$parcel$export(module.exports, "default", () => $94a7c42ea17d0623$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = bc48rmkjfrtbr9csthb35z2
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/bc48rmkjfrtbr9csthb35z2

var $9TZf5 = parcelRequire("9TZf5");

var $4VvKV = parcelRequire("4VvKV");
const $94a7c42ea17d0623$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($4VvKV)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($4VvKV))
});
var $94a7c42ea17d0623$export$2e2bcd8739ae039 = $94a7c42ea17d0623$var$Illustration;
// for advanced use only
const $94a7c42ea17d0623$export$a179c88182cb9d56 = [
    0,
    0,
    248,
    158
];

});
parcelRegister("4VvKV", function(module, exports) {
module.exports = new URL("jira-board.b6e126ca.svg", import.meta.url).toString();

});


parcelRegister("eiNXE", function(module, exports) {

$parcel$export(module.exports, "default", () => $5770b2d296336c15$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $9TZf5 = parcelRequire("9TZf5");

var $kKKWT = parcelRequire("kKKWT");

var $6vymO = parcelRequire("6vymO");
const $5770b2d296336c15$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($6vymO)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($kKKWT))
});
var $5770b2d296336c15$export$2e2bcd8739ae039 = $5770b2d296336c15$var$Illustration;
// for advanced use only
const $5770b2d296336c15$export$a179c88182cb9d56 = [
    0,
    0,
    254,
    244
];

});
parcelRegister("kKKWT", function(module, exports) {
module.exports = new URL("chat-emojis-darkmode.6cddbb3f.svg", import.meta.url).toString();

});

parcelRegister("6vymO", function(module, exports) {
module.exports = new URL("chat-emojis.ced55590.svg", import.meta.url).toString();

});


parcelRegister("lB6YN", function(module, exports) {

$parcel$export(module.exports, "default", () => $caf9c995ac7631dc$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $9TZf5 = parcelRequire("9TZf5");

var $kcf4o = parcelRequire("kcf4o");

var $4WWSp = parcelRequire("4WWSp");
const $caf9c995ac7631dc$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($4WWSp)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($kcf4o))
});
var $caf9c995ac7631dc$export$2e2bcd8739ae039 = $caf9c995ac7631dc$var$Illustration;
// for advanced use only
const $caf9c995ac7631dc$export$a179c88182cb9d56 = [
    0,
    0,
    247,
    189
];

});
parcelRegister("kcf4o", function(module, exports) {
module.exports = new URL("lightbulb-orbit-darkmode.1b2c96a6.svg", import.meta.url).toString();

});

parcelRegister("4WWSp", function(module, exports) {
module.exports = new URL("lightbulb-orbit.353743a0.svg", import.meta.url).toString();

});


const $89d8bb437c2044ff$export$b45a36df7873757 = 'alerts';
const $89d8bb437c2044ff$export$a7952c5a5c371ddd = 'oncall';
const $89d8bb437c2044ff$export$de0bca182bc46c7f = 'services';
const $89d8bb437c2044ff$export$ed849d1eb34423e5 = 'similarIssues';
const $89d8bb437c2044ff$export$d4a1ed8524773042 = 'sentiment-analysis';
const $89d8bb437c2044ff$export$3d2ce10d3ca55e3c = 'automaticallySetRequestType';
const $89d8bb437c2044ff$export$cae2404f62c0f4d7 = 'change-management';
const $89d8bb437c2044ff$export$31ffe79c2b019cf = 'incident-management';
const $89d8bb437c2044ff$export$3a20074cc38cbf69 = 'problem-management';
const $89d8bb437c2044ff$export$a364d86306d4a6d4 = 'service-request';
const $89d8bb437c2044ff$export$71f1a79e03f525 = 'post-incident-review';
const $89d8bb437c2044ff$export$ff4743f07602eea7 = 'csat';
const $89d8bb437c2044ff$export$51e98af8dd4951f3 = 'email-request';
const $89d8bb437c2044ff$export$6860c7a26d6d6d35 = 'csm-customer-context';
const $89d8bb437c2044ff$export$7c5ee80fcb40e9d3 = 'developer-escalation';
const $89d8bb437c2044ff$export$28fc94ee6c61f632 = 'products-and-entitlements';
const $89d8bb437c2044ff$export$93b42272f76473c9 = 'jsm-views';
const $89d8bb437c2044ff$export$1eb399d8c2d53748 = 'jsm-board';
const $89d8bb437c2044ff$export$abbcecf25bfa1e87 = 'jsm-calendar';
const $89d8bb437c2044ff$export$66ede2c1de447f8f = 'developer-escalation';
const $89d8bb437c2044ff$export$e927a5d1b72f0b68 = 'ENABLED';
const $89d8bb437c2044ff$export$8cd212c10b4124d2 = 'DISABLED';

parcelRegister("33vnX", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c99200bb65a9c25$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $5c99200bb65a9c25$var$LazyDefaultRequestTypeSettings = (0, $7rh0R.lazy)(()=>(parcelRequire("3XDh8")), {
    moduleId: "./src/packages/servicedesk/default-request-type-settings/src/ui/index.tsx"
});
const $5c99200bb65a9c25$var$AsyncDefaultRequestTypeSettings = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "async-jira-servicedesk-default-request-type-settings",
        packageName: "jira-servicedesk-default-request-type-settings",
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jira-servicedesk-default-request-type-settings",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5c99200bb65a9c25$var$LazyDefaultRequestTypeSettings, props)));
var $5c99200bb65a9c25$export$2e2bcd8739ae039 = $5c99200bb65a9c25$var$AsyncDefaultRequestTypeSettings;

});
parcelRegister("3XDh8", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("ldZeb")
]).then(()=>parcelRequire('bq6Et'));

});


parcelRegister("ksHP7", function(module, exports) {

$parcel$export(module.exports, "ExternalLink", () => $6aa5ffb8db519abc$export$b2bf131c9f9cce5d);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $5OdZ3 = parcelRequire("5OdZ3");

var $eI5EY = parcelRequire("eI5EY");
const $6aa5ffb8db519abc$export$b2bf131c9f9cce5d = ({ enabled: enabled = true, href: href, children: children = null, onClick: onClick = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))) })=>{
    if ((0, $eI5EY.fg)('jsm_gs_a11y_fixes_p1')) return enabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5OdZ3.default), {
        rel: "noreferrer",
        href: href,
        target: "_blank",
        onClick: onClick
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
    return enabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
        rel: "noreferrer",
        href: href,
        target: "_blank",
        onClick: onClick
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
};

});

parcelRegister("dj40u", function(module, exports) {

$parcel$export(module.exports, "FeatureSection", () => $dc72de8df24aab47$export$51869905696433f4);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $hI5oG = parcelRequire("hI5oG");

var $eI5EY = parcelRequire("eI5EY");
const $dc72de8df24aab47$export$51869905696433f4 = ({ title: title, description: description, children: children })=>{
    const headingLevel = (0, $eI5EY.fg)('jsmca11y-564-update-section-headings') ? 'h2' : 'h5';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dc72de8df24aab47$var$Wrapper, null, Boolean(title) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        as: headingLevel,
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dc72de8df24aab47$export$f99233281efd08a0, null, title)), Boolean(description) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dc72de8df24aab47$export$393edc798c47379d, null, description), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dc72de8df24aab47$export$6ce170286acaa8d3, null, children));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $dc72de8df24aab47$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s81jx0",
            __cmplp.className
        ])
    });
});
const $dc72de8df24aab47$export$f99233281efd08a0 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_otyrpxbi",
            __cmplp.className
        ])
    });
});
const $dc72de8df24aab47$export$393edc798c47379d = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_otyrxy5q",
            __cmplp.className
        ])
    });
});
const $dc72de8df24aab47$export$6ce170286acaa8d3 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_wav7pxbi",
            __cmplp.className
        ])
    });
});

});

parcelRegister("co8Ny", function(module, exports) {

$parcel$export(module.exports, "FeatureToggleTile", () => $bf4f57e9bf022478$export$26dc9690f0a0e6b3);
$parcel$export(module.exports, "FeaturesToggleTile", () => $bf4f57e9bf022478$export$7438f1a0fed9f8d2);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $lhqaW = parcelRequire("lhqaW");

var $fgSLb = parcelRequire("fgSLb");
const $bf4f57e9bf022478$export$26dc9690f0a0e6b3 = ({ feature: feature, value: value, saving: saving, disabled: disabled, onChange: onChange, tooltip: tooltip, focusToggle: focusToggle = false, isPopperOpenByDefault: isPopperOpenByDefault, ...featureTileProps })=>{
    const id = `FeatureTile-${featureTileProps.title.replace(/\s+/g, '-').toLowerCase()}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lhqaW.FeatureTile), {
        ...featureTileProps,
        input: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fgSLb.FeatureToggle), {
            feature: feature,
            value: value,
            saving: saving,
            disabled: disabled,
            focusToggle: focusToggle,
            onChange: onChange,
            popperText: tooltip,
            labelId: id,
            ...(0, $1ybV0.ff)('enable_jsm_repackaging_changes_vtwk9') ? {
                isPopperOpenByDefault: isPopperOpenByDefault
            } : {}
        })
    });
};
const $bf4f57e9bf022478$export$7438f1a0fed9f8d2 = ({ features: features, value: value, saving: saving, disabled: disabled, onChange: onChange, tooltip: tooltip, focusToggle: focusToggle = false, isPopperOpenByDefault: isPopperOpenByDefault, ...featureTileProps })=>{
    const id = `FeatureTile-${featureTileProps.title.replace(/\s+/g, '-').toLowerCase()}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lhqaW.FeatureTile), {
        ...featureTileProps,
        input: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fgSLb.FeatureToggle), {
            feature: features,
            value: value,
            saving: saving,
            disabled: disabled,
            focusToggle: focusToggle,
            onChange: onChange,
            popperText: tooltip,
            labelId: id,
            ...(0, $1ybV0.ff)('enable_jsm_repackaging_changes_vtwk9') ? {
                isPopperOpenByDefault: isPopperOpenByDefault
            } : {}
        })
    });
};

});
parcelRegister("lhqaW", function(module, exports) {

$parcel$export(module.exports, "FeatureTile", () => $3e99c0c53516a434$export$e7754544f82eb73d);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $hI5oG = parcelRequire("hI5oG");

var $2eG9N = parcelRequire("2eG9N");

var $fIaoU = parcelRequire("fIaoU");
const $3e99c0c53516a434$export$e7754544f82eb73d = ({ title: title, input: input, children: children, tooltip: tooltip, badge: badge, aiFooterRequired: aiFooterRequired, illustration: illustration })=>{
    const toggleId = `FeatureTile-${title.replace(/\s+/g, '-').toLowerCase()}`;
    const imageIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3e99c0c53516a434$var$ImageContainer, null, illustration);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3e99c0c53516a434$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3e99c0c53516a434$var$FlexContainer, null, imageIcon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3e99c0c53516a434$var$Body, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        as: "h5",
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3e99c0c53516a434$var$Title, {
        htmlFor: toggleId
    }, title, badge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3e99c0c53516a434$var$Badge, null, badge))), children), tooltip ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: tooltip
    }, input) : input), aiFooterRequired && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fIaoU.AiFooter), null));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3e99c0c53516a434$var$ImageContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1o9zidpf _mezj8vuz _bna78vuz",
            __cmplp.className
        ])
    });
});
const $3e99c0c53516a434$var$Badge = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0u2gc _1e0c1o8l _s7n41ndm",
            __cmplp.className
        ])
    });
});
const $3e99c0c53516a434$var$Body = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _18s8fkly",
            __cmplp.className
        ])
    });
});
const $3e99c0c53516a434$var$FlexContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvrv2br _16jlkb7n _1yt41ejb",
            __cmplp.className
        ])
    });
});
const $3e99c0c53516a434$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16qs1os1 _bfhkvuon _19ith6cr _2rkoftgi _vchhusvi",
            __cmplp.className
        ])
    });
});
const $3e99c0c53516a434$var$Title = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1ule _19pkidpf _otyru2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fIaoU", function(module, exports) {

$parcel$export(module.exports, "AiFooter", () => $7af2387697e791cd$export$915814a2dcce5cf0);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $aUqTb = parcelRequire("aUqTb");

var $ffiyv = parcelRequire("ffiyv");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");



var $78led = parcelRequire("78led");

var $5JgJ2 = parcelRequire("5JgJ2");

var $i8ZM8 = parcelRequire("i8ZM8");
const $7af2387697e791cd$export$915814a2dcce5cf0 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ $eUqFw.createElement((0, $b5IAe.default), {
        paddingBlock: "space.050",
        xcss: $7af2387697e791cd$var$aiInfoContainerStyles
    }, /*#__PURE__*/ $eUqFw.createElement((0, $9Amv1.default), {
        role: "note",
        grow: "fill",
        alignBlock: "center",
        xcss: $7af2387697e791cd$var$inlineBlockStyles
    }, /*#__PURE__*/ $eUqFw.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aUqTb))), {
        label: "infoIcon",
        size: "medium",
        primaryColor: `var(--ds-icon-subtle, ${(0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de)})`
    }), /*#__PURE__*/ $eUqFw.createElement($7af2387697e791cd$var$AiLink, {
        href: "https://www.atlassian.com/trust/atlassian-intelligence",
        target: "_blank"
    }, formatMessage((0, $i8ZM8.default).contentQualityStatement)), /*#__PURE__*/ $eUqFw.createElement((0, $ffiyv.default), {
        appearance: "default"
    }, formatMessage((0, $i8ZM8.default).betaAccessLozenge), " "), /*#__PURE__*/ $eUqFw.createElement("div", {
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _11c81vlj _syaz131l _19bv93m8"
        ])
    }, formatMessage((0, $i8ZM8.default).aiNote), /*#__PURE__*/ $eUqFw.createElement((0, $b5IAe.default), {
        paddingInline: "space.050",
        xcss: $7af2387697e791cd$var$aiIconContainerStyles
    }, /*#__PURE__*/ $eUqFw.createElement((0, $78led.AiIcon), {
        label: "aiIcon",
        isDisabled: true,
        size: "small"
    })))));
};
const $7af2387697e791cd$var$aiInfoContainerStyles = (0, $1ZAYh.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    borderTop: `1px solid ${`var(--ds-border, ${(0, $73a5c9d720aa66e1$exports).N40})`}`
});
const $7af2387697e791cd$var$aiIconContainerStyles = (0, $1ZAYh.xcss)({
    height: '24px',
    display: 'flex',
    alignItems: 'center'
});
const $7af2387697e791cd$var$inlineBlockStyles = (0, $1ZAYh.xcss)({
    paddingLeft: 'space.200'
});
const $7af2387697e791cd$var$footerNoteTextStyles = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7af2387697e791cd$var$AiLink = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11c81vlj _syaz131l _2hwx1b66 _1053131l _30l3131l",
            __cmplp.className
        ])
    });
});

});
parcelRegister("aUqTb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7f13fdf9f823d771$var$_react = $7f13fdf9f823d771$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $7f13fdf9f823d771$var$_information = $7f13fdf9f823d771$var$_interopRequireDefault((parcelRequire("h6FFs")));
function $7f13fdf9f823d771$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7f13fdf9f823d771$var$EditorPanelIcon = (props)=>/*#__PURE__*/ $7f13fdf9f823d771$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 19a7 7 0 1 1 0-14 7 7 0 0 1 0 14m0-1.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11m0-6a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1m0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2"/></svg>`
    }, props, {
        newIcon: $7f13fdf9f823d771$var$_information.default
    }));
$7f13fdf9f823d771$var$EditorPanelIcon.displayName = 'EditorPanelIcon';
var $7f13fdf9f823d771$var$_default = module.exports.default = $7f13fdf9f823d771$var$EditorPanelIcon;

});
parcelRegister("h6FFs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6db48d6c22f8d07c19434865c237f982>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c743518dce4b322a$var$_react = $c743518dce4b322a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $c743518dce4b322a$var$_UNSAFE_baseNew = $c743518dce4b322a$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $c743518dce4b322a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Information".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: information state in section messages or inline messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c743518dce4b322a$var$InformationIcon = (props)=>/*#__PURE__*/ $c743518dce4b322a$var$_react.default.createElement($c743518dce4b322a$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m6.5-1.25H8a.75.75 0 0 1 .75.75v5h-1.5V8.25H6.5zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$c743518dce4b322a$var$InformationIcon.displayName = 'InformationIcon';
var $c743518dce4b322a$var$_default = module.exports.default = $c743518dce4b322a$var$InformationIcon;

});


parcelRegister("78led", function(module, exports) {

$parcel$export(module.exports, "AiIcon", () => $c929eac1624d8a26$export$762da6f7f5ace732);

var $eUqFw = parcelRequire("eUqFw");

var $ce8OV = parcelRequire("ce8OV");

const $c929eac1624d8a26$export$762da6f7f5ace732 = (props)=>{
    let iconAccentBlueB200;
    let textAccentBlueB400;
    if (props.isDisabled) {
        iconAccentBlueB200 = `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$exports).N200})`;
        textAccentBlueB400 = `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$exports).N200})`;
    } else if (props.isDisabled) {
        iconAccentBlueB200 = `var(--ds-icon-accent-gray, ${(0, $73a5c9d720aa66e1$exports).N300})`;
        textAccentBlueB400 = `var(--ds-text-accent-gray, ${(0, $73a5c9d720aa66e1$exports).N300})`;
    } else {
        iconAccentBlueB200 = `var(--ds-icon-accent-blue, ${(0, $73a5c9d720aa66e1$exports).B200})`;
        textAccentBlueB400 = `var(--ds-text-accent-blue, ${(0, $73a5c9d720aa66e1$exports).B400})`;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ce8OV.default), {
        ...props,
        testId: "atlassian-intelligence.common.ui.ai-icon.svg-icon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "ai_icon_lg0",
        x1: "21",
        y1: "12",
        x2: "17.5",
        y2: "12",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.270833",
        stopColor: iconAccentBlueB200,
        color: iconAccentBlueB200
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: textAccentBlueB400,
        color: textAccentBlueB400
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "ai_icon_lg1",
        x1: "12.5",
        y1: "3",
        x2: "12.5",
        y2: "6.5",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.1875",
        stopColor: iconAccentBlueB200,
        color: iconAccentBlueB200
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: textAccentBlueB400,
        color: textAccentBlueB400
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "ai_icon_lg2",
        x1: "6.82996",
        y1: "12",
        x2: "3.32996",
        y2: "12",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        stopColor: textAccentBlueB400,
        color: textAccentBlueB400
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.791667",
        stopColor: iconAccentBlueB200,
        color: iconAccentBlueB200
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "ai_icon_lg3",
        x1: "12.5",
        y1: "17",
        x2: "12.5",
        y2: "21",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        stopColor: textAccentBlueB400,
        color: textAccentBlueB400
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.802083",
        stopColor: iconAccentBlueB200,
        color: iconAccentBlueB200
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.17 12C17.17 11.4477 17.6177 11 18.17 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H18.17C17.6177 13 17.17 12.5523 17.17 12Z",
        fill: props.isDisabled ? `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$exports).N200})` : 'url(#ai_icon_lg0)'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 3C12.5523 3 13 3.44772 13 4V5.83C13 6.38228 12.5523 6.83 12 6.83C11.4477 6.83 11 6.38228 11 5.83V4C11 3.44772 11.4477 3 12 3Z",
        fill: props.isDisabled ? `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$exports).N200})` : 'url(#ai_icon_lg1)'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3 12C3 11.4477 3.44772 11 4 11H5.83C6.38228 11 6.83 11.4477 6.83 12C6.83 12.5523 6.38228 13 5.83 13H4C3.44772 13 3 12.5523 3 12Z",
        fill: props.isDisabled ? `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$exports).N200})` : 'url(#ai_icon_lg2)'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 17.17C12.5523 17.17 13 17.6177 13 18.17V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V18.17C11 17.6177 11.4477 17.17 12 17.17Z",
        fill: props.isDisabled ? `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$exports).N200})` : 'url(#ai_icon_lg3)'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.2929 14.2929C14.6835 13.9024 15.3166 13.9024 15.7071 14.2929L19.7071 18.2929C20.0977 18.6834 20.0977 19.3166 19.7071 19.7071C19.3166 20.0976 18.6835 20.0976 18.2929 19.7071L14.2929 15.7071C13.9024 15.3166 13.9024 14.6834 14.2929 14.2929Z",
        fill: iconAccentBlueB200
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19.7071 4.29289C20.0977 4.68342 20.0977 5.31658 19.7071 5.70711L15.7071 9.70711C15.3166 10.0976 14.6835 10.0976 14.2929 9.70711C13.9024 9.31658 13.9024 8.68342 14.2929 8.29289L18.2929 4.29289C18.6835 3.90237 19.3166 3.90237 19.7071 4.29289Z",
        fill: iconAccentBlueB200
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.29289 4.29289C4.68342 3.90237 5.31658 3.90237 5.70711 4.29289L9.70711 8.29289C10.0976 8.68342 10.0976 9.31658 9.70711 9.70711C9.31658 10.0976 8.68342 10.0976 8.29289 9.70711L4.29289 5.70711C3.90237 5.31658 3.90237 4.68342 4.29289 4.29289Z",
        fill: iconAccentBlueB200
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.70711 14.2929C10.0976 14.6834 10.0976 15.3166 9.70711 15.7071L5.70711 19.7071C5.31658 20.0976 4.68342 20.0976 4.29289 19.7071C3.90237 19.3166 3.90237 18.6834 4.29289 18.2929L8.29289 14.2929C8.68342 13.9024 9.31658 13.9024 9.70711 14.2929Z",
        fill: iconAccentBlueB200
    })));
};

});

parcelRegister("i8ZM8", function(module, exports) {

$parcel$export(module.exports, "default", () => $0eb2009d6335c336$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $0eb2009d6335c336$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    aiNote: {
        "id": "servicedesk-itsm-features.common.ai-footer.ai-note",
        "defaultMessage": "Powered by Atlassian Intelligence"
    },
    contentQualityStatement: {
        "id": "servicedesk-itsm-features.common.ai-footer.content-quality-statement",
        "defaultMessage": "Content is based on your permissions, and its quality may vary"
    },
    betaAccessLozenge: {
        "id": "servicedesk-itsm-features.common.ai-footer.beta-access-lozenge",
        "defaultMessage": "Beta"
    }
});

});



parcelRegister("fgSLb", function(module, exports) {

$parcel$export(module.exports, "FeatureToggle", () => $3764f2b8fd46796b$export$8e25d4633f989d7a);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $8nlzU = parcelRequire("8nlzU");
var $i6BC8 = parcelRequire("i6BC8");
var $6frYP = parcelRequire("6frYP");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");

var $e270j = parcelRequire("e270j");

var $1ybV0 = parcelRequire("1ybV0");
const $3764f2b8fd46796b$export$8e25d4633f989d7a = ({ feature: feature, onChange: onChange, value: value = false, saving: saving = false, disabled: disabled = false, focusToggle: focusToggle = false, popperText: popperText = null, labelId: labelId, isPopperOpenByDefault: isPopperOpenByDefault = false })=>{
    const [isPopperOpen, setIsPopperOpen] = (0, $eUqFw.useState)((0, $1ybV0.ff)('enable_jsm_repackaging_changes_vtwk9') ? isPopperOpenByDefault : false);
    const handleChange = (0, $eUqFw.useCallback)((event, analyticEvent)=>{
        // We're not disabling the toggle since we need to use the onchange event to show the popper
        if (disabled) {
            event.preventDefault();
            setIsPopperOpen(true);
        } else onChange(feature, event.currentTarget.checked, analyticEvent);
    }, [
        disabled,
        feature,
        onChange
    ]);
    const toggleRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (focusToggle) toggleRef?.current?.focus();
    }, [
        focusToggle,
        toggleRef
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if ((0, $1ybV0.ff)('enable_jsm_repackaging_changes_vtwk9') && isPopperOpenByDefault) setIsPopperOpen(isPopperOpenByDefault);
    }, [
        isPopperOpenByDefault
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3764f2b8fd46796b$var$Wrapper, null, saving && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3764f2b8fd46796b$var$FloatLeftWrapper, {
        role: "status",
        "aria-label": "Loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: "small"
    })), popperText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8nlzU.Manager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6frYP.Reference), null, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e270j.default), {
            id: labelId,
            // eslint-disable-next-line jira/integration/test-id-by-folder-structure
            testId: "servicedesk-itsm-features.common.ui.feature-toggle-tile.feature-toggle-v2.toggle-stateless",
            isChecked: value,
            isDisabled: disabled && !popperText,
            size: "large",
            ref: ref,
            onChange: handleChange,
            onBlur: ()=>setIsPopperOpen(false)
        })), isPopperOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i6BC8.Popper), {
        placement: "bottom-start"
    }, ({ ref: ref, style: style })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            // eslint-disable-next-line jira/integration/test-id-by-folder-structure
            testId: "servicedesk-itsm-features.common.ui.feature-toggle-tile.feature-toggle-v2.popper",
            ref: ref,
            // 'style' is required by the Popper component to render properly
            // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: style,
            xcss: (0, $1ybV0.ff)('enable_jsm_repackaging_changes_vtwk9') ? $3764f2b8fd46796b$var$popupStyles : $3764f2b8fd46796b$var$popupStylesOld,
            "aria-live": "polite"
        }, popperText))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e270j.default), {
        id: labelId,
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        testId: "servicedesk-itsm-features.common.ui.feature-toggle-tile.feature-toggle-v2.toggle-stateless",
        isChecked: value,
        isDisabled: disabled || saving,
        size: "large",
        ref: toggleRef,
        onChange: handleChange
    }));
};
const $3764f2b8fd46796b$var$popupStylesOld = (0, $1ZAYh.xcss)({
    padding: 'space.200',
    maxWidth: '220px',
    borderRadius: 'border.radius.100',
    backgroundColor: 'elevation.surface.overlay',
    boxShadow: 'elevation.shadow.overlay'
});
const $3764f2b8fd46796b$var$popupStyles = (0, $1ZAYh.xcss)({
    padding: 'space.200',
    maxWidth: '320px',
    borderRadius: 'border.radius.100',
    backgroundColor: 'elevation.surface.overlay',
    boxShadow: 'elevation.shadow.overlay'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3764f2b8fd46796b$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm",
            __cmplp.className
        ])
    });
});
const $3764f2b8fd46796b$var$FloatLeftWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _1e0c1txw _4cvr1h6o _154iidpf _94n5idpf _1ltvc7mi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("e270j", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d3122f1d9f9fa05$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $5Q9wj = parcelRequire("5Q9wj");

var $ki32l = parcelRequire("ki32l");

var $hnob3 = parcelRequire("hnob3");

var $fbOgz = parcelRequire("fbOgz");

var $2wLr6 = parcelRequire("2wLr6");

var $gnr5M = parcelRequire("gnr5M");
const $4d3122f1d9f9fa05$var$noop = (0, $5Q9wj.default);
const $4d3122f1d9f9fa05$var$analyticsAttributes = {
    componentName: 'toggle',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $4d3122f1d9f9fa05$var$iconSizeMap = {
    regular: 'small',
    large: 'medium'
};
/**
 * __Toggle__
 *
 * A toggle is used to view or switch between enabled or disabled states.
 *
 * - [Examples](https://atlassian.design/components/toggle/examples)
 * - [Code](https://atlassian.design/components/toggle/code)
 * - [Usage](https://atlassian.design/components/toggle/usage)
 */ const $4d3122f1d9f9fa05$var$Toggle = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { defaultChecked: defaultChecked = false, isDisabled: isDisabled = false, onBlur: providedOnBlur = $4d3122f1d9f9fa05$var$noop, onChange: providedChange = $4d3122f1d9f9fa05$var$noop, onFocus: providedFocus = $4d3122f1d9f9fa05$var$noop, size: size = 'regular', name: name = '', value: value = '', isChecked: isChecked, analyticsContext: analyticsContext, id: id, testId: testId, label: label, descriptionId: descriptionId } = props;
    const isControlled = typeof isChecked === 'undefined';
    const [checked, setChecked] = (0, $eUqFw.useState)(defaultChecked);
    const handleBlur = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: providedOnBlur,
        action: 'blur',
        analyticsData: analyticsContext,
        ...$4d3122f1d9f9fa05$var$analyticsAttributes
    });
    const handleFocus = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: providedFocus,
        action: 'focus',
        analyticsData: analyticsContext,
        ...$4d3122f1d9f9fa05$var$analyticsAttributes
    });
    const handleChange = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (isControlled) setChecked((checked)=>!checked);
            return providedChange(event, analyticsEvent);
        },
        action: 'change',
        analyticsData: analyticsContext,
        ...$4d3122f1d9f9fa05$var$analyticsAttributes
    });
    const shouldChecked = isControlled ? checked : isChecked;
    const controlProps = {
        'data-checked': shouldChecked ? shouldChecked : undefined,
        'data-disabled': isDisabled ? isDisabled : undefined,
        'data-size': size,
        'data-testid': testId ? testId : undefined
    };
    const toggleStyles = (0, $eUqFw.useMemo)(()=>(0, $gnr5M.getStyles)(size), [
        size
    ]);
    const legacyIconSize = $4d3122f1d9f9fa05$var$iconSizeMap[size];
    const labelId = (0, $ki32l.useId)();
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("label", {
        ...controlProps,
        css: toggleStyles
    }, label ? /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        id: labelId,
        hidden: true
    }, label) : null, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        ref: ref,
        checked: shouldChecked,
        disabled: isDisabled,
        id: id,
        name: name,
        onBlur: handleBlur,
        onChange: handleChange,
        onFocus: handleFocus,
        type: "checkbox",
        value: value,
        "data-testid": testId && `${testId}--input`,
        "aria-labelledby": label ? labelId : undefined,
        "aria-describedby": descriptionId
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $2wLr6.default), {
        size: size,
        isHidden: !shouldChecked,
        position: "left"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hnob3))), {
        label: "",
        color: "currentColor",
        LEGACY_size: legacyIconSize,
        testId: testId && `${testId}--toggle-check-icon`
    })), /*#__PURE__*/ (0, $byn9U.jsx)((0, $2wLr6.default), {
        size: size,
        isHidden: shouldChecked,
        position: "right"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fbOgz))), {
        label: "",
        color: "currentColor",
        LEGACY_size: legacyIconSize,
        testId: testId && `${testId}--toggle-cross-icon`
    }))));
}));
$4d3122f1d9f9fa05$var$Toggle.displayName = 'Toggle';
var $4d3122f1d9f9fa05$export$2e2bcd8739ae039 = $4d3122f1d9f9fa05$var$Toggle;

});
parcelRegister("hnob3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::116024720ac5bfd6b5d0b476c677b799>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ca6756bf734aa598$var$_react = $ca6756bf734aa598$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $ca6756bf734aa598$var$_checkMark = $ca6756bf734aa598$var$_interopRequireDefault((parcelRequire("7RK9I")));

var $ca6756bf734aa598$var$_done = $ca6756bf734aa598$var$_interopRequireDefault((parcelRequire("k9Z3M")));
function $ca6756bf734aa598$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "EditorDoneIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/utility/check-mark
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ca6756bf734aa598$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $ca6756bf734aa598$var$_react.default.createElement($ca6756bf734aa598$var$_checkMark.default, Object.assign({
        LEGACY_fallbackIcon: $ca6756bf734aa598$var$_done.default
    }, props));
$ca6756bf734aa598$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
var $ca6756bf734aa598$var$_default = module.exports.default = $ca6756bf734aa598$var$CheckMarkIcon;

});
parcelRegister("7RK9I", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d905e7dc6c2480f22f2a9081c36a5712>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5ba14938eb17fe40$var$_react = $5ba14938eb17fe40$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $5ba14938eb17fe40$var$_UNSAFE_baseNew = $5ba14938eb17fe40$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $5ba14938eb17fe40$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CheckMark".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/utility/check-mark
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5ba14938eb17fe40$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $5ba14938eb17fe40$var$_react.default.createElement($5ba14938eb17fe40$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 6 2.75 3.5 6.25-7"/>`,
        type: 'utility'
    }, props));
$5ba14938eb17fe40$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $5ba14938eb17fe40$var$_default = module.exports.default = $5ba14938eb17fe40$var$CheckMarkIcon;

});

parcelRegister("k9Z3M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ead4032469749d51$var$_react = $ead4032469749d51$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $ead4032469749d51$var$_checkMark = $ead4032469749d51$var$_interopRequireDefault((parcelRequire("j52dF")));
function $ead4032469749d51$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ead4032469749d51$var$EditorDoneIcon = (props)=>/*#__PURE__*/ $ead4032469749d51$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M7.356 10.942a.497.497 0 0 0-.713 0l-.7.701a.5.5 0 0 0-.003.71l3.706 3.707a.5.5 0 0 0 .705.003l7.712-7.712a.493.493 0 0 0-.006-.708l-.7-.7a.504.504 0 0 0-.714 0l-6.286 6.286a.506.506 0 0 1-.713 0z"/></svg>`
    }, props, {
        newIcon: $ead4032469749d51$var$_checkMark.default
    }));
$ead4032469749d51$var$EditorDoneIcon.displayName = 'EditorDoneIcon';
var $ead4032469749d51$var$_default = module.exports.default = $ead4032469749d51$var$EditorDoneIcon;

});
parcelRegister("j52dF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::209317c625743d387bf26edea0c296a9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $de4034a95f8a9e06$var$_react = $de4034a95f8a9e06$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $de4034a95f8a9e06$var$_UNSAFE_baseNew = $de4034a95f8a9e06$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $de4034a95f8a9e06$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $de4034a95f8a9e06$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $de4034a95f8a9e06$var$_react.default.createElement($de4034a95f8a9e06$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 8 4.25 5.25 8.75-10.5"/>`
    }, props));
$de4034a95f8a9e06$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $de4034a95f8a9e06$var$_default = module.exports.default = $de4034a95f8a9e06$var$CheckMarkIcon;

});



parcelRegister("fbOgz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::77b0cdbbee1b52bd7575a4eda010b0e1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b0eedfeb10f4bac1$var$_react = $b0eedfeb10f4bac1$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $b0eedfeb10f4bac1$var$_cross = $b0eedfeb10f4bac1$var$_interopRequireDefault((parcelRequire("adUQx")));

var $b0eedfeb10f4bac1$var$_close = $b0eedfeb10f4bac1$var$_interopRequireDefault((parcelRequire("je5kZ")));
function $b0eedfeb10f4bac1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CrossIcon.
 * This component is CrossIcon, with `UNSAFE_fallbackIcon` set to "EditorCloseIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: remove tag.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b0eedfeb10f4bac1$var$CrossIcon = (props)=>/*#__PURE__*/ $b0eedfeb10f4bac1$var$_react.default.createElement($b0eedfeb10f4bac1$var$_cross.default, Object.assign({
        LEGACY_fallbackIcon: $b0eedfeb10f4bac1$var$_close.default
    }, props));
$b0eedfeb10f4bac1$var$CrossIcon.Name = 'CrossIconMigration';
var $b0eedfeb10f4bac1$var$_default = module.exports.default = $b0eedfeb10f4bac1$var$CrossIcon;

});
parcelRegister("adUQx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8a2857e231b7db111b6bd9efbc440f24>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $771736c5909ba4b4$var$_react = $771736c5909ba4b4$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $771736c5909ba4b4$var$_UNSAFE_baseNew = $771736c5909ba4b4$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $771736c5909ba4b4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Cross".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: remove tag.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $771736c5909ba4b4$var$CrossIcon = (props)=>/*#__PURE__*/ $771736c5909ba4b4$var$_react.default.createElement($771736c5909ba4b4$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m2 10 4-4m4-4L6 6m0 0L2 2m4 4 4 4"/>`,
        type: 'utility'
    }, props));
$771736c5909ba4b4$var$CrossIcon.displayName = 'CrossIcon';
var $771736c5909ba4b4$var$_default = module.exports.default = $771736c5909ba4b4$var$CrossIcon;

});

parcelRegister("je5kZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dff3771012ed2785$var$_react = $dff3771012ed2785$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $dff3771012ed2785$var$_close = $dff3771012ed2785$var$_interopRequireDefault((parcelRequire("02Sz7")));
function $dff3771012ed2785$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $dff3771012ed2785$var$EditorCloseIcon = (props)=>/*#__PURE__*/ $dff3771012ed2785$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m15.185 7.4-3.184 3.185-3.186-3.186a.507.507 0 0 0-.712.003l-.7.701a.496.496 0 0 0-.004.712l3.185 3.184L7.4 15.185a.507.507 0 0 0 .004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 0 0 .712-.004l.701-.7a.496.496 0 0 0 .003-.712l-3.186-3.186 3.186-3.184a.507.507 0 0 0-.003-.712l-.7-.7a.5.5 0 0 0-.36-.153.5.5 0 0 0-.353.15"/></svg>`
    }, props, {
        newIcon: $dff3771012ed2785$var$_close.default
    }));
$dff3771012ed2785$var$EditorCloseIcon.displayName = 'EditorCloseIcon';
var $dff3771012ed2785$var$_default = module.exports.default = $dff3771012ed2785$var$EditorCloseIcon;

});


parcelRegister("2wLr6", function(module, exports) {

$parcel$export(module.exports, "default", () => $3035e6738b21544f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $XHGTv = parcelRequire("XHGTv");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
const $3035e6738b21544f$var$iconContainerStyles = (0, $1ZAYh.xcss)({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'opacity 0.2s ease',
    position: 'absolute',
    insetBlockStart: 'space.025'
});
const $3035e6738b21544f$var$iconContainerRegularStyles = (0, $1ZAYh.xcss)({
    width: '16px',
    height: '16px'
});
const $3035e6738b21544f$var$iconContainerLargeStyles = (0, $1ZAYh.xcss)({
    width: '20px',
    height: '20px'
});
const $3035e6738b21544f$var$hiddenStyles = (0, $1ZAYh.xcss)({
    opacity: 0
});
const $3035e6738b21544f$var$leftStyles = (0, $1ZAYh.xcss)({
    insetInlineStart: '3px'
});
const $3035e6738b21544f$var$rightStyles = (0, $1ZAYh.xcss)({
    insetInlineEnd: '3px'
});
/**
 * __Icon container__
 *
 * Positions a toggle's check and close icons.
 */ const $3035e6738b21544f$var$IconContainer = ({ children: children, size: size, isHidden: isHidden, position: position })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "span",
        xcss: [
            $3035e6738b21544f$var$iconContainerStyles,
            isHidden && (0, $XHGTv.fg)('platform-visual-refresh-icons') && $3035e6738b21544f$var$hiddenStyles,
            size === 'regular' && $3035e6738b21544f$var$iconContainerRegularStyles,
            size === 'large' && $3035e6738b21544f$var$iconContainerLargeStyles,
            position === 'left' && $3035e6738b21544f$var$leftStyles,
            position === 'right' && $3035e6738b21544f$var$rightStyles
        ]
    }, children);
};
var $3035e6738b21544f$export$2e2bcd8739ae039 = $3035e6738b21544f$var$IconContainer;

});

parcelRegister("gnr5M", function(module, exports) {

$parcel$export(module.exports, "getStyles", () => $f3c1d4ec47a37a63$export$ffd58b7f6f099a57);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $lcnyw = parcelRequire("lcnyw");

var $3Vu5P = parcelRequire("3Vu5P");
const $f3c1d4ec47a37a63$var$globalGridSize = (0, $lcnyw.gridSize)();
const $f3c1d4ec47a37a63$var$dimensions = {
    regular: {
        height: $f3c1d4ec47a37a63$var$globalGridSize * 2,
        width: $f3c1d4ec47a37a63$var$globalGridSize * 4
    },
    large: {
        height: $f3c1d4ec47a37a63$var$globalGridSize * 2 + $f3c1d4ec47a37a63$var$globalGridSize / 2,
        width: $f3c1d4ec47a37a63$var$globalGridSize * 5
    }
};
const $f3c1d4ec47a37a63$var$getHeight = ({ size: size })=>$f3c1d4ec47a37a63$var$dimensions[size].height;
const $f3c1d4ec47a37a63$var$getWidth = ({ size: size })=>$f3c1d4ec47a37a63$var$dimensions[size].width;
const $f3c1d4ec47a37a63$var$borderWidth = 2;
const $f3c1d4ec47a37a63$var$paddingUnitless = $f3c1d4ec47a37a63$var$globalGridSize / 4;
const $f3c1d4ec47a37a63$var$transition = 'transform 0.2s ease';
const $f3c1d4ec47a37a63$export$ffd58b7f6f099a57 = (size)=>{
    const colors = (0, $3Vu5P.getColors)();
    // TODO: Use tokens and reorganize to alphasemantic ordering (DSP-11769 DSP-11770)
    /* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview,@repo/internal/styles/consistent-style-ordering */ return /*#__PURE__*/ (0, $byn9U.css)({
        boxSizing: 'content-box',
        display: 'inline-block',
        padding: $f3c1d4ec47a37a63$var$borderWidth,
        margin: $f3c1d4ec47a37a63$var$borderWidth,
        backgroundClip: 'content-box',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: colors.backgroundColorUnchecked,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderRadius: `${$f3c1d4ec47a37a63$var$getHeight({
            size: size
        })}px`,
        border: `${$f3c1d4ec47a37a63$var$borderWidth}px solid transparent`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${$f3c1d4ec47a37a63$var$getHeight({
            size: size
        })}px`,
        position: 'relative',
        transition: `${$f3c1d4ec47a37a63$var$transition}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${$f3c1d4ec47a37a63$var$getWidth({
            size: size
        })}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-checked]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorChecked,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            color: colors.iconColorChecked
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&[data-disabled]:not([data-checked])': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorUncheckedDisabled
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-disabled][data-checked],&[data-disabled][data-checked]:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorCheckedDisabled
        },
        '&:focus-within': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            border: `${$f3c1d4ec47a37a63$var$borderWidth}px solid ${colors.borderColorFocus}`
        },
        '&:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorUncheckedHover,
            cursor: 'pointer'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&[data-disabled]:hover,&[data-disabled][data-checked]:hover,&[data-disabled]:not([data-checked]):hover': {
            cursor: 'not-allowed'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-checked]:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorCheckedHover
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:not([data-checked]):hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorUncheckedHover
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&[data-disabled]:not([data-checked]):hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorCheckedDisabled
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: colors.iconColorUnchecked,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-disabled], &[data-disabled][data-checked], &[data-disabled][data-checked]:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            color: colors.iconColorDisabled
        },
        // the input element underneath
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        'input[type="checkbox"]': {
            opacity: 0,
            margin: 0,
            padding: 0,
            border: 'none',
            '&:focus': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
                outline: 'none !important'
            }
        },
        // slider
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.handleBackgroundColor,
            borderRadius: "var(--ds-border-radius-circle, 50%)",
            content: '""',
            position: 'absolute',
            transform: 'initial',
            transition: $f3c1d4ec47a37a63$var$transition,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            insetBlockEnd: `${2 * $f3c1d4ec47a37a63$var$paddingUnitless}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: `${$f3c1d4ec47a37a63$var$getHeight({
                size: size
            }) - $f3c1d4ec47a37a63$var$paddingUnitless * 2}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            width: `${$f3c1d4ec47a37a63$var$getHeight({
                size: size
            }) - $f3c1d4ec47a37a63$var$paddingUnitless * 2}px`,
            // initially we set left as left-most position
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            insetInlineStart: `${2 * $f3c1d4ec47a37a63$var$paddingUnitless}px`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-checked]::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.handleBackgroundColorChecked,
            // when  it's checked, slide the pseudo-element to right-most postion
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            transform: `translateX(${$f3c1d4ec47a37a63$var$getHeight({
                size: size
            })}px)`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-disabled]::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.handleBackgroundColorDisabled,
            zIndex: 1
        },
        // Remove during new icon flag cleanup. This is required to maintain the size of legacy icons.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...size === 'large' && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
        !(0, $XHGTv.fg)('platform-visual-refresh-icons') && {
            '> span > span': {
                height: '20px',
                width: '20px'
            }
        },
        '@media screen and (forced-colors: active)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '::before': {
                filter: 'grayscale(100%) invert(1)'
            },
            '&:focus-within': {
                outline: '1px solid'
            }
        }
    });
};

});
parcelRegister("3Vu5P", function(module, exports) {

$parcel$export(module.exports, "getColors", () => $a04fcc2fd7c04036$export$6cee60e8aa85e528);

const $a04fcc2fd7c04036$var$colorMap = {
    backgroundColorChecked: `var(--ds-background-success-bold, ${(0, $73a5c9d720aa66e1$export$a49394138f7b8e85)})`,
    backgroundColorCheckedHover: `var(--ds-background-success-bold-hovered, ${(0, $73a5c9d720aa66e1$export$6fa04827ac68a4fb)})`,
    backgroundColorCheckedDisabled: `var(--ds-background-disabled, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`,
    backgroundColorUnchecked: `var(--ds-background-neutral-bold, ${(0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd)})`,
    backgroundColorUncheckedHover: `var(--ds-background-neutral-bold-hovered, ${(0, $73a5c9d720aa66e1$export$eece5f492e429f08)})`,
    backgroundColorUncheckedDisabled: `var(--ds-background-disabled, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`,
    borderColorFocus: `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`,
    iconColorChecked: `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    iconColorDisabled: `var(--ds-icon-disabled, ${(0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de)})`,
    iconColorUnchecked: `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    handleBackgroundColor: `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    handleBackgroundColorChecked: `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    handleBackgroundColorDisabled: `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`
};
const $a04fcc2fd7c04036$export$6cee60e8aa85e528 = ()=>$a04fcc2fd7c04036$var$colorMap;

});





parcelRegister("2EAfK", function(module, exports) {

$parcel$export(module.exports, "default", () => $c52a5b5b186fc38d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $guiFP = parcelRequire("guiFP");

var $jMP2a = parcelRequire("jMP2a");

var $ldqS7 = parcelRequire("ldqS7");
const $c52a5b5b186fc38d$var$useAdminHubAIEnabled = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [isAdminHubAiToggleEnabled, setisAdminHubAiToggleEnabled] = (0, $eUqFw.useState)(false);
    const fetchData = (0, $eUqFw.useCallback)(async ()=>{
        try {
            const response = await (0, $ldqS7.fetchAiEnablement)();
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchAiEnablementStatus succeeded');
            setisAdminHubAiToggleEnabled(response.isEnabled);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                error: error,
                meta: {
                    id: 'fetchAiEnablementStatus',
                    teamName: 'jsd-shield',
                    packageName: 'jiraServicedeskItsmFeatures'
                }
            });
        }
    }, [
        createAnalyticsEvent
    ]);
    (0, $eUqFw.useEffect)(()=>{
        fetchData();
    }, [
        fetchData
    ]);
    return isAdminHubAiToggleEnabled;
};
var $c52a5b5b186fc38d$export$2e2bcd8739ae039 = $c52a5b5b186fc38d$var$useAdminHubAIEnabled;

});
parcelRegister("ldqS7", function(module, exports) {

$parcel$export(module.exports, "fetchAiEnablement", () => $276f39d0d71f7589$export$ad4105850d0ce824);

var $e91YZ = parcelRequire("e91YZ");

var $2OdyW = parcelRequire("2OdyW");
const $276f39d0d71f7589$export$2171a423b572256a = (JIRA_SERVICEDESK)=>`/rest/latest/aiconfig/optin/${JIRA_SERVICEDESK}`;
const $276f39d0d71f7589$export$ad4105850d0ce824 = ()=>{
    const { JIRA_SERVICEDESK: JIRA_SERVICEDESK } = (0, $e91YZ.LICENSED_PRODUCTS);
    const url = $276f39d0d71f7589$export$2171a423b572256a(JIRA_SERVICEDESK);
    return (0, $2OdyW.default)(url, {
        method: 'GET'
    });
};

});


parcelRegister("fJdKO", function(module, exports) {

$parcel$export(module.exports, "default", () => $efef53285222a19d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $k8Qyf = parcelRequire("k8Qyf");

var $j2ZgI = parcelRequire("j2ZgI");
const $efef53285222a19d$var$useSaveFailedFlag = ()=>{
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    return (0, $eUqFw.useCallback)((featureName, value, errorMessages)=>{
        const errorTitle = errorMessages?.errorTitle || (0, $j2ZgI.default).saveErrorTitle;
        const errorDescription = errorMessages?.errorDescription || (0, $j2ZgI.default).saveErrorDescription;
        const feature = featureName.toLowerCase();
        showFlag({
            type: 'error',
            isAutoDismiss: true,
            title: [
                errorTitle,
                {
                    feature: feature,
                    value: value
                }
            ],
            description: errorDescription,
            actions: [
                {
                    content: (0, $j2ZgI.default).refreshAction,
                    onClick: ()=>{
                        window.location.reload();
                    }
                }
            ]
        });
    }, [
        showFlag
    ]);
};
var $efef53285222a19d$export$2e2bcd8739ae039 = $efef53285222a19d$var$useSaveFailedFlag;

});
parcelRegister("j2ZgI", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d4fd03cca8d3f95$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7d4fd03cca8d3f95$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    saveErrorTitle: {
        "id": "servicedesk-itsm-features.controllers.common.save-failed-flag.save-error-title",
        "defaultMessage": "We couldn't turn {value, select, false {off} other {on}} {feature}"
    },
    saveErrorDescription: {
        "id": "servicedesk-itsm-features.controllers.common.save-failed-flag.save-error-description",
        "defaultMessage": "Refresh or try again."
    },
    refreshAction: {
        "id": "servicedesk-itsm-features.controllers.common.save-failed-flag.refresh-action",
        "defaultMessage": "Refresh"
    }
});

});


parcelRegister("iPgVt", function(module, exports) {

$parcel$export(module.exports, "default", () => $931a873fc5ac1d35$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
parcelRequire("kQbL4");

var $dxIU5 = parcelRequire("dxIU5");

var $hIoOm = parcelRequire("hIoOm");

var $2futN = parcelRequire("2futN");

var $bFzGY = parcelRequire("bFzGY");

var $aSEj7 = parcelRequire("aSEj7");

var $lB25E = parcelRequire("lB25E");

var $32e1r = parcelRequire("32e1r");

var $hVNI2 = parcelRequire("hVNI2");
const $931a873fc5ac1d35$var$useServiceProjectFeaturesController = ()=>{
    const { data: data, update: updateFeatureResource, refresh: refreshFeatureResource } = (0, $aSEj7.default)();
    const { refresh: refreshServiceManagementNavigation } = (0, $2futN.useJiraServiceManagementProjectNavigation)();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const [saving, setSavingState] = (0, $eUqFw.useState)({});
    const [projectKey = ''] = (0, $lB25E.usePathParam)('projectKey');
    const subscriptionsRef = (0, $eUqFw.useRef)((0, $eUqFw.useMemo)(()=>new (0, $hIoOm.Subscription)(), []));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const refreshResources = (0, $eUqFw.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(()=>{
            refreshFeatureResource();
            refreshServiceManagementNavigation();
        }, 1000, {
            trailing: true
        }), [
        refreshFeatureResource,
        refreshServiceManagementNavigation
    ]);
    const update = (0, $eUqFw.useCallback)(({ feature: feature, enabled: enabled, onSuccess: onSuccess, onFail: onFail })=>{
        if (projectKey) {
            setSavingState((prevState)=>({
                    ...prevState,
                    [feature]: true
                }));
            subscriptionsRef.current.add((0, $32e1r.default)(projectKey, feature, enabled).finally(()=>{
                setSavingState((prevState)=>({
                        ...prevState,
                        [feature]: false
                    }));
            }).subscribe(({ status: status, editable: editable })=>{
                refreshResources();
                updateFeatureResource((prevData)=>({
                        ...prevData,
                        [feature]: {
                            status: status,
                            editable: editable
                        }
                    }));
                (0, $hVNI2.fireSuccessAnalytics)(createAnalyticsEvent({}), feature, enabled);
                onSuccess?.();
            }, (error)=>{
                (0, $hVNI2.fireFailureAnalytics)(createAnalyticsEvent({}), error, feature, enabled);
                onFail?.(error);
            }));
        }
    }, [
        createAnalyticsEvent,
        projectKey,
        refreshResources,
        updateFeatureResource
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            subscriptionsRef.current.unsubscribe();
        }, []);
    return {
        data: data,
        saving: saving,
        update: update
    };
};
var $931a873fc5ac1d35$export$2e2bcd8739ae039 = $931a873fc5ac1d35$var$useServiceProjectFeaturesController;

});
parcelRegister("32e1r", function(module, exports) {

$parcel$export(module.exports, "default", () => $27ff4cedb30ceb9b$export$2e2bcd8739ae039);

var $3JafE = parcelRequire("3JafE");
parcelRequire("cpH8E");

var $fV97Z = parcelRequire("fV97Z");
const $27ff4cedb30ceb9b$var$updateFeatureService = (projectKey, feature, enable)=>(0, $3JafE.Observable).fromPromise((0, $fV97Z.performPostRequest)(`/rest/servicedesk/1/servicedesk/${projectKey}/features/${enable ? 'enable' : 'disable'}`, {
        body: JSON.stringify({
            feature: feature
        })
    }));
var $27ff4cedb30ceb9b$export$2e2bcd8739ae039 = $27ff4cedb30ceb9b$var$updateFeatureService;

});

parcelRegister("hVNI2", function(module, exports) {

$parcel$export(module.exports, "fireSuccessAnalytics", () => $086950cf30a20433$export$e5b4271d9c5c1be6);
$parcel$export(module.exports, "fireFailureAnalytics", () => $086950cf30a20433$export$b1994666a7494095);

var $guiFP = parcelRequire("guiFP");

var $jMP2a = parcelRequire("jMP2a");

var $frZnw = parcelRequire("frZnw");
const $086950cf30a20433$export$e5b4271d9c5c1be6 = (analyticEvent, feature, value)=>{
    (0, $jMP2a.fireTrackAnalytics)(analyticEvent, 'featureSetting updated', {
        feature: feature,
        value: value
    });
};
const $086950cf30a20433$export$b1994666a7494095 = (analyticEvent, error, feature, value)=>{
    (0, $guiFP.default)({
        meta: {
            id: 'updateFeaturesSetting',
            packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).ITSM_FEATURES_SETTINGS),
            teamName: 'jsd-shield'
        },
        error: error,
        event: analyticEvent,
        attributes: {
            feature: feature,
            value: value
        },
        sendToPrivacyUnsafeSplunk: true
    });
};

});


parcelRegister("h5WbH", function(module, exports) {

$parcel$export(module.exports, "default", () => $2da4f5d2132b9713$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $2da4f5d2132b9713$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    labsSectionTitle: {
        "id": "servicedesk-itsm-features.app.sections.labs-section.labs-section-title",
        "defaultMessage": "Feature lab"
    },
    labsSectionDescription: {
        "id": "servicedesk-itsm-features.app.sections.labs-section.labs-section-description",
        "defaultMessage": "The feature lab lets us test new ideas and get real-world feedback to improve them. They're works in progress, so they can change or break, and may not end up released at all. {learnMoreLink}."
    },
    labsDocsLink: {
        "id": "servicedesk-itsm-features.app.sections.labs-section.labs-docs-link",
        "defaultMessage": "Learn more about the feature lab"
    },
    similarRequestsPanelTitle: {
        "id": "servicedesk-itsm-features.app.sections.labs-section.similar-requests-panel-title",
        "defaultMessage": "Similar requests panel"
    },
    similarRequestsPanelDescription: {
        "id": "servicedesk-itsm-features.app.sections.labs-section.similar-requests-panel-description",
        "defaultMessage": "Your team can view other issues in the project that are related to the one they're viewing. This works for all issues types on Jira Service Management (service requests, incidents, problems, changes, and post-incident reviews). {learnMoreLink}."
    },
    similarRequestsLink: {
        "id": "servicedesk-itsm-features.app.sections.labs-section.similar-requests-link",
        "defaultMessage": "Learn more about the similar requests panel"
    },
    issueViewTitle: {
        "id": "servicedesk-itsm-features.app.sections.labs-section.issue-view-title",
        "defaultMessage": "Issue view"
    },
    itsmTitle: {
        "id": "servicedesk-itsm-features.app.sections.labs-section.itsm-title",
        "defaultMessage": "ITSM categories"
    },
    defaultRequestTypesTitle: {
        "id": "servicedesk-itsm-features.app.sections.labs-section.default-request-types-title",
        "defaultMessage": "Default request types"
    },
    defaultRequestTypesDescription: {
        "id": "servicedesk-itsm-features.app.sections.labs-section.default-request-types-description",
        "defaultMessage": "When you change the issue type of an issue, we'll automatically update the issue's request type. Choose a default request type for each of your issues types by editing the default request type settings. {learnMoreLink}."
    },
    defaultRequestTypesLink: {
        "id": "servicedesk-itsm-features.app.sections.labs-section.default-request-types-link",
        "defaultMessage": "Learn more about default request types"
    },
    defaultRequestTypeSettingsButtonText: {
        "id": "servicedesk-itsm-features.app.sections.labs-section.default-request-type-settings-button-text",
        "defaultMessage": "Default request type settings"
    },
    jsmBoardGroupTitle: {
        "id": "servicedesk-itsm-features.app.sections.labs-section.jsm-board-group-title",
        "defaultMessage": "Boards"
    },
    jsmBoardTitle: {
        "id": "servicedesk-itsm-features.app.sections.labs-section.jsm-board-title",
        "defaultMessage": "Board"
    },
    jsmBoardDescription: {
        "id": "servicedesk-itsm-features.app.sections.labs-section.jsm-board-description",
        "defaultMessage": "Visualize your work with a board to track the progress of all issues in your project. Add, rename, or remove columns in your board to match your team's preferred way of working. {learnMoreLink}."
    },
    jsmBoardLink: {
        "id": "servicedesk-itsm-features.app.sections.labs-section.jsm-board-link",
        "defaultMessage": "Learn more about setting up a board"
    },
    newLozenge: {
        "id": "servicedesk-itsm-features.app.sections.labs-section.new-lozenge",
        "defaultMessage": "New"
    },
    sentimentFieldTitle: {
        "id": "servicedesk-itsm-features.app.sections.labs-section.sentiment-field-title",
        "defaultMessage": "Customer sentiment analysis"
    },
    sentimenFieldDescription: {
        "id": "servicedesk-itsm-features.app.sections.labs-section.sentimen-field-description",
        "defaultMessage": "Show customer sentiment on issues to quickly understand how customers are feeling. Customer sentiment is determined by content in the issue and the activity feed. {learnMoreLink}."
    },
    sentimentLink: {
        "id": "servicedesk-itsm-features.app.sections.labs-section.sentiment-link",
        "defaultMessage": "Read more about sentiment analysis"
    },
    sentimentFeaturePrerequisiteTooltip: {
        "id": "servicedesk-itsm-features.app.sections.labs-section.sentiment-feature-prerequisite-tooltip",
        "defaultMessage": "To use this feature, your Jira admin needs to <link> enable Atlassian Intelligence.</link>"
    }
});

});


parcelRegister("kO1Zr", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad51cad2dac21007$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $hI5oG = parcelRequire("hI5oG");

var $dfBCt = parcelRequire("dfBCt");

var $bKxX9 = parcelRequire("bKxX9");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $bNe1g = parcelRequire("bNe1g");

var $dj40u = parcelRequire("dj40u");

var $eMtcB = parcelRequire("eMtcB");

var $j0iPr = parcelRequire("j0iPr");

var $kAjbD = parcelRequire("kAjbD");

var $ddk2C = parcelRequire("ddk2C");

var $98E1h = parcelRequire("98E1h");

var $gtdmv = parcelRequire("gtdmv");

var $9J8UW = parcelRequire("9J8UW");

var $jArhm = parcelRequire("jArhm");
const $ad51cad2dac21007$var$renderGroupTitle = (message)=>{
    const headingLevel = (0, $eI5EY.fg)('jsmca11y-564-update-section-headings') ? 'h2' : 'h4';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "xsmall",
        as: headingLevel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ad51cad2dac21007$export$161318b2ba42cf2b, null, message));
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ad51cad2dac21007$var$ServiceProjectSection = /*#__PURE__*/ (0, $eUqFw.memo)(()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { data: projectContextData } = (0, $bNe1g.useProjectContext)();
    const isSimplifiedProject = Boolean(projectContextData?.simplified);
    const { hasViews: hasViews, hasChannels: hasChannels, hasEssentials: hasEssentials, hasPractices: hasPractices, hasCustomerService: hasCustomerService, hasOperations: hasOperations } = (0, $eMtcB.useFeatureVisibility)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dj40u.FeatureSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, (0, $bKxX9.ff)('jsm-feature-labs-views-extraction_3odmp') && (!(0, $eI5EY.fg)('jcs_master_flag') || hasViews) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, $ad51cad2dac21007$var$renderGroupTitle(formatMessage((0, $gtdmv.default).viewsTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jArhm.default), null)), (0, $eI5EY.fg)('jsm_simplified_project_settings_navigation') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, (!(0, $eI5EY.fg)('jcs_master_flag') || hasChannels) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, $ad51cad2dac21007$var$renderGroupTitle(formatMessage((0, $gtdmv.default).channelsTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $98E1h.default), null)), (!(0, $eI5EY.fg)('jcs_master_flag') || hasEssentials) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, $ad51cad2dac21007$var$renderGroupTitle(formatMessage((0, $gtdmv.default).essentialsTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j0iPr.default), null))), !isSimplifiedProject && (!(0, $eI5EY.fg)('jcs_master_flag') || hasPractices) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, $ad51cad2dac21007$var$renderGroupTitle(formatMessage((0, $gtdmv.default).workTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9J8UW.default), null)), !isSimplifiedProject && !(0, $dfBCt.isFedRamp)() && (!(0, $eI5EY.fg)('jcs_master_flag') || hasCustomerService) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, $ad51cad2dac21007$var$renderGroupTitle(formatMessage((0, $gtdmv.default).customerServiceTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kAjbD.default), null)), (!(0, $eI5EY.fg)('jcs_master_flag') || hasOperations) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, $ad51cad2dac21007$var$renderGroupTitle(formatMessage((0, $gtdmv.default).operationsTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ddk2C.default), null))));
});
var $ad51cad2dac21007$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
 = $ad51cad2dac21007$var$ServiceProjectSection;
const $ad51cad2dac21007$export$161318b2ba42cf2b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _syaz1ifp _otyrx0bf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("j0iPr", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c179b02932a7106$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $eo17r = parcelRequire("eo17r");
var $k8Qyf = parcelRequire("k8Qyf");

var $3QLcd = parcelRequire("3QLcd");

var $7aDRP = parcelRequire("7aDRP");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");


var $lB25E = parcelRequire("lB25E");

var $co8Ny = parcelRequire("co8Ny");

var $fJdKO = parcelRequire("fJdKO");

var $iPgVt = parcelRequire("iPgVt");

var $f78Ls = parcelRequire("f78Ls");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3c179b02932a7106$var$ChannelsFeatures = /*#__PURE__*/ (0, $eUqFw.memo)(()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { data: data, saving: saving, update: update } = (0, $iPgVt.default)();
    const showSaveErrorFlag = (0, $fJdKO.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagsService)();
    const { push: push } = (0, $lB25E.useRouterActions)();
    const [projectKey = ''] = (0, $lB25E.usePathParam)('projectKey');
    const flagIdRef = (0, $eUqFw.useRef)({});
    const createOnChangeHandler = (0, $eUqFw.useCallback)((featureTitle)=>(feature, enabled, analyticEvent)=>{
            (0, $jMP2a.fireUIAnalytics)(analyticEvent, 'settingsToggle', {
                field: feature
            });
            update({
                feature: feature,
                enabled: enabled,
                onSuccess: ()=>{
                    const flagIdKey = `${feature}-service-feature-success`;
                    const { current: flagIds } = flagIdRef;
                    // toFlagId creates a new string reference. But we want to reuse
                    // flag ids so the most relevant flag for a feature is shown
                    flagIds[flagIdKey] = flagIds[flagIdKey] || (0, $eo17r.toFlagId)(flagIdKey);
                    const id = flagIds[flagIdKey];
                    // Dismiss previous flag with the same id. So user cannot
                    // interact with out of update flags
                    dismissFlag(id);
                    showFlag({
                        id: id,
                        type: 'success',
                        isAutoDismiss: !enabled,
                        title: [
                            (0, $f78Ls.default).csatSuccessTitle,
                            {
                                value: enabled
                            }
                        ],
                        description: enabled ? (0, $f78Ls.default).successEnableDescription : (0, $f78Ls.default).successDisableDescription,
                        actions: enabled ? [
                            {
                                content: (0, $f78Ls.default).successEnableAction,
                                onClick: ()=>{
                                    dismissFlag(id);
                                    push(`/jira/servicedesk/projects/${projectKey}/settings/feedback-settings`);
                                }
                            }
                        ] : []
                    });
                },
                onFail: ()=>{
                    showSaveErrorFlag(featureTitle, enabled);
                }
            });
        }, [
        projectKey,
        dismissFlag,
        push,
        showFlag,
        showSaveErrorFlag,
        update
    ]);
    const inProductHelpArticleId = '3UP0988YCozC1pC59eZlo';
    const fallbackArticleUrl = 'https://support.atlassian.com/jira-service-management-cloud/docs/what-are-customer-satisfaction-surveys-csats/';
    const inProductHelpLink = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3QLcd.default), {
        appearance: "link",
        spacing: "none",
        articleId: inProductHelpArticleId,
        fallbackComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
            target: "_blank",
            href: fallbackArticleUrl
        }, formatMessage((0, $f78Ls.default).learnMoreAboutCsat)),
        onClick: ()=>(0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'helpLink clicked', 'learnMoreAboutCsat', {
                inProductHelpArticleId: inProductHelpArticleId
            })
    }, formatMessage((0, $f78Ls.default).learnMoreAboutCsat));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $co8Ny.FeatureToggleTile), {
        feature: (0, $89d8bb437c2044ff$export$ff4743f07602eea7),
        title: formatMessage((0, $f78Ls.default).csatTitle),
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7aDRP.default), {
            alt: ""
        }),
        value: data?.[0, $89d8bb437c2044ff$export$ff4743f07602eea7]?.status === (0, $89d8bb437c2044ff$export$e927a5d1b72f0b68),
        saving: saving[0, $89d8bb437c2044ff$export$ff4743f07602eea7],
        onChange: createOnChangeHandler(formatMessage((0, $f78Ls.default).csatTitle))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $f78Ls.default).csatDescriptionForInProductHelp,
        values: {
            learnMoreLink: inProductHelpLink,
            br: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null))
        }
    }));
});
var $3c179b02932a7106$export$2e2bcd8739ae039 = $3c179b02932a7106$var$ChannelsFeatures;

});
parcelRegister("7aDRP", function(module, exports) {

$parcel$export(module.exports, "default", () => $82530e0c025d7ee1$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = 4qk62xwz9s9g3zgngr5gqp5
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/4qk62xwz9s9g3zgngr5gqp5

var $9TZf5 = parcelRequire("9TZf5");

var $dY4V4 = parcelRequire("dY4V4");
const $82530e0c025d7ee1$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($dY4V4)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($dY4V4))
});
var $82530e0c025d7ee1$export$2e2bcd8739ae039 = $82530e0c025d7ee1$var$Illustration;
// for advanced use only
const $82530e0c025d7ee1$export$a179c88182cb9d56 = [
    0,
    0,
    165,
    228
];

});
parcelRegister("dY4V4", function(module, exports) {
module.exports = new URL("ribbon.a5d8a248.svg", import.meta.url).toString();

});


parcelRegister("f78Ls", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a87a816267b19c8$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6a87a816267b19c8$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    csatTitle: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.csat-features.csat-title",
        "defaultMessage": "Customer satisfaction"
    },
    csatDescription: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.csat-features.csat-description",
        "defaultMessage": "\n            <p>\n                Measure customer satisfaction through an automated email survey sent after you resolve a request.\n                <a target=\"_blank\" href=\"{href}\">Learn more about customer satisfaction</a>.\n            </p>"
    },
    csatDescriptionForInProductHelp: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.csat-features.csat-description-for-in-product-help",
        "defaultMessage": "Measure customer satisfaction through an automated email survey sent after you resolve a request. {learnMoreLink}"
    },
    learnMoreAboutCsat: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.csat-features.learn-more-about-csat",
        "defaultMessage": "Learn more about customer satisfaction surveys"
    },
    csatSuccessTitle: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.csat-features.csat-success-title",
        "defaultMessage": "Customer satisfaction turned {value, select,\n            false {off}\n            true {on}\n            other {}\n        }"
    },
    successEnableDescription: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.csat-features.success-enable-description",
        "defaultMessage": "Edit your survey on the customer satisfaction page."
    },
    successDisableDescription: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.csat-features.success-disable-description",
        "defaultMessage": "You can turn this on again at any time. "
    },
    successEnableAction: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.csat-features.success-enable-action",
        "defaultMessage": "Edit survey"
    },
    successDisableDismiss: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.csat-features.success-disable-dismiss",
        "defaultMessage": "Ok"
    }
});

});


parcelRegister("kAjbD", function(module, exports) {

$parcel$export(module.exports, "default", () => $964d03522f1b73f9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1Yimi = parcelRequire("1Yimi");

var $eo17r = parcelRequire("eo17r");
var $k8Qyf = parcelRequire("k8Qyf");

var $3QLcd = parcelRequire("3QLcd");

var $2rsB9 = parcelRequire("2rsB9");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $2futN = parcelRequire("2futN");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $6bQqb = parcelRequire("6bQqb");


var $khSOi = parcelRequire("khSOi");

var $6SQlZ = parcelRequire("6SQlZ");

var $f1lMr = parcelRequire("f1lMr");

var $c7H0g = parcelRequire("c7H0g");

var $lB25E = parcelRequire("lB25E");

var $co8Ny = parcelRequire("co8Ny");

var $eCuTQ = parcelRequire("eCuTQ");

var $fJdKO = parcelRequire("fJdKO");

var $iPgVt = parcelRequire("iPgVt");

var $hObqq = parcelRequire("hObqq");

var $iV7rt = parcelRequire("iV7rt");

var $gE7IZ = parcelRequire("gE7IZ");

var $1ao52 = parcelRequire("1ao52");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $964d03522f1b73f9$var$CsmFeatures = /*#__PURE__*/ (0, $eUqFw.memo)(()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { data: data, saving: saving, update: update } = (0, $iPgVt.default)();
    const showSaveErrorFlag = (0, $fJdKO.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagsService)();
    const { push: push } = (0, $lB25E.useRouterActions)();
    const isJCS = (0, $khSOi.useIsJCS)();
    const { refresh: refreshPractices } = (0, $lB25E.useResource)((0, $6bQqb.servicedeskPracticesResource));
    const { refresh: refreshJSMNavigation } = (0, $2futN.useJiraServiceManagementProjectNavigation)();
    const { flush: flushCachedEscalationsRequestType } = (0, $6SQlZ.useCachedEscalationsRequestTypeActions)();
    const [projectKey = ''] = (0, $lB25E.usePathParam)('projectKey');
    const flagIdRef = (0, $eUqFw.useRef)({});
    const { data: { numAffectedRequestTypes: numDeveloperEscalationsAffectedRequestTypes }, error: developerEscalationsAffectedRequestTypesError, fetch: fetchDeveloperEscalationsRequestTypes } = (0, $eCuTQ.default)((0, $89d8bb437c2044ff$export$7c5ee80fcb40e9d3));
    const [isDisablingDeveloperEscalations, setDisablingDeveloperEscalations] = (0, $eUqFw.useState)(false);
    const [isDisableDeveloperEscalationsModalOpen, setIsDisableDeveloperEscalationsModalOpen] = (0, $eUqFw.useState)(false);
    const isJiraAdmin = (0, $c7H0g.useIsAdmin)();
    const csmDeveloperEscalationsInProductHelpArticleId = '3qm63PXTQWey7cMEvrEtyk';
    const csmDeveloperEscalationsFallbackArticleUrl = 'https://support.atlassian.com/jira-service-management-cloud/docs/manage-your-developer-escalations/';
    const csmDeveloperEscalationsInProductHelpLink = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3QLcd.default), {
        appearance: "link",
        spacing: "none",
        articleId: csmDeveloperEscalationsInProductHelpArticleId,
        fallbackComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
            target: "_blank",
            href: csmDeveloperEscalationsFallbackArticleUrl
        }, formatMessage((0, $gE7IZ.default).csmDeveloperEscalationsLearnMore)),
        onClick: ()=>(0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'helpLink clicked', 'learnMoreAboutCsmDeveloperEscalations', {
                csmDeveloperEscalationsInProductHelpArticleId: csmDeveloperEscalationsInProductHelpArticleId
            })
    }, formatMessage((0, $gE7IZ.default).csmDeveloperEscalationsLearnMore));
    const updateCsmDeveloperEscalations = (0, $eUqFw.useCallback)((enabled)=>{
        update({
            feature: (0, $89d8bb437c2044ff$export$7c5ee80fcb40e9d3),
            enabled: enabled,
            onSuccess: ()=>{
                const flagIdKey = `${(0, $89d8bb437c2044ff$export$7c5ee80fcb40e9d3)}-service-feature-success`;
                const { current: flagIds } = flagIdRef;
                // toFlagId creates a new string reference. But we want to reuse
                // flag ids so the most relevant flag for a feature is shown
                flagIds[flagIdKey] = flagIds[flagIdKey] || (0, $eo17r.toFlagId)(flagIdKey);
                const id = flagIds[flagIdKey];
                const onClick = ()=>{
                    dismissFlag(id);
                };
                // Dismiss previous flag with the same id. So user cannot
                // interact with out of update flags
                dismissFlag(id);
                refreshPractices();
                refreshJSMNavigation();
                flushCachedEscalationsRequestType();
                showFlag({
                    id: id,
                    type: 'success',
                    isAutoDismiss: !enabled,
                    title: [
                        (0, $gE7IZ.default).csmDeveloperEscalationsContactSuccessTitle,
                        {
                            value: enabled
                        }
                    ],
                    description: [
                        enabled ? (0, $gE7IZ.default).csmDeveloperEscalationsSuccessEnableDescription : (0, $gE7IZ.default).csmDeveloperEscalationSuccessDisableDescription,
                        {
                            strong: (children)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
                                    weight: "bold"
                                }, children)
                        }
                    ],
                    actions: enabled ? [
                        {
                            content: (0, $gE7IZ.default).csmDeveloperEscalationsSuccessEnableDismiss,
                            onClick: onClick
                        },
                        {
                            content: (0, $gE7IZ.default).csmDeveloperEscalationsSuccessEnableAction,
                            onClick: ()=>{
                                dismissFlag(id);
                                push(`/jira/servicedesk/projects/${projectKey}/settings/request-types/category/${(0, $f1lMr.SHORT_FORM_DEVELOPER_ESCALATION)}`);
                            }
                        }
                    ] : [
                        {
                            content: (0, $gE7IZ.default).csmDeveloperEscalationsSuccessDisableDismiss,
                            onClick: onClick
                        }
                    ]
                });
            },
            onFail: ()=>{
                showSaveErrorFlag(formatMessage((0, $gE7IZ.default).csmDeveloperEscalationsTitle), enabled);
            }
        });
    }, [
        dismissFlag,
        projectKey,
        push,
        refreshJSMNavigation,
        refreshPractices,
        showFlag,
        showSaveErrorFlag,
        update,
        formatMessage,
        flushCachedEscalationsRequestType
    ]);
    // This hook is used to ensure that fetchDeveloperEscalationsRequestTypes() called in disable()
    // fetches all requisite data before determining whether to show the warning modal.
    (0, $eUqFw.useEffect)(()=>{
        if (numDeveloperEscalationsAffectedRequestTypes !== undefined && numDeveloperEscalationsAffectedRequestTypes > 0 || developerEscalationsAffectedRequestTypesError) setIsDisableDeveloperEscalationsModalOpen(true);
        else if (numDeveloperEscalationsAffectedRequestTypes === 0) {
            updateCsmDeveloperEscalations(false);
            setDisablingDeveloperEscalations(false);
        }
    }, [
        developerEscalationsAffectedRequestTypesError,
        numDeveloperEscalationsAffectedRequestTypes,
        updateCsmDeveloperEscalations
    ]);
    const disable = (0, $eUqFw.useCallback)(()=>{
        setDisablingDeveloperEscalations(true);
        fetchDeveloperEscalationsRequestTypes();
    }, [
        setDisablingDeveloperEscalations,
        fetchDeveloperEscalationsRequestTypes
    ]);
    const createCsmDeveloperEscalationsOnChangeHandler = (0, $eUqFw.useCallback)(()=>(feature, enabled, analyticEvent)=>{
            (0, $jMP2a.fireUIAnalytics)(analyticEvent, 'settingsToggle', {
                field: feature
            });
            if (enabled) updateCsmDeveloperEscalations(enabled);
            else disable();
        }, [
        disable,
        updateCsmDeveloperEscalations
    ]);
    const onConfirmDisable = (0, $eUqFw.useCallback)(()=>{
        updateCsmDeveloperEscalations(false);
        setIsDisableDeveloperEscalationsModalOpen(false);
        setDisablingDeveloperEscalations(false);
    }, [
        updateCsmDeveloperEscalations
    ]);
    const closeDisableModal = (0, $eUqFw.useCallback)(()=>{
        setIsDisableDeveloperEscalationsModalOpen(false);
        setDisablingDeveloperEscalations(false);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, data?.[0, $89d8bb437c2044ff$export$6860c7a26d6d6d35] != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iV7rt.default), {
        isJiraAdmin: isJiraAdmin,
        isProductsAndEntitlementsEnabled: data?.[0, $89d8bb437c2044ff$export$28fc94ee6c61f632]?.status === (0, $89d8bb437c2044ff$export$e927a5d1b72f0b68)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1ao52.default), {
        isJiraAdmin: isJiraAdmin,
        isCustomerContextEnabled: data?.[0, $89d8bb437c2044ff$export$6860c7a26d6d6d35]?.status === (0, $89d8bb437c2044ff$export$e927a5d1b72f0b68)
    }), !isJCS && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $co8Ny.FeatureToggleTile), {
        feature: (0, $89d8bb437c2044ff$export$7c5ee80fcb40e9d3),
        title: formatMessage((0, $gE7IZ.default).csmDeveloperEscalationsTitle),
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2rsB9.default), {
            alt: ""
        }),
        value: data?.[0, $89d8bb437c2044ff$export$7c5ee80fcb40e9d3]?.status === (0, $89d8bb437c2044ff$export$e927a5d1b72f0b68),
        saving: saving[0, $89d8bb437c2044ff$export$7c5ee80fcb40e9d3] || isDisablingDeveloperEscalations,
        onChange: createCsmDeveloperEscalationsOnChangeHandler(),
        disabled: !isJiraAdmin,
        tooltip: isJiraAdmin ? null : formatMessage((0, $gE7IZ.default).csmCustomerContextContactAdmin)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $gE7IZ.default).csmDeveloperEscalationsDescription,
        values: {
            learnMoreLink: csmDeveloperEscalationsInProductHelpLink
        }
    })), isDisableDeveloperEscalationsModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hObqq.AsyncConfirmDisableModal), {
        feature: (0, $89d8bb437c2044ff$export$7c5ee80fcb40e9d3),
        onClose: closeDisableModal,
        onConfirm: onConfirmDisable,
        numAffectedRequestTypes: numDeveloperEscalationsAffectedRequestTypes,
        affectedRequestTypesError: developerEscalationsAffectedRequestTypesError
    }));
});
var $964d03522f1b73f9$export$2e2bcd8739ae039 = $964d03522f1b73f9$var$CsmFeatures;

});
parcelRegister("2rsB9", function(module, exports) {

$parcel$export(module.exports, "default", () => $346b6e023709d8f3$export$2e2bcd8739ae039);

var $9TZf5 = parcelRequire("9TZf5");

var $T0zde = parcelRequire("T0zde");
const $346b6e023709d8f3$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($T0zde)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($T0zde))
});
var $346b6e023709d8f3$export$2e2bcd8739ae039 = $346b6e023709d8f3$var$Illustration;
const $346b6e023709d8f3$export$a179c88182cb9d56 = [
    0,
    0,
    249,
    212
];

});
parcelRegister("T0zde", function(module, exports) {
module.exports = new URL("inspect-code.20cbac7f.svg", import.meta.url).toString();

});


parcelRegister("6SQlZ", function(module, exports) {

$parcel$export(module.exports, "useCachedEscalationsRequestType", () => $c7cb5d88000c2e61$export$f963a7e097ba92b8);
$parcel$export(module.exports, "useCachedEscalationsRequestTypeActions", () => $c7cb5d88000c2e61$export$1e9a1e5c798dc8f5);
$parcel$export(module.exports, "useFlushCachedEscalationsRequestType", () => $c7cb5d88000c2e61$export$fe860dc0eb43e1d5);

var $eUqFw = parcelRequire("eUqFw");

var $f1lMr = parcelRequire("f1lMr");

var $WBLbN = parcelRequire("WBLbN");
const $c7cb5d88000c2e61$var$initialState = {
    cache: {}
};
const $c7cb5d88000c2e61$export$e324594224ef24da = {
    has: (projectKey)=>({ getState: getState })=>projectKey in getState().cache,
    get: (projectKey)=>({ getState: getState })=>getState().cache[projectKey] ?? [],
    set: (projectKey, value)=>({ getState: getState, setState: setState })=>setState({
                cache: {
                    ...getState().cache,
                    [projectKey]: value
                }
            }),
    flush: ()=>({ setState: setState })=>setState({
                cache: {}
            })
};
const $c7cb5d88000c2e61$var$store = (0, $WBLbN.createStore)({
    name: 'CustomerServiceEscalationsCachedResquestType',
    initialState: $c7cb5d88000c2e61$var$initialState,
    actions: $c7cb5d88000c2e61$export$e324594224ef24da
});
const $c7cb5d88000c2e61$export$f963a7e097ba92b8 = (0, $WBLbN.createHook)($c7cb5d88000c2e61$var$store, {
    selector: ({ cache: cache }, projectKey)=>cache[projectKey] ?? []
});
const $c7cb5d88000c2e61$export$1e9a1e5c798dc8f5 = (0, $WBLbN.createActionsHook)($c7cb5d88000c2e61$var$store);
const $c7cb5d88000c2e61$export$fe860dc0eb43e1d5 = (workCategory, // eslint-disable-next-line @typescript-eslint/no-explicit-any
dependency)=>{
    const { flush: flush } = $c7cb5d88000c2e61$export$1e9a1e5c798dc8f5();
    (0, $eUqFw.useEffect)(()=>{
        if (workCategory === (0, $f1lMr.DEVELOPER_ESCALATION)) flush();
    }, [
        flush,
        workCategory,
        dependency
    ]);
};

});

parcelRegister("eCuTQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c049766b1d9c31e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $bNe1g = parcelRequire("bNe1g");

var $51maw = parcelRequire("51maw");
const $8c049766b1d9c31e$var$useAffectedRequestTypes = (practice)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { data: projectContext } = (0, $bNe1g.useProjectContext)();
    const { projectId: projectId } = projectContext || {};
    const { data: affectedRequestTypes, loading: loading, error: error, fetch: fetch } = (0, $51maw.useRequestTypesForPracticeService)(projectId, practice); // eslint-disable-line @typescript-eslint/consistent-type-assertions
    (0, $eUqFw.useEffect)(()=>{
        if (affectedRequestTypes) (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'affectedRequestTypes fetched');
    }, [
        createAnalyticsEvent,
        affectedRequestTypes
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (error) (0, $guiFP.default)({
            meta: {
                id: 'affectedRequestTypesFetch',
                packageName: 'jiraServicedeskItsmFeatures'
            },
            error: error,
            event: createAnalyticsEvent({}),
            sendToPrivacyUnsafeSplunk: true
        });
    });
    return {
        data: {
            numAffectedRequestTypes: affectedRequestTypes?.length
        },
        loading: loading,
        error: error,
        fetch: fetch
    };
};
var $8c049766b1d9c31e$export$2e2bcd8739ae039 = $8c049766b1d9c31e$var$useAffectedRequestTypes;

});
parcelRegister("51maw", function(module, exports) {

$parcel$export(module.exports, "useRequestTypesForPracticeService", () => $437c1641025f1286$export$5ecd4d35e36c1c31);

var $eUqFw = parcelRequire("eUqFw");

var $eEzyV = parcelRequire("eEzyV");

var $fV97Z = parcelRequire("fV97Z");
const $437c1641025f1286$var$getRequestTypesUrl = (projectId, practice)=>`/rest/servicedesk/1/servicedesk/${projectId}/request-types?practices=${practice}`;
const $437c1641025f1286$export$5ecd4d35e36c1c31 = (projectId, practice)=>{
    const url = $437c1641025f1286$var$getRequestTypesUrl(projectId, practice);
    const request = (0, $eUqFw.useCallback)(()=>(0, $fV97Z.performGetRequest)(url).then((response)=>response.ticketTypes), [
        url
    ]);
    return (0, $eEzyV.useService)(request);
};

});


parcelRegister("hObqq", function(module, exports) {

$parcel$export(module.exports, "AsyncConfirmDisableModal", () => $22c1a8c3ae81e157$export$605dbba7217e1592);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

const $22c1a8c3ae81e157$var$ConfirmDisableModal = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("cTxNl")), {
    moduleId: "./src/packages/servicedesk/itsm-features/src/ui/app/sections/service-project-section/csm-features/confirm-disable-modal/index.tsx"
});
const $22c1a8c3ae81e157$export$605dbba7217e1592 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-confirm-disable-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($22c1a8c3ae81e157$var$ConfirmDisableModal, props));

});
parcelRegister("cTxNl", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("benat")
]).then(()=>parcelRequire('5arAO'));

});


parcelRegister("iV7rt", function(module, exports) {

$parcel$export(module.exports, "default", () => $e896336d9d8f8fe6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $30Cw3 = parcelRequire("30Cw3");

var $eo17r = parcelRequire("eo17r");
var $k8Qyf = parcelRequire("k8Qyf");

var $3QLcd = parcelRequire("3QLcd");

var $fifNX = parcelRequire("fifNX");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");


var $lB25E = parcelRequire("lB25E");

var $co8Ny = parcelRequire("co8Ny");

var $fJdKO = parcelRequire("fJdKO");

var $iPgVt = parcelRequire("iPgVt");

var $sinJ9 = parcelRequire("sinJ9");

var $iZt1U = parcelRequire("iZt1U");
const $e896336d9d8f8fe6$var$CustomerContextFeatureTile = ({ isJiraAdmin: isJiraAdmin, isProductsAndEntitlementsEnabled: isProductsAndEntitlementsEnabled })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { data: data, saving: savingValue, update: update } = (0, $iPgVt.default)();
    const showSaveErrorFlag = (0, $fJdKO.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagsService)();
    const { push: push } = (0, $lB25E.useRouterActions)();
    const [projectKey = ''] = (0, $lB25E.usePathParam)('projectKey');
    const flagIdRef = (0, $eUqFw.useRef)({});
    const updateFeatureValue = (0, $eUqFw.useCallback)((featureTitle, feature, enabled)=>update({
            feature: feature,
            enabled: enabled,
            onSuccess: ()=>{
                const flagIdKey = `${feature}-service-feature-success`;
                const { current: flagIds } = flagIdRef;
                // toFlagId creates a new string reference. But we want to reuse
                // flag ids so the most relevant flag for a feature is shown
                flagIds[flagIdKey] = flagIds[flagIdKey] || (0, $eo17r.toFlagId)(flagIdKey);
                const id = flagIds[flagIdKey];
                const onClick = ()=>{
                    dismissFlag(id);
                };
                // Dismiss previous flag with the same id. So user cannot
                // interact with out of update flags
                dismissFlag(id);
                showFlag({
                    id: id,
                    type: 'success',
                    isAutoDismiss: !enabled,
                    title: [
                        (0, $iZt1U.default).successFlagTitle,
                        {
                            feature: (0, (/*@__PURE__*/$parcel$interopDefault($30Cw3)))(feature),
                            value: enabled
                        }
                    ],
                    description: enabled ? (0, $iZt1U.default).successEnableDescription : (0, $iZt1U.default).successDisableDescription,
                    actions: enabled ? [
                        {
                            content: (0, $iZt1U.default).successEnableAction,
                            onClick: ()=>{
                                dismissFlag(id);
                                push(`/jira/servicedesk/projects/${projectKey}/customers`);
                            }
                        }
                    ] : [
                        {
                            content: (0, $iZt1U.default).successDisableDismiss,
                            onClick: onClick
                        }
                    ]
                });
            },
            onFail: ()=>{
                showSaveErrorFlag(featureTitle, enabled);
            }
        }), [
        dismissFlag,
        projectKey,
        push,
        showFlag,
        showSaveErrorFlag,
        update
    ]);
    const inProductHelpArticleId = '6u1dZowoLdD0MSj0H7QWxK';
    const fallbackArticleUrl = 'https://support.atlassian.com/jira-service-management-cloud/docs/what-is-customer-service-management/';
    const inProductHelpLink = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3QLcd.default), {
        appearance: "link",
        spacing: "none",
        articleId: inProductHelpArticleId,
        fallbackComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
            target: "_blank",
            href: fallbackArticleUrl
        }, formatMessage((0, $iZt1U.default).csmCustomerContextLearnMore)),
        onClick: ()=>(0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'helpLink clicked', 'learnMoreAboutCsmCustomerContext', {
                inProductHelpArticleId: inProductHelpArticleId
            })
    }, formatMessage((0, $iZt1U.default).csmCustomerContextLearnMore));
    let tooltipMessage = null;
    if (!isJiraAdmin) tooltipMessage = formatMessage((0, $iZt1U.default).csmCustomerContextContactAdmin);
    const [isDisableCsmModalOpen, setIsDisableCsmModalOpen] = (0, $eUqFw.useState)(false);
    const onConfirmCsmDisable = (0, $eUqFw.useCallback)(()=>{
        updateFeatureValue(formatMessage((0, $iZt1U.default).csmCustomerContextTitle), (0, $89d8bb437c2044ff$export$6860c7a26d6d6d35), false);
        updateFeatureValue(formatMessage((0, $iZt1U.default).productsAndEntitlementsFeatureTitle), (0, $89d8bb437c2044ff$export$28fc94ee6c61f632), false);
        setIsDisableCsmModalOpen(false);
    }, [
        formatMessage,
        updateFeatureValue
    ]);
    const closeDisableCsmModal = (0, $eUqFw.useCallback)(()=>{
        setIsDisableCsmModalOpen(false);
    }, []);
    const disableCustomerServiceManagement = (0, $eUqFw.useCallback)(()=>{
        setIsDisableCsmModalOpen(true);
    }, []);
    const createCsmOnChangeHandler = (0, $eUqFw.useCallback)((feature, enabled, analyticEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticEvent, 'settingsToggle', {
            field: feature
        });
        if (enabled || !enabled && !isProductsAndEntitlementsEnabled) updateFeatureValue(formatMessage((0, $iZt1U.default).csmCustomerContextTitle), feature, enabled);
        else disableCustomerServiceManagement();
    }, [
        disableCustomerServiceManagement,
        formatMessage,
        isProductsAndEntitlementsEnabled,
        updateFeatureValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $co8Ny.FeatureToggleTile), {
        feature: (0, $89d8bb437c2044ff$export$6860c7a26d6d6d35),
        title: formatMessage((0, $iZt1U.default).csmCustomerContextTitle),
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fifNX.default), {
            alt: ""
        }),
        value: data?.[0, $89d8bb437c2044ff$export$6860c7a26d6d6d35]?.status === (0, $89d8bb437c2044ff$export$e927a5d1b72f0b68),
        saving: savingValue[0, $89d8bb437c2044ff$export$6860c7a26d6d6d35] || isDisableCsmModalOpen,
        onChange: createCsmOnChangeHandler,
        disabled: !isJiraAdmin,
        tooltip: tooltipMessage
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $iZt1U.default).csmCustomerContextDescriptionForIph,
        values: {
            learnMoreLink: inProductHelpLink,
            br: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null))
        }
    })), isDisableCsmModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $sinJ9.AsyncConfirmDisableModal), {
        onClose: closeDisableCsmModal,
        onConfirm: onConfirmCsmDisable
    }));
};
var $e896336d9d8f8fe6$export$2e2bcd8739ae039 = $e896336d9d8f8fe6$var$CustomerContextFeatureTile;

});
parcelRegister("30Cw3", function(module, exports) {

var $lrLC2 = parcelRequire("lrLC2");
/**
 * Converts `string` to
 * [snake case](https://en.wikipedia.org/wiki/Snake_case).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the snake cased string.
 * @example
 *
 * _.snakeCase('Foo Bar');
 * // => 'foo_bar'
 *
 * _.snakeCase('fooBar');
 * // => 'foo_bar'
 *
 * _.snakeCase('--FOO-BAR--');
 * // => 'foo_bar'
 */ var $230f3fa76a4d544d$var$snakeCase = $lrLC2(function(result, word, index) {
    return result + (index ? '_' : '') + word.toLowerCase();
});
module.exports = $230f3fa76a4d544d$var$snakeCase;

});

parcelRegister("fifNX", function(module, exports) {

$parcel$export(module.exports, "default", () => $0bedb9f585aacc9b$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = 67s6pq4g49vjwgq7hjn368
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/67s6pq4g49vjwgq7hjn368

var $9TZf5 = parcelRequire("9TZf5");

var $5fLU3 = parcelRequire("5fLU3");
const $0bedb9f585aacc9b$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($5fLU3)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($5fLU3))
});
var $0bedb9f585aacc9b$export$2e2bcd8739ae039 = $0bedb9f585aacc9b$var$Illustration;
// for advanced use only
const $0bedb9f585aacc9b$export$a179c88182cb9d56 = [
    0,
    0,
    229,
    178
];

});
parcelRegister("5fLU3", function(module, exports) {
module.exports = new URL("id-badge.7070a4f3.svg", import.meta.url).toString();

});


parcelRegister("sinJ9", function(module, exports) {

$parcel$export(module.exports, "AsyncConfirmDisableModal", () => $0dfa3d75e69851fe$export$605dbba7217e1592);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

const $0dfa3d75e69851fe$var$ConfirmDisableModal = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("eNng5")), {
    moduleId: "./src/packages/servicedesk/itsm-features/src/ui/app/sections/service-project-section/csm-features/customer-context/confirm-disable-modal/index.tsx"
});
const $0dfa3d75e69851fe$export$605dbba7217e1592 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-confirm-disable-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0dfa3d75e69851fe$var$ConfirmDisableModal, props));

});
parcelRegister("eNng5", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("8NOy8")
]).then(()=>parcelRequire('gkE0p'));

});


parcelRegister("iZt1U", function(module, exports) {

$parcel$export(module.exports, "default", () => $67df87c773bb3b97$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $67df87c773bb3b97$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    csmCustomerContextTitle: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.csm-features.customer-context.csm-customer-context-title",
        "defaultMessage": "Customer and organization profiles"
    },
    csmCustomerContextBadge: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.csm-features.customer-context.csm-customer-context-badge",
        "defaultMessage": "Early Access"
    },
    csmCustomerContextDescriptionForIph: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.csm-features.customer-context.csm-customer-context-description-for-iph",
        "defaultMessage": "Create profiles of your customers and organizations to get important information about them when working on issues. {learnMoreLink}"
    },
    csmCustomerContextLearnMore: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.csm-features.customer-context.csm-customer-context-learn-more",
        "defaultMessage": "Read more about customer and organization profiles. "
    },
    csmCustomerContextDetailsTitle: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.csm-features.customer-context.csm-customer-context-details-title",
        "defaultMessage": "Customer service management features"
    },
    csmCustomerContextContactAdmin: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.csm-features.customer-context.csm-customer-context-contact-admin",
        "defaultMessage": "Contact your Jira admin to enable or disable this feature."
    },
    csmCustomerContextContactSuccessTitle: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.csm-features.customer-context.csm-customer-context-contact-success-title",
        "defaultMessage": "Customer service management {value, select,\n            false {disabled}\n            true {enabled}\n            other {}\n        }"
    },
    successFlagTitle: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.csm-features.customer-context.success-flag-title",
        "defaultMessage": "{feature, select,\n            csm_customer_context {Customer service management}\n            products_and_entitlements {Products and entitlements}\n            other {unknown}\n        } {value, select,\n            false {turned off}\n            true {enabled}\n            other {}\n        }"
    },
    successEnableDescription: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.csm-features.customer-context.success-enable-description",
        "defaultMessage": "Start using customer support features on the Customers and Organizations pages."
    },
    successDisableDescription: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.csm-features.customer-context.success-disable-description",
        "defaultMessage": "You can enable this feature again at any time."
    },
    successEnableAction: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.csm-features.customer-context.success-enable-action",
        "defaultMessage": "Go to Customers page"
    },
    successDisableDismiss: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.csm-features.customer-context.success-disable-dismiss",
        "defaultMessage": "OK"
    },
    productsAndEntitlementsFeatureTitle: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.csm-features.customer-context.products-and-entitlements-feature-title",
        "defaultMessage": "Products and entitlements"
    }
});

});


parcelRegister("gE7IZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea4080c6837309b5$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ea4080c6837309b5$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    csmCustomerContextContactAdmin: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.csm-features.csm-customer-context-contact-admin",
        "defaultMessage": "Contact your Jira admin to enable or disable this feature."
    },
    successEnableDescription: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.csm-features.success-enable-description",
        "defaultMessage": "Start using customer support features on the customers and organizations pages."
    },
    successDisableDescription: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.csm-features.success-disable-description",
        "defaultMessage": "Enable this feature again at any time from the features menu."
    },
    successEnableAction: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.csm-features.success-enable-action",
        "defaultMessage": "Go to customers page"
    },
    successEnableDismiss: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.csm-features.success-enable-dismiss",
        "defaultMessage": "No thanks"
    },
    successDisableDismiss: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.csm-features.success-disable-dismiss",
        "defaultMessage": "Ok"
    },
    csmDeveloperEscalationsTitle: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.csm-features.csm-developer-escalations-title",
        "defaultMessage": "Developer escalations"
    },
    csmDeveloperEscalationsBadge: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.csm-features.csm-developer-escalations-badge",
        "defaultMessage": "Early Access"
    },
    csmDeveloperEscalationsDescription: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.csm-features.csm-developer-escalations-description",
        "defaultMessage": "Streamline developer escalations for your team with a dedicated work category and view. Developers can view, comment, and collaborate with customer service agents on escalated issues that require input from subject matter experts. {learnMoreLink}"
    },
    csmDeveloperEscalationsLearnMore: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.csm-features.csm-developer-escalations-learn-more",
        "defaultMessage": "Learn more about developer escalations."
    },
    csmDeveloperEscalationsContactSuccessTitle: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.csm-features.csm-developer-escalations-contact-success-title",
        "defaultMessage": "Developer escalations {value, select,\n            false {disabled}\n            true {enabled}\n            other {}\n        }"
    },
    csmDeveloperEscalationsSuccessEnableDescription: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.csm-features.csm-developer-escalations-success-enable-description",
        "defaultMessage": "You will now see <strong>Developer escalations</strong> in your project. Add a request type to start using this category."
    },
    csmDeveloperEscalationSuccessDisableDescription: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.csm-features.csm-developer-escalation-success-disable-description",
        "defaultMessage": "You can enable this feature again at any time."
    },
    csmDeveloperEscalationsSuccessEnableAction: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.csm-features.csm-developer-escalations-success-enable-action",
        "defaultMessage": "Add request type"
    },
    csmDeveloperEscalationsSuccessEnableDismiss: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.csm-features.csm-developer-escalations-success-enable-dismiss",
        "defaultMessage": "Maybe later"
    },
    csmDeveloperEscalationsSuccessDisableDismiss: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.csm-features.csm-developer-escalations-success-disable-dismiss",
        "defaultMessage": "Ok"
    }
});

});

parcelRegister("1ao52", function(module, exports) {

$parcel$export(module.exports, "default", () => $543b9e0f58293860$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $1Yimi = parcelRequire("1Yimi");

var $eo17r = parcelRequire("eo17r");
var $k8Qyf = parcelRequire("k8Qyf");

var $3QLcd = parcelRequire("3QLcd");

var $382qC = parcelRequire("382qC");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");


var $lB25E = parcelRequire("lB25E");

var $co8Ny = parcelRequire("co8Ny");

var $fJdKO = parcelRequire("fJdKO");

var $iPgVt = parcelRequire("iPgVt");

var $c4nFu = parcelRequire("c4nFu");
const $543b9e0f58293860$var$ProductsAndEntitlementsFeatureTile = ({ isJiraAdmin: isJiraAdmin, isCustomerContextEnabled: isCustomerContextEnabled })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { data: data, saving: saving, update: update } = (0, $iPgVt.default)();
    const showSaveErrorFlag = (0, $fJdKO.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagsService)();
    const { push: push } = (0, $lB25E.useRouterActions)();
    const [projectKey = ''] = (0, $lB25E.usePathParam)('projectKey');
    const flagIdRef = (0, $eUqFw.useRef)({});
    const featureInProductHelpArticleId = '5vAddFwJAdYXOuso7OdwMz';
    const featureFallbackArticleUrl = 'https://support.atlassian.com/jira-service-management-cloud/docs/create-product-entitlements-for-your-customers/';
    const featureHelpArticleFireAnalytics = ()=>(0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'helpLink clicked', 'learnMoreAboutProductsAndEntitlements', {
            featureInProductHelpArticleId: featureInProductHelpArticleId
        });
    const featureFallbackAnchor = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "link",
        spacing: "none",
        href: featureFallbackArticleUrl,
        target: "_blank",
        onClick: featureHelpArticleFireAnalytics
    }, formatMessage((0, $c4nFu.default).featureLearnMore));
    const featureInProductHelpLink = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3QLcd.default), {
        appearance: "link",
        spacing: "none",
        articleId: featureInProductHelpArticleId,
        fallbackComponent: featureFallbackAnchor,
        onClick: featureHelpArticleFireAnalytics
    }, formatMessage((0, $c4nFu.default).featureLearnMore));
    const updateFeatureToggle = (0, $eUqFw.useCallback)((enabled)=>{
        update({
            feature: (0, $89d8bb437c2044ff$export$28fc94ee6c61f632),
            enabled: enabled,
            onSuccess: ()=>{
                const flagIdKey = `${(0, $89d8bb437c2044ff$export$28fc94ee6c61f632)}-service-feature-success`;
                const { current: flagIds } = flagIdRef;
                // toFlagId creates a new string reference. But we want to reuse
                // flag ids so the most relevant flag for a feature is shown
                flagIds[flagIdKey] = flagIds[flagIdKey] || (0, $eo17r.toFlagId)(flagIdKey);
                const id = flagIds[flagIdKey];
                const onClick = ()=>{
                    dismissFlag(id);
                };
                // Dismiss previous flag with the same id. So user cannot
                // interact with out of update flags
                dismissFlag(id);
                showFlag({
                    id: id,
                    type: 'success',
                    isAutoDismiss: !enabled,
                    title: [
                        (0, $c4nFu.default).featureContactSuccessTitle,
                        {
                            value: enabled
                        }
                    ],
                    description: [
                        enabled ? (0, $c4nFu.default).featureSuccessEnableDescription : (0, $c4nFu.default).featureSuccessDisableDescription,
                        {
                            strong: (children)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
                                    weight: "bold"
                                }, children)
                        }
                    ],
                    actions: enabled ? [
                        {
                            content: (0, $c4nFu.default).featureSuccessEnableAction,
                            onClick: ()=>{
                                dismissFlag(id);
                                push(`/jira/servicedesk/projects/${projectKey}/products/`);
                            }
                        }
                    ] : [
                        {
                            content: (0, $c4nFu.default).featureSuccessDisableDismiss,
                            onClick: onClick
                        }
                    ]
                });
            },
            onFail: ()=>{
                showSaveErrorFlag(formatMessage((0, $c4nFu.default).featureTitle), enabled);
            }
        });
    }, [
        dismissFlag,
        projectKey,
        push,
        showFlag,
        showSaveErrorFlag,
        update,
        formatMessage
    ]);
    const createFeatureOnChangeHandler = (0, $eUqFw.useCallback)(()=>(feature, enabled, analyticEvent)=>{
            (0, $jMP2a.fireUIAnalytics)(analyticEvent, 'settingsToggle', {
                field: feature
            });
            updateFeatureToggle(enabled);
        }, [
        updateFeatureToggle
    ]);
    const isProductsAndEntitlementsEnabled = data?.[0, $89d8bb437c2044ff$export$28fc94ee6c61f632]?.status === (0, $89d8bb437c2044ff$export$e927a5d1b72f0b68);
    const nonJiraAdmintooltip = isJiraAdmin ? null : formatMessage((0, $c4nFu.default).featureContactAdmin);
    const customerContextDisablesTooltip = isCustomerContextEnabled ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $c4nFu.default).featurePrerequisite,
        values: {
            strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
                    weight: "bold"
                }, chunks)
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $co8Ny.FeatureToggleTile), {
        feature: (0, $89d8bb437c2044ff$export$28fc94ee6c61f632),
        title: formatMessage((0, $c4nFu.default).featureTitle),
        value: isProductsAndEntitlementsEnabled,
        saving: saving[0, $89d8bb437c2044ff$export$28fc94ee6c61f632],
        onChange: createFeatureOnChangeHandler(),
        tooltip: nonJiraAdmintooltip || customerContextDisablesTooltip,
        disabled: !isJiraAdmin || !isCustomerContextEnabled,
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $382qC.default), {
            alt: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $c4nFu.default).featureDescription,
        values: {
            learnMoreLink: featureInProductHelpLink
        }
    })));
};
var $543b9e0f58293860$export$2e2bcd8739ae039 = $543b9e0f58293860$var$ProductsAndEntitlementsFeatureTile;

});
parcelRegister("382qC", function(module, exports) {

$parcel$export(module.exports, "default", () => $125bd8f5cbe587b0$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = 9kfmw2v5rxbpzq6h9hkwp
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/9kfmw2v5rxbpzq6h9hkwp

var $9TZf5 = parcelRequire("9TZf5");

var $h02Mu = parcelRequire("h02Mu");
const $125bd8f5cbe587b0$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($h02Mu)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($h02Mu))
});
var $125bd8f5cbe587b0$export$2e2bcd8739ae039 = $125bd8f5cbe587b0$var$Illustration;
// for advanced use only
const $125bd8f5cbe587b0$export$a179c88182cb9d56 = [
    0,
    0,
    172,
    170
];

});
parcelRegister("h02Mu", function(module, exports) {
module.exports = new URL("value.9806a076.svg", import.meta.url).toString();

});


parcelRegister("c4nFu", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c6ff9074ebef1db$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3c6ff9074ebef1db$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    featureTitle: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.csm-features.products-and-entitlements-tile.feature-title",
        "defaultMessage": "Products and entitlements"
    },
    featureDescription: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.csm-features.products-and-entitlements-tile.feature-description",
        "defaultMessage": "View and manage the details of your customers' entitlements to your products to get more context when supporting customers. {learnMoreLink}"
    },
    featureLearnMore: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.csm-features.products-and-entitlements-tile.feature-learn-more",
        "defaultMessage": "Read more about products and entitlements."
    },
    featureContactAdmin: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.csm-features.products-and-entitlements-tile.feature-contact-admin",
        "defaultMessage": "Contact your Jira admin to enable or disable this feature."
    },
    featurePrerequisite: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.csm-features.products-and-entitlements-tile.feature-prerequisite",
        "defaultMessage": "To use this feature, turn on <strong>Customer and organization profiles</strong>"
    },
    featureContactSuccessTitle: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.csm-features.products-and-entitlements-tile.feature-contact-success-title",
        "defaultMessage": "Products and entitlements {value, select,\n            false {turned off}\n            true {enabled}\n            other {}\n        }"
    },
    featureSuccessEnableDescription: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.csm-features.products-and-entitlements-tile.feature-success-enable-description",
        "defaultMessage": "Start adding products and setting up entitlements on the Products page."
    },
    featureSuccessDisableDescription: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.csm-features.products-and-entitlements-tile.feature-success-disable-description",
        "defaultMessage": "You can enable this feature again at any time."
    },
    featureSuccessEnableAction: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.csm-features.products-and-entitlements-tile.feature-success-enable-action",
        "defaultMessage": "Go to Products page"
    },
    featureSuccessDisableDismiss: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.csm-features.products-and-entitlements-tile.feature-success-disable-dismiss",
        "defaultMessage": "OK"
    }
});

});



parcelRegister("ddk2C", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbb9115c91c8ff9f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $XHGTv = parcelRequire("XHGTv");

var $h4Fhh = parcelRequire("h4Fhh");

var $3QLcd = parcelRequire("3QLcd");

var $ayM9M = parcelRequire("ayM9M");

var $87mAl = parcelRequire("87mAl");

var $iJckJ = parcelRequire("iJckJ");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $4Wgi4 = parcelRequire("4Wgi4");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $bNe1g = parcelRequire("bNe1g");


var $frZnw = parcelRequire("frZnw");

var $ksHP7 = parcelRequire("ksHP7");

var $co8Ny = parcelRequire("co8Ny");

var $fJdKO = parcelRequire("fJdKO");

var $iPgVt = parcelRequire("iPgVt");

var $lggcE = parcelRequire("lggcE");

var $jgHQQ = parcelRequire("jgHQQ");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bbb9115c91c8ff9f$var$DevOpsFeatures = /*#__PURE__*/ (0, $eUqFw.memo)(()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ opsgenieBaseUrl: opsgenieBaseUrl }] = (0, $4Wgi4.useOpsgenieBaseUrl)((0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).ITSM_FEATURES_SETTINGS));
    const { data: data, saving: saving, update: update } = (0, $iPgVt.default)();
    const showSaveErrorFlag = (0, $fJdKO.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { data: projectContext } = (0, $bNe1g.useProjectContext)();
    const { isConsolidated: isConsolidated } = (0, $h4Fhh.useOgTenantInfo)();
    const isClassicProject = Boolean(projectContext && !projectContext.simplified);
    const handleOnChange = (0, $eUqFw.useCallback)((feature, enabled, analyticEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticEvent, 'settingsToggle', {
            field: feature
        });
        update({
            feature: feature,
            enabled: enabled,
            onFail: ()=>{
                showSaveErrorFlag(formatMessage((0, $lggcE.FEATURE_TITLE_LOOKUP)[feature]), enabled);
            }
        });
    }, [
        formatMessage,
        showSaveErrorFlag,
        update
    ]);
    const createLearnMoreLink = (href, message, articleId, eventName)=>{
        const learnMoreLinkButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ksHP7.ExternalLink), {
            href: href
        }, message);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3QLcd.default), {
            articleId: articleId,
            appearance: "link",
            spacing: "none",
            fallbackComponent: learnMoreLinkButton,
            onClick: ()=>(0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'helpLink clicked', eventName, {
                    articleId: articleId
                })
        }, message);
    };
    const classicLearnMoreAboutAlertArticleId = '1s3I1JN4Y9Sejgt7YDLK7J';
    const nextGenLearnMoreAboutAlertArticleId = 'ZOHywNcUfDBlV4uvkv0Po';
    const learnMoreAboutAlerts = createLearnMoreLink('https://docs.opsgenie.com/docs/new-user-alert-management', formatMessage((0, $jgHQQ.default).alertsLink), isClassicProject ? classicLearnMoreAboutAlertArticleId : nextGenLearnMoreAboutAlertArticleId, 'learnMoreAboutAlerts');
    const learnMoreAboutAlertsConsolidated = createLearnMoreLink('https://support.atlassian.com/jira-service-management-cloud/docs/what-are-alerts', formatMessage((0, $jgHQQ.default).alertsLinkConsolidated), '8nyr2PWtUtH4wbYm8JAV2', 'learnMoreAboutAlertsConsolidated');
    const learnMoreAboutOnCall = createLearnMoreLink('https://docs.opsgenie.com/docs/new-user-on-call-schedules', formatMessage((0, $jgHQQ.default).oncallLink), '2zyL8oLj6I4a56rpl8TPZ3', 'learnMoreAboutOnCall');
    const learnMoreAboutOnCallConsolidated = createLearnMoreLink('https://support.atlassian.com/jira-service-management-cloud/docs/how-do-on-call-schedules-work-in-operations', formatMessage((0, $jgHQQ.default).oncallLinkConsolidated), '7KkB6nTIcLcVRC2T39y2xI', 'learnMoreAboutOnCallConsolidated');
    const learnMoreAboutServices = createLearnMoreLink('https://support.atlassian.com/jira-service-desk-cloud/docs/manage-your-service-registry', formatMessage((0, $jgHQQ.default).servicesLink), '3osolPEuol1YCaO4FthXUl', 'learnMoreAboutService');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, isClassicProject && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $co8Ny.FeatureToggleTile), {
        feature: (0, $89d8bb437c2044ff$export$de0bca182bc46c7f),
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ayM9M.default), {
            alt: ""
        }),
        title: formatMessage((0, $jgHQQ.default).servicesTitle),
        value: // @ts-expect-error TS2532 - Object is possibly 'undefined'.
        data?.[0, $89d8bb437c2044ff$export$de0bca182bc46c7f].status === (0, $89d8bb437c2044ff$export$e927a5d1b72f0b68),
        saving: saving[0, $89d8bb437c2044ff$export$de0bca182bc46c7f],
        onChange: handleOnChange
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $jgHQQ.default).servicesDescription,
        values: {
            learnMoreLink: learnMoreAboutServices
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $co8Ny.FeatureToggleTile), {
        feature: (0, $89d8bb437c2044ff$export$b45a36df7873757),
        title: formatMessage((0, $jgHQQ.default).alertsTitle),
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $87mAl.default), {
            alt: ""
        }),
        value: // @ts-expect-error TS2532 - Object is possibly 'undefined'.
        data?.[0, $89d8bb437c2044ff$export$b45a36df7873757].status === (0, $89d8bb437c2044ff$export$e927a5d1b72f0b68),
        saving: saving[0, $89d8bb437c2044ff$export$b45a36df7873757],
        onChange: handleOnChange
    }, isConsolidated ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $jgHQQ.default).alertsConsolidatedDescription,
        values: {
            learnMoreLink: learnMoreAboutAlertsConsolidated
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $jgHQQ.default).alertsDescription,
        values: {
            opsgenieLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ksHP7.ExternalLink), {
                href: `${String(opsgenieBaseUrl)}/alert`,
                enabled: Boolean(opsgenieBaseUrl)
            }, formatMessage((0, $jgHQQ.default).alertsOgLink)),
            learnMoreLink: learnMoreAboutAlerts
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $co8Ny.FeatureToggleTile), {
        feature: (0, $89d8bb437c2044ff$export$a7952c5a5c371ddd),
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJckJ.default), {
            alt: ""
        }),
        title: formatMessage((0, $jgHQQ.default).oncallTitle),
        value: // @ts-expect-error TS2532 - Object is possibly 'undefined'.
        data?.[0, $89d8bb437c2044ff$export$a7952c5a5c371ddd].status === (0, $89d8bb437c2044ff$export$e927a5d1b72f0b68),
        saving: saving[0, $89d8bb437c2044ff$export$a7952c5a5c371ddd],
        onChange: handleOnChange
    }, isConsolidated && (0, $XHGTv.getBooleanFF)('platform.jira.frontend.remove-the-linkage-to-opsgenie-in-jsm') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $jgHQQ.default).oncallConsolidatedDescription,
        values: {
            learnMoreLink: learnMoreAboutOnCallConsolidated
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $jgHQQ.default).oncallDescription,
        values: {
            opsgenieLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ksHP7.ExternalLink), {
                href: `${String(opsgenieBaseUrl)}/schedule/whoIsOnCall`,
                enabled: Boolean(opsgenieBaseUrl)
            }, formatMessage((0, $jgHQQ.default).oncallOgLink)),
            learnMoreLink: learnMoreAboutOnCall
        }
    })));
});
var $bbb9115c91c8ff9f$export$2e2bcd8739ae039 = $bbb9115c91c8ff9f$var$DevOpsFeatures;

});
parcelRegister("ayM9M", function(module, exports) {

$parcel$export(module.exports, "default", () => $e195c8a981525092$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $9TZf5 = parcelRequire("9TZf5");

var $kf3LO = parcelRequire("kf3LO");
const $e195c8a981525092$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($kf3LO)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($kf3LO))
});
var $e195c8a981525092$export$2e2bcd8739ae039 = $e195c8a981525092$var$Illustration;
// for advanced use only
const $e195c8a981525092$export$a179c88182cb9d56 = [
    0,
    0,
    208,
    193
];

});
parcelRegister("kf3LO", function(module, exports) {
module.exports = new URL("graph.a9178f19.svg", import.meta.url).toString();

});


parcelRegister("87mAl", function(module, exports) {

$parcel$export(module.exports, "default", () => $f89acd8c30852c86$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = hmw64wpfb5gbffw5rhb2nfx
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/hmw64wpfb5gbffw5rhb2nfx

var $9TZf5 = parcelRequire("9TZf5");

var $1rfPk = parcelRequire("1rfPk");
const $f89acd8c30852c86$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($1rfPk)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($1rfPk))
});
var $f89acd8c30852c86$export$2e2bcd8739ae039 = $f89acd8c30852c86$var$Illustration;
// for advanced use only
const $f89acd8c30852c86$export$a179c88182cb9d56 = [
    0,
    0,
    54,
    48
];

});
parcelRegister("1rfPk", function(module, exports) {
module.exports = new URL("jsm-alerts.eb48cb8d.svg", import.meta.url).toString();

});


parcelRegister("iJckJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2dbe348a6524df7c$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = hmw64wpfb5gbffw5rhb2nfx
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/hmw64wpfb5gbffw5rhb2nfx

var $9TZf5 = parcelRequire("9TZf5");

var $lIBJ9 = parcelRequire("lIBJ9");
const $2dbe348a6524df7c$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($lIBJ9)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($lIBJ9))
});
var $2dbe348a6524df7c$export$2e2bcd8739ae039 = $2dbe348a6524df7c$var$Illustration;
// for advanced use only
const $2dbe348a6524df7c$export$a179c88182cb9d56 = [
    0,
    0,
    56,
    61
];

});
parcelRegister("lIBJ9", function(module, exports) {
module.exports = new URL("jsm-oncall.599266be.svg", import.meta.url).toString();

});


parcelRegister("4Wgi4", function(module, exports) {

$parcel$export(module.exports, "useOpsgenieBaseUrl", () => $8057d1504c4c8df3$export$60d311c8b1ba6c11);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $WBLbN = parcelRequire("WBLbN");

var $6CPEe = parcelRequire("6CPEe");
const $8057d1504c4c8df3$export$d4c72bab9d6cc13a = {
    opsgenieBaseUrl: undefined,
    fetchStatus: undefined,
    error: undefined
};
const $8057d1504c4c8df3$var$opsgenieBaseUrlStore = (0, $WBLbN.createStore)({
    name: 'opsgenieBaseUrl',
    initialState: $8057d1504c4c8df3$export$d4c72bab9d6cc13a,
    actions: (0, $6CPEe.actions)
});
const $8057d1504c4c8df3$export$7d5869fb9c3cabbd = (0, $WBLbN.createHook)($8057d1504c4c8df3$var$opsgenieBaseUrlStore);
const $8057d1504c4c8df3$export$60d311c8b1ba6c11 = (packageName)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [state, { fetchOpsgenieBaseUrl: fetchOpsgenieBaseUrl }] = $8057d1504c4c8df3$export$7d5869fb9c3cabbd();
    const fetchOgBaseUrl = (0, $eUqFw.useCallback)(()=>fetchOpsgenieBaseUrl(createAnalyticsEvent({}), packageName), [
        createAnalyticsEvent,
        fetchOpsgenieBaseUrl,
        packageName
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (state.opsgenieBaseUrl === undefined && !state.fetchStatus) fetchOgBaseUrl();
    }, [
        fetchOgBaseUrl,
        state.opsgenieBaseUrl,
        state.fetchStatus
    ]);
    return [
        state,
        {
            fetchOgBaseUrl: fetchOgBaseUrl
        }
    ];
};

});
parcelRegister("6CPEe", function(module, exports) {

$parcel$export(module.exports, "actions", () => $d028f496c3752929$export$e324594224ef24da);

var $7WHQX = parcelRequire("7WHQX");
const $d028f496c3752929$export$e324594224ef24da = {
    fetchOpsgenieBaseUrl: $7WHQX.fetchOpsgenieBaseUrl
};

});
parcelRegister("7WHQX", function(module, exports) {

$parcel$export(module.exports, "fetchOpsgenieBaseUrl", () => $4f69155afcb64fd9$export$14e903f188de435b);

var $guiFP = parcelRequire("guiFP");

var $2OdyW = parcelRequire("2OdyW");

var $jMP2a = parcelRequire("jMP2a");

var $hVMYA = parcelRequire("hVMYA");
const $4f69155afcb64fd9$export$14e903f188de435b = (analyticsEvent, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
packageName)=>async ({ getState: getState, setState: setState })=>{
        const { opsgenieBaseUrl: currentOpsgenieBaseUrl, fetchStatus: currentFetchStatus } = getState();
        if (currentOpsgenieBaseUrl !== undefined || // @ts-expect-error - TS2345 - Argument of type 'FetchStatus | undefined' is not assignable to parameter of type '"SUCCESS" | "IN_PROGRESS_FETCH_STATUS"'.
        [
            (0, $hVMYA.FETCH_STATUS).inProgress,
            (0, $hVMYA.FETCH_STATUS).success
        ].includes(currentFetchStatus)) return;
        setState({
            fetchStatus: (0, $hVMYA.FETCH_STATUS).inProgress,
            error: undefined
        });
        try {
            const { baseUrl: baseUrl } = await (0, $2OdyW.default)('/rest/internal/2/opsgenie-base-url');
            analyticsEvent && (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'fetchOgBaseUrl succeeded');
            setState({
                fetchStatus: (0, $hVMYA.FETCH_STATUS).success,
                opsgenieBaseUrl: baseUrl
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.trackFetchErrors)({
                error: error,
                id: 'fetchOgBaseUrl',
                packageName: packageName,
                sendToPrivacyUnsafeSplunk: true
            });
            setState({
                fetchStatus: (0, $hVMYA.FETCH_STATUS).error,
                error: error
            });
            throw error;
        }
    };

});
parcelRegister("hVMYA", function(module, exports) {

$parcel$export(module.exports, "FETCH_STATUS", () => $78888933c485ee94$export$7279934be2ca35bc);
const $78888933c485ee94$export$7279934be2ca35bc = {
    inProgress: 'IN_PROGRESS_FETCH_STATUS',
    error: 'ERROR_FETCH_STATUS',
    success: 'SUCCESS'
};

});




parcelRegister("lggcE", function(module, exports) {

$parcel$export(module.exports, "FEATURE_TITLE_LOOKUP", () => $54246d485ae1056a$export$dfc02a342f2d3448);


var $jgHQQ = parcelRequire("jgHQQ");
const $54246d485ae1056a$export$dfc02a342f2d3448 = {
    [(0, $89d8bb437c2044ff$export$b45a36df7873757)]: (0, $jgHQQ.default).alertsTitle,
    [(0, $89d8bb437c2044ff$export$a7952c5a5c371ddd)]: (0, $jgHQQ.default).oncallTitle,
    [(0, $89d8bb437c2044ff$export$de0bca182bc46c7f)]: (0, $jgHQQ.default).servicesTitle
};

});
parcelRegister("jgHQQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f5f9c144ca016d3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $5f5f9c144ca016d3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    servicesTitle: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.dev-ops-features.services-title",
        "defaultMessage": "Services"
    },
    servicesDescription: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.dev-ops-features.services-description",
        "defaultMessage": "Services hold details of the products and applications your organization uses. These can be used for a variety of features, including approving changes or knowing who to alert of an incident. {learnMoreLink}."
    },
    servicesLink: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.dev-ops-features.services-link",
        "defaultMessage": "Learn more about Services"
    },
    alertsTitle: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.dev-ops-features.alerts-title",
        "defaultMessage": "Alerts"
    },
    alertsDescription: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.dev-ops-features.alerts-description",
        "defaultMessage": "Give access to {opsgenieLink} in this project to let your team notify the right people of incidents as they happen. {learnMoreLink}."
    },
    alertsOgLink: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.dev-ops-features.alerts-og-link",
        "defaultMessage": "Alerts by Opsgenie"
    },
    alertsLink: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.dev-ops-features.alerts-link",
        "defaultMessage": "Learn more about Alerts"
    },
    alertsConsolidatedDescription: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.dev-ops-features.alerts-consolidated-description",
        "defaultMessage": "Give access to Alerts in this project to notify the right people during incidents and provide more context by linking alerts to incidents. {learnMoreLink}."
    },
    alertsLinkConsolidated: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.dev-ops-features.alerts-link-consolidated",
        "defaultMessage": "Read more about alerts"
    },
    oncallTitle: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.dev-ops-features.oncall-title",
        "defaultMessage": "On-call"
    },
    oncallDescription: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.dev-ops-features.oncall-description",
        "defaultMessage": "Give access to {opsgenieLink} in this project to let your team see who's rostered to be alerted about incidents. {learnMoreLink}."
    },
    oncallConsolidatedDescription: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.dev-ops-features.oncall-consolidated-description",
        "defaultMessage": "Give access to On-call in this project to let your team see who is on call and notified about incidents. {learnMoreLink}."
    },
    oncallLinkConsolidated: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.dev-ops-features.oncall-link-consolidated",
        "defaultMessage": "Read more about on-call schedules"
    },
    oncallOgLink: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.dev-ops-features.oncall-og-link",
        "defaultMessage": "On-call by Opsgenie"
    },
    oncallLink: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.dev-ops-features.oncall-link",
        "defaultMessage": "Learn more about On-call"
    }
});

});



parcelRegister("98E1h", function(module, exports) {

$parcel$export(module.exports, "default", () => $1136f7aa8d3f7a2a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $eo17r = parcelRequire("eo17r");
var $k8Qyf = parcelRequire("k8Qyf");

var $3QLcd = parcelRequire("3QLcd");

var $k3buW = parcelRequire("k3buW");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");


var $lB25E = parcelRequire("lB25E");

var $co8Ny = parcelRequire("co8Ny");

var $fJdKO = parcelRequire("fJdKO");

var $iPgVt = parcelRequire("iPgVt");

var $9lghv = parcelRequire("9lghv");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $1136f7aa8d3f7a2a$var$ChannelsFeatures = /*#__PURE__*/ (0, $eUqFw.memo)(()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { data: data, saving: saving, update: update } = (0, $iPgVt.default)();
    const showSaveErrorFlag = (0, $fJdKO.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagsService)();
    const { push: push } = (0, $lB25E.useRouterActions)();
    const [projectKey = ''] = (0, $lB25E.usePathParam)('projectKey');
    const flagIdRef = (0, $eUqFw.useRef)({});
    const createOnChangeHandler = (0, $eUqFw.useCallback)((featureTitle)=>(feature, enabled, analyticEvent)=>{
            (0, $jMP2a.fireUIAnalytics)(analyticEvent, 'settingsToggle', {
                field: feature
            });
            update({
                feature: feature,
                enabled: enabled,
                onSuccess: ()=>{
                    const flagIdKey = `${feature}-service-feature-success`;
                    const { current: flagIds } = flagIdRef;
                    // toFlagId creates a new string reference. But we want to reuse
                    // flag ids so the most relevant flag for a feature is shown
                    flagIds[flagIdKey] = flagIds[flagIdKey] || (0, $eo17r.toFlagId)(flagIdKey);
                    const id = flagIds[flagIdKey];
                    // Dismiss previous flag with the same id. So user cannot
                    // interact with out of update flags
                    dismissFlag(id);
                    showFlag({
                        id: id,
                        type: 'success',
                        isAutoDismiss: !enabled,
                        title: [
                            (0, $9lghv.default).emailSuccessTitle,
                            {
                                value: enabled
                            }
                        ],
                        description: enabled ? (0, $9lghv.default).successEnableDescription : (0, $9lghv.default).successDisableDescription,
                        actions: enabled ? [
                            {
                                content: (0, $9lghv.default).successEnableAction,
                                onClick: ()=>{
                                    dismissFlag(id);
                                    push(`/jira/servicedesk/projects/${projectKey}/settings/email`);
                                }
                            }
                        ] : []
                    });
                },
                onFail: ()=>{
                    showSaveErrorFlag(featureTitle, enabled);
                }
            });
        }, [
        projectKey,
        dismissFlag,
        push,
        showFlag,
        showSaveErrorFlag,
        update
    ]);
    const inProductHelpArticleId = '2LdFejVRvNBq8otZjImdE1';
    const fallbackArticleUrl = 'https://support.atlassian.com/jira-service-management-cloud/docs/receive-requests-from-an-email-address/';
    const inProductHelpLink = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3QLcd.default), {
        appearance: "link",
        spacing: "none",
        articleId: inProductHelpArticleId,
        fallbackComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
            target: "_blank",
            href: fallbackArticleUrl
        }, formatMessage((0, $9lghv.default).learnMoreAboutEmail)),
        onClick: ()=>(0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'helpLink clicked', 'learnMoreAboutEmail', {
                inProductHelpArticleId: inProductHelpArticleId
            })
    }, formatMessage((0, $9lghv.default).learnMoreAboutEmail));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $co8Ny.FeatureToggleTile), {
        feature: (0, $89d8bb437c2044ff$export$51e98af8dd4951f3),
        title: formatMessage((0, $9lghv.default).emailTitle),
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k3buW.default), {
            alt: ""
        }),
        value: data?.[0, $89d8bb437c2044ff$export$51e98af8dd4951f3]?.status === (0, $89d8bb437c2044ff$export$e927a5d1b72f0b68),
        saving: saving[0, $89d8bb437c2044ff$export$51e98af8dd4951f3],
        onChange: createOnChangeHandler(formatMessage((0, $9lghv.default).emailTitle))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $9lghv.default).emailDescriptionForInProductHelp,
        values: {
            learnMoreLink: inProductHelpLink,
            br: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null))
        }
    }));
});
var $1136f7aa8d3f7a2a$export$2e2bcd8739ae039 = $1136f7aa8d3f7a2a$var$ChannelsFeatures;

});
parcelRegister("k3buW", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e410d92f1114bfe$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = sk4xn6h5m96r66tjv74tk
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/sk4xn6h5m96r66tjv74tk

var $9TZf5 = parcelRequire("9TZf5");

var $i49EG = parcelRequire("i49EG");
const $3e410d92f1114bfe$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($i49EG)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($i49EG))
});
var $3e410d92f1114bfe$export$2e2bcd8739ae039 = $3e410d92f1114bfe$var$Illustration;
// for advanced use only
const $3e410d92f1114bfe$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    139
];

});
parcelRegister("i49EG", function(module, exports) {
module.exports = new URL("invitation.873b2b7a.svg", import.meta.url).toString();

});


parcelRegister("9lghv", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d31b39bbcc16ced$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $0d31b39bbcc16ced$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    emailTitle: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.email-features.email-title",
        "defaultMessage": "Email"
    },
    emailDescription: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.email-features.email-description",
        "defaultMessage": "\n            <p>\n                Turn emails into support requests that are automatically added to your queues\n                <a target=\"_blank\" href=\"{href}\">Learn more about email requests.</a>.\n            </p>"
    },
    emailDescriptionForInProductHelp: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.email-features.email-description-for-in-product-help",
        "defaultMessage": "Turn emails into support requests that are automatically added to your queues. {learnMoreLink}"
    },
    learnMoreAboutEmail: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.email-features.learn-more-about-email",
        "defaultMessage": "Learn more about email requests"
    },
    emailSuccessTitle: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.email-features.email-success-title",
        "defaultMessage": "Email turned {value, select,\n            false {off}\n            true {on}\n            other {}\n        }"
    },
    successEnableDescription: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.email-features.success-enable-description",
        "defaultMessage": "View and customize your email address on the email page."
    },
    successDisableDescription: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.email-features.success-disable-description",
        "defaultMessage": "You can turn this on again at any time."
    },
    successEnableAction: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.email-features.success-enable-action",
        "defaultMessage": "Go to email page"
    },
    successDisableDismiss: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.email-features.success-disable-dismiss",
        "defaultMessage": "Ok"
    }
});

});


parcelRegister("gtdmv", function(module, exports) {

$parcel$export(module.exports, "default", () => $97554541248b9af6$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $97554541248b9af6$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    viewsTitle: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.views-title",
        "defaultMessage": "Views"
    },
    channelsTitle: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.channels-title",
        "defaultMessage": "Channels"
    },
    essentialsTitle: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.essentials-title",
        "defaultMessage": "Essentials"
    },
    workTitle: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.work-title",
        "defaultMessage": "Work categories"
    },
    customerServiceTitle: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.customer-service-title",
        "defaultMessage": "Customer service"
    },
    operationsTitle: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.operations-title",
        "defaultMessage": "Operations"
    }
});

});

parcelRegister("9J8UW", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a40011d93e308c9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");


var $kSk4G = parcelRequire("kSk4G");

var $3NHvN = parcelRequire("3NHvN");

var $94zS7 = parcelRequire("94zS7");

var $imjKI = parcelRequire("imjKI");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $5a40011d93e308c9$var$PracticesFeatures = /*#__PURE__*/ (0, $eUqFw.memo)(()=>{
    const { data: data, saving: saving, update: update, paymentError: paymentError } = (0, $kSk4G.default)();
    const [confirmFeature, setConfirmFeature] = (0, $eUqFw.useState)('');
    const [numAffectedRT, setNumAffectedRT] = (0, $eUqFw.useState)();
    const [affectedRTError, setAffectedRTError] = (0, $eUqFw.useState)();
    const [refocusElement, setRefocusElement] = (0, $eUqFw.useState)('');
    const [isDisableModalOpen, setIsDisableModalOpen] = (0, $eUqFw.useState)(false);
    const onEnable = (0, $eUqFw.useCallback)((feature)=>{
        setConfirmFeature(confirmFeature);
        update({
            feature: feature,
            enabled: true
        });
    }, [
        confirmFeature,
        update
    ]);
    const onDisable = (0, $eUqFw.useCallback)((feature, numAffectedRequestTypes, error)=>{
        setConfirmFeature(feature);
        if (error || numAffectedRequestTypes !== undefined && numAffectedRequestTypes > 0) {
            // If request types are assigned to the work category, we need to show the disable modal to confirm they will be moved to unassigned before disabling the feature
            setIsDisableModalOpen(true);
            setNumAffectedRT(numAffectedRequestTypes);
            setAffectedRTError(error);
        } else update({
            feature: feature,
            enabled: false
        });
    }, [
        update
    ]);
    const practiceFeatures = (0, $imjKI.getPracticeFeatures)();
    const onConfirmDisable = (0, $eUqFw.useCallback)(()=>{
        update({
            feature: confirmFeature,
            enabled: false
        });
        setConfirmFeature('');
        setIsDisableModalOpen(false);
    }, [
        confirmFeature,
        update
    ]);
    const closeDisableModal = (0, $eUqFw.useCallback)(()=>{
        setRefocusElement(confirmFeature);
        setConfirmFeature('');
        setIsDisableModalOpen(false);
    }, [
        confirmFeature
    ]);
    (0, $eUqFw.useEffect)(()=>{
        refocusElement && setRefocusElement('');
    }, [
        refocusElement
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, practiceFeatures.map((feature)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $94zS7.default), {
            key: feature,
            feature: feature,
            saving: !!saving[feature],
            isEnabled: data?.[feature]?.status === (0, $89d8bb437c2044ff$export$e927a5d1b72f0b68),
            focusToggle: refocusElement === feature,
            onEnable: onEnable,
            onDisable: onDisable,
            ...(0, $1ybV0.ff)('enable_jsm_repackaging_changes_vtwk9') ? {
                hasPaymentError: !!paymentError[feature]
            } : {}
        })), isDisableModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3NHvN.AsyncConfirmDisableModal), {
        feature: confirmFeature,
        onClose: closeDisableModal,
        onConfirm: onConfirmDisable,
        numAffectedRequestTypes: numAffectedRT,
        affectedRequestTypesError: affectedRTError
    }));
});
var $5a40011d93e308c9$export$2e2bcd8739ae039 = $5a40011d93e308c9$var$PracticesFeatures;

});
parcelRegister("kSk4G", function(module, exports) {

$parcel$export(module.exports, "default", () => $9711bfbb4b238726$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $2futN = parcelRequire("2futN");

var $6bQqb = parcelRequire("6bQqb");

var $lB25E = parcelRequire("lB25E");

var $iPgVt = parcelRequire("iPgVt");

var $lPNLS = parcelRequire("lPNLS");
const $9711bfbb4b238726$var$usePracticeFeaturesController = ()=>{
    const { data: data, saving: saving, update: updateFeature } = (0, $iPgVt.default)();
    const { showSuccessFlag: showSuccessFlag, showErrorFlag: showErrorFlag } = (0, $lPNLS.default)();
    const { refresh: refreshPractices } = (0, $lB25E.useResource)((0, $6bQqb.servicedeskPracticesResource));
    const { refresh: refreshJSMNavigation } = (0, $2futN.useJiraServiceManagementProjectNavigation)();
    const [paymentError, setPaymentError] = (0, $eUqFw.useState)({});
    const update = (0, $eUqFw.useCallback)(({ feature: feature, enabled: enabled })=>{
        updateFeature({
            feature: feature,
            enabled: enabled,
            onSuccess: ()=>{
                refreshPractices();
                refreshJSMNavigation();
                showSuccessFlag(feature, enabled);
            },
            onFail: (error)=>{
                if ((0, $1ybV0.ff)('enable_jsm_repackaging_changes_vtwk9') && error.statusCode === 402) setPaymentError({
                    ...paymentError,
                    [feature]: true
                });
                else showErrorFlag(feature, enabled);
            }
        });
    }, [
        refreshPractices,
        refreshJSMNavigation,
        showErrorFlag,
        showSuccessFlag,
        updateFeature,
        paymentError
    ]);
    return {
        data: data,
        saving: saving,
        update: update,
        paymentError: paymentError
    };
};
var $9711bfbb4b238726$export$2e2bcd8739ae039 = $9711bfbb4b238726$var$usePracticeFeaturesController;

});
parcelRegister("lPNLS", function(module, exports) {

$parcel$export(module.exports, "default", () => $18097c3aa2992083$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $30Cw3 = parcelRequire("30Cw3");

var $eo17r = parcelRequire("eo17r");
var $k8Qyf = parcelRequire("k8Qyf");

var $kHK5i = parcelRequire("kHK5i");

var $lB25E = parcelRequire("lB25E");

var $HgZ0n = parcelRequire("HgZ0n");
const $18097c3aa2992083$var$useFlags = ()=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagsService)();
    const { push: push } = (0, $lB25E.useRouterActions)();
    const [projectKey = ''] = (0, $lB25E.usePathParam)('projectKey');
    const flagIdRef = (0, $eUqFw.useRef)({});
    return {
        showSuccessFlag: (0, $eUqFw.useCallback)((feature, enabled)=>{
            const featureMessageKey = (0, (/*@__PURE__*/$parcel$interopDefault($30Cw3)))(feature);
            const flagIdKey = `${feature}-service-feature-success`;
            const { current: flagIds } = flagIdRef;
            // toFlagId creates a new string reference. But we want to reuse
            // flag ids so the most relevant flag for a feature is shown
            flagIds[flagIdKey] = flagIds[flagIdKey] || (0, $eo17r.toFlagId)(flagIdKey);
            const id = flagIds[flagIdKey];
            const onClick = ()=>{
                dismissFlag(id);
            };
            // Dismiss previous flag with the same id. So user cannot
            // interact with out of update flags
            dismissFlag(id);
            showFlag({
                id: id,
                type: 'success',
                isAutoDismiss: !enabled,
                title: [
                    (0, $HgZ0n.default).successTitle,
                    {
                        feature: featureMessageKey,
                        value: enabled
                    }
                ],
                description: enabled ? (0, $HgZ0n.default).successEnableDescription : (0, $HgZ0n.default).successDisableDescription,
                actions: enabled ? [
                    {
                        content: (0, $HgZ0n.default).successEnableDismiss,
                        onClick: onClick
                    },
                    {
                        content: (0, $HgZ0n.default).successEnableAction,
                        onClick: ()=>{
                            const practiceUrlFragment = `/category/${(0, $kHK5i.toShortFormItsmPractice)(feature)}`;
                            dismissFlag(id);
                            push(`/jira/servicedesk/projects/${projectKey}/settings/request-types${practiceUrlFragment}`);
                        }
                    }
                ] : [
                    {
                        content: (0, $HgZ0n.default).successDisableDismiss,
                        onClick: onClick
                    }
                ]
            });
        }, [
            dismissFlag,
            projectKey,
            push,
            showFlag
        ]),
        showErrorFlag: (0, $eUqFw.useCallback)((feature, enabled)=>{
            const featureMessageKey = (0, (/*@__PURE__*/$parcel$interopDefault($30Cw3)))(feature);
            const flagIdKey = `${feature}-service-feature-error`;
            const { current: flagIds } = flagIdRef;
            flagIds[flagIdKey] = flagIds[flagIdKey] || (0, $eo17r.toFlagId)(flagIdKey);
            const id = flagIds[flagIdKey];
            dismissFlag(id);
            showFlag({
                id: id,
                type: 'error',
                isAutoDismiss: true,
                title: [
                    (0, $HgZ0n.default).errorTitle,
                    {
                        feature: featureMessageKey,
                        value: enabled
                    }
                ],
                description: (0, $HgZ0n.default).errorDesciption,
                actions: [
                    {
                        content: (0, $HgZ0n.default).errorDismiss,
                        onClick: ()=>{
                            dismissFlag(id);
                        }
                    },
                    {
                        content: (0, $HgZ0n.default).errorAction,
                        onClick: ()=>{
                            window.location.reload();
                        }
                    }
                ]
            });
        }, [
            dismissFlag,
            showFlag
        ])
    };
};
var $18097c3aa2992083$export$2e2bcd8739ae039 = $18097c3aa2992083$var$useFlags;

});
parcelRegister("kHK5i", function(module, exports) {

$parcel$export(module.exports, "toShortFormItsmPractice", () => $3c2de4d4270495ab$export$db58a56259f511a2);

var $f1lMr = parcelRequire("f1lMr");
const $3c2de4d4270495ab$var$longToShortConversionMap = {
    [(0, $f1lMr.CHANGES)]: (0, $f1lMr.SHORT_FORM_CHANGES),
    [(0, $f1lMr.INCIDENTS)]: (0, $f1lMr.SHORT_FORM_INCIDENTS),
    [(0, $f1lMr.PROBLEMS)]: (0, $f1lMr.SHORT_FORM_PROBLEMS),
    [(0, $f1lMr.SERVICE_REQUEST)]: (0, $f1lMr.SHORT_FORM_SERVICE_REQUEST),
    [(0, $f1lMr.POST_INCIDENT_REVIEWS)]: (0, $f1lMr.SHORT_FORM_POST_INCIDENT_REVIEWS),
    [(0, $f1lMr.DEVELOPER_ESCALATION)]: (0, $f1lMr.SHORT_FORM_DEVELOPER_ESCALATION)
};
function $3c2de4d4270495ab$var$isLongForm(workCategoryKey) {
    return !!workCategoryKey && workCategoryKey in $3c2de4d4270495ab$var$longToShortConversionMap;
}
const $3c2de4d4270495ab$export$db58a56259f511a2 = (workCategoryKey)=>{
    if ($3c2de4d4270495ab$var$isLongForm(workCategoryKey)) return $3c2de4d4270495ab$var$longToShortConversionMap[workCategoryKey];
    return null;
};

});

parcelRegister("HgZ0n", function(module, exports) {

$parcel$export(module.exports, "default", () => $7813f1b9bec70d39$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7813f1b9bec70d39$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    successTitle: {
        "id": "servicedesk-itsm-features.controllers.practices.practice-features-controller.flags.success-title",
        "defaultMessage": "{feature, select,\n            service_request {Service request management}\n            incident_management {Incident management}\n            problem_management {Problem management}\n            change_management {Change management}\n            post_incident_review {Post-incident reviews}\n            other {unknown}\n        } {value, select, false {disabled} true {enabled} other {}}"
    },
    successEnableDescription: {
        "id": "servicedesk-itsm-features.controllers.practices.practice-features-controller.flags.success-enable-description",
        "defaultMessage": "Add request types to start using this category."
    },
    successDisableDescription: {
        "id": "servicedesk-itsm-features.controllers.practices.practice-features-controller.flags.success-disable-description",
        "defaultMessage": "You can enable this category again at any time."
    },
    successEnableDismiss: {
        "id": "servicedesk-itsm-features.controllers.practices.practice-features-controller.flags.success-enable-dismiss",
        "defaultMessage": "Maybe later"
    },
    successDisableDismiss: {
        "id": "servicedesk-itsm-features.controllers.practices.practice-features-controller.flags.success-disable-dismiss",
        "defaultMessage": "Ok"
    },
    successEnableAction: {
        "id": "servicedesk-itsm-features.controllers.practices.practice-features-controller.flags.success-enable-action",
        "defaultMessage": "Add request types"
    },
    errorTitle: {
        "id": "servicedesk-itsm-features.controllers.practices.practice-features-controller.flags.error-title",
        "defaultMessage": "We couldn't {value, select, false {disable} true {enable} other {}} {feature, select,\n            service_request {service requests}\n            incident_management {incident management}\n            problem_management {problem management}\n            change_management {change management}\n            post_incident_review {post-incident reviews}\n            other {unknown}\n        }"
    },
    errorDesciption: {
        "id": "servicedesk-itsm-features.controllers.practices.practice-features-controller.flags.error-desciption",
        "defaultMessage": "Refresh the page and try again."
    },
    errorDismiss: {
        "id": "servicedesk-itsm-features.controllers.practices.practice-features-controller.flags.error-dismiss",
        "defaultMessage": "Dismiss"
    },
    errorAction: {
        "id": "servicedesk-itsm-features.controllers.practices.practice-features-controller.flags.error-action",
        "defaultMessage": "Refresh"
    }
});

});



parcelRegister("3NHvN", function(module, exports) {

$parcel$export(module.exports, "AsyncConfirmDisableModal", () => $18ff8048c9f73ddf$export$605dbba7217e1592);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

const $18ff8048c9f73ddf$var$ConfirmDisableModal = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("jOaUU")), {
    moduleId: "./src/packages/servicedesk/itsm-features/src/ui/app/sections/service-project-section/practices-features/confirm-disable-modal/index.tsx"
});
const $18ff8048c9f73ddf$export$605dbba7217e1592 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-confirm-disable-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($18ff8048c9f73ddf$var$ConfirmDisableModal, props));

});
parcelRegister("jOaUU", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("kuoEY")
]).then(()=>parcelRequire('aR3WS'));

});


parcelRegister("94zS7", function(module, exports) {

$parcel$export(module.exports, "default", () => $8692cef32badff45$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ffiyv = parcelRequire("ffiyv");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $ijmuy = parcelRequire("ijmuy");

var $co8Ny = parcelRequire("co8Ny");

var $eCuTQ = parcelRequire("eCuTQ");

var $imjKI = parcelRequire("imjKI");

var $eWwQ7 = parcelRequire("eWwQ7");

var $9qPM9 = parcelRequire("9qPM9");
const $8692cef32badff45$var$Tile = ({ feature: feature, saving: saving, isEnabled: isEnabled, onEnable: onEnable, onDisable: onDisable, focusToggle: focusToggle, hasPaymentError: hasPaymentError })=>{
    const { illustration: illustration, title: title, description: description, learnMoreLink: learnMoreLink, detailsTitle: detailsTitle, details: details, automationSystemRules: automationSystemRules, inProductHelpArticleId: inProductHelpArticleId, descriptionForIPH: descriptionForIPH, learnMoreLinkText: learnMoreLinkText, learnMoreLinkClickEventName: learnMoreLinkClickEventName, popperText: popperText, isPremiumFeature: isPremiumFeature } = (0, $imjKI.FEATURE_CONFIG)[feature];
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isStartingDisable, setStartingDisable] = (0, $eUqFw.useState)(false);
    const { data: { numAffectedRequestTypes: numAffectedRequestTypes }, error: affectedRequestTypesError, fetch: fetchRequestTypes } = (0, $eCuTQ.default)(feature);
    (0, $eUqFw.useEffect)(()=>{
        if ((0, $1ybV0.ff)('enable_jsm_repackaging_changes_vtwk9')) {
            if (isStartingDisable && (numAffectedRequestTypes !== undefined || affectedRequestTypesError)) {
                setStartingDisable(false);
                onDisable(feature, numAffectedRequestTypes, affectedRequestTypesError);
            }
        } else // eslint-disable-next-line no-lonely-if
        if (numAffectedRequestTypes !== undefined || affectedRequestTypesError) {
            setStartingDisable(false);
            onDisable(feature, numAffectedRequestTypes, affectedRequestTypesError);
        }
    }, [
        affectedRequestTypesError,
        feature,
        numAffectedRequestTypes,
        isStartingDisable,
        onDisable
    ]);
    const disable = (0, $eUqFw.useCallback)(()=>{
        setStartingDisable(true);
        fetchRequestTypes();
    }, [
        setStartingDisable,
        fetchRequestTypes
    ]);
    const handleOnChange = (selectedFeature, enabled, analyticEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticEvent, 'settingsToggle', {
            field: feature
        });
        if (enabled) onEnable(selectedFeature);
        else disable();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $co8Ny.FeatureToggleTile), {
        key: feature,
        feature: feature,
        title: formatMessage(title),
        value: isEnabled,
        saving: saving || isStartingDisable,
        onChange: handleOnChange,
        focusToggle: focusToggle,
        illustration: illustration,
        ...(0, $1ybV0.ff)('enable_jsm_repackaging_changes_vtwk9') ? {
            tooltip: popperText,
            isPopperOpenByDefault: hasPaymentError,
            disabled: hasPaymentError
        } : {},
        ...(0, $1ybV0.ff)('enable_jsm_repackaging_changes_vtwk9') && isPremiumFeature ? {
            badge: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
                appearance: "new"
            }, formatMessage((0, $9qPM9.default).premiumLozenge))
        } : {}
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eWwQ7.default), {
        description: description,
        learnMoreLink: learnMoreLink,
        inProductHelpArticleId: inProductHelpArticleId,
        descriptionForIPH: descriptionForIPH,
        learnMoreLinkText: learnMoreLinkText,
        learnMoreLinkClickEventName: learnMoreLinkClickEventName
    }), details && detailsTitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ijmuy.DetailsList), {
        title: formatMessage(detailsTitle),
        messages: details,
        automationSystemRules: automationSystemRules
    }));
};
var $8692cef32badff45$export$2e2bcd8739ae039 = $8692cef32badff45$var$Tile;

});
parcelRegister("ijmuy", function(module, exports) {

$parcel$export(module.exports, "DetailsList", () => $a683e6db6e800fad$export$bdef74da83342439);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $fCmfi = parcelRequire("fCmfi");

var $ibyhG = parcelRequire("ibyhG");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");


var $5JgJ2 = parcelRequire("5JgJ2");

var $irsgl = parcelRequire("irsgl");
const $a683e6db6e800fad$export$bdef74da83342439 = /*#__PURE__*/ (0, $eUqFw.memo)(({ title: title, messages: messages, automationSystemRules: automationSystemRules })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [expanded, setExpanded] = (0, $eUqFw.useState)(false);
    const handleOnClick = ()=>{
        setExpanded((prevState)=>!prevState);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $a683e6db6e800fad$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle-link",
        spacing: "none",
        iconBefore: expanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $a683e6db6e800fad$var$iconWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ibyhG))), {
            label: formatMessage((0, $irsgl.default).expandedIconLabel),
            color: `var(--ds-icon, ${(0, $73a5c9d720aa66e1$exports).N800})`
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $a683e6db6e800fad$var$iconWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fCmfi))), {
            label: formatMessage((0, $irsgl.default).collapsedIconLabel),
            color: `var(--ds-icon, ${(0, $73a5c9d720aa66e1$exports).N800})`
        })),
        onClick: handleOnClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a683e6db6e800fad$var$Title, null, title)), expanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a683e6db6e800fad$var$List, {
        "data-testid": "servicedesk-itsm-features.common.ui.details-list.list"
    }, automationSystemRules && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("li", {
        key: (0, $irsgl.default).automationDetails.id
    }, formatMessage((0, $irsgl.default).automationDetails)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("ul", null, automationSystemRules.map((automation)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("li", {
            key: automation.id
        }, formatMessage(automation))))), messages.map((message)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("li", {
            key: message.id
        }, formatMessage(message)))));
});
const $a683e6db6e800fad$var$wrapperStyles = (0, $1ZAYh.xcss)({
    marginTop: 'space.200',
    marginLeft: 'space.negative.100'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a683e6db6e800fad$var$Title = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1aqp _vwz41tcg",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a683e6db6e800fad$var$List = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0pxbi",
            __cmplp.className
        ])
    });
});
const $a683e6db6e800fad$var$iconWrapperStyles = (0, $1ZAYh.xcss)({
    width: '24px'
});

});
parcelRegister("irsgl", function(module, exports) {

$parcel$export(module.exports, "default", () => $0557f0b346adae61$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $0557f0b346adae61$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    collapsedIconLabel: {
        "id": "servicedesk-itsm-features.common.details-list.collapsed-icon-label",
        "defaultMessage": "Details collapsed"
    },
    expandedIconLabel: {
        "id": "servicedesk-itsm-features.common.details-list.expanded-icon-label",
        "defaultMessage": "Details expanded"
    },
    automationDetails: {
        "id": "servicedesk-itsm-features.common.details-list.automation-details",
        "defaultMessage": "Automation Rules:"
    }
});

});


parcelRegister("imjKI", function(module, exports) {

$parcel$export(module.exports, "getPracticeFeatures", () => $24cdb0c5a47eb278$export$febc564106282658);
$parcel$export(module.exports, "FEATURE_CONFIG", () => $24cdb0c5a47eb278$export$d1c784b8ca09de21);

var $eUqFw = parcelRequire("eUqFw");

var $7Ls9Q = parcelRequire("7Ls9Q");

var $lOG94 = parcelRequire("lOG94");

var $k26I8 = parcelRequire("k26I8");

var $isUra = parcelRequire("isUra");

var $dTq6i = parcelRequire("dTq6i");


var $9qPM9 = parcelRequire("9qPM9");

var $jSIEd = parcelRequire("jSIEd");
const $24cdb0c5a47eb278$export$2fb95653399533d0 = [
    (0, $89d8bb437c2044ff$export$a364d86306d4a6d4),
    (0, $89d8bb437c2044ff$export$31ffe79c2b019cf),
    (0, $89d8bb437c2044ff$export$3a20074cc38cbf69),
    (0, $89d8bb437c2044ff$export$cae2404f62c0f4d7)
];
const $24cdb0c5a47eb278$export$febc564106282658 = ()=>[
        (0, $89d8bb437c2044ff$export$a364d86306d4a6d4),
        (0, $89d8bb437c2044ff$export$31ffe79c2b019cf),
        (0, $89d8bb437c2044ff$export$3a20074cc38cbf69),
        (0, $89d8bb437c2044ff$export$cae2404f62c0f4d7),
        (0, $89d8bb437c2044ff$export$71f1a79e03f525)
    ];
const $24cdb0c5a47eb278$export$d1c784b8ca09de21 = {
    [(0, $89d8bb437c2044ff$export$a364d86306d4a6d4)]: {
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dTq6i.default), {
            alt: ""
        }),
        title: (0, $9qPM9.default).serviceRequestManagementTitle,
        description: (0, $9qPM9.default).serviceRequestManagementDescription,
        learnMoreLink: 'https://support.atlassian.com/jira-service-management-cloud/docs/what-are-service-requests/',
        inProductHelpArticleId: 'KQWczajRKJY4szPR8IYSq',
        descriptionForIPH: (0, $9qPM9.default).serviceRequestManagementDescriptionForIph,
        learnMoreLinkText: (0, $9qPM9.default).serviceRequestManagementLearnMore,
        learnMoreLinkClickEventName: 'learnMoreAboutServiceRequest',
        detailsTitle: (0, $9qPM9.default).serviceRequestDetailsTitle,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        details: [
            (0, $9qPM9.default).serviceRequestDetail1
        ]
    },
    [(0, $89d8bb437c2044ff$export$31ffe79c2b019cf)]: {
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k26I8.default), {
            alt: ""
        }),
        title: (0, $9qPM9.default).incidentManagementTitle,
        description: (0, $9qPM9.default).incidentManagementDescription,
        learnMoreLink: 'https://support.atlassian.com/jira-service-management-cloud/docs/what-are-incidents/',
        inProductHelpArticleId: '7FKGuAquLRrlRsNOmESYQp',
        descriptionForIPH: (0, $9qPM9.default).incidentManagementDescriptionForInProductHelp,
        learnMoreLinkText: (0, $9qPM9.default).incidentManagementLearnMore,
        learnMoreLinkClickEventName: 'learnMoreAboutIncidentManagement',
        detailsTitle: (0, $9qPM9.default).incidentManagementDetailsTitle,
        details: [
            (0, $9qPM9.default).incidentManagementDetail1,
            (0, $9qPM9.default).incidentManagementDetail2,
            (0, $9qPM9.default).incidentManagementDetail3
        ]
    },
    [(0, $89d8bb437c2044ff$export$3a20074cc38cbf69)]: {
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $isUra.default), {
            alt: ""
        }),
        title: (0, $9qPM9.default).problemManagementTitle,
        description: (0, $9qPM9.default).problemManagementDescription,
        learnMoreLink: 'https://support.atlassian.com/jira-service-management-cloud/docs/what-are-problems/',
        inProductHelpArticleId: '1UdImCpAUfqaJX6qQcVnZ3',
        descriptionForIPH: (0, $9qPM9.default).problemManagementDescriptionForInProductHelp,
        learnMoreLinkText: (0, $9qPM9.default).problemManagementLearnMore,
        learnMoreLinkClickEventName: 'learnMoreAboutProblemManagement',
        detailsTitle: (0, $9qPM9.default).problemManagementDetailsTitle,
        details: [
            (0, $9qPM9.default).problemManagementDetail1,
            (0, $9qPM9.default).problemManagementDetail2,
            (0, $9qPM9.default).problemManagementDetail3
        ],
        popperText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jSIEd.UpgradePlanContent), {
            feature: "problemManagement"
        }),
        isPremiumFeature: true
    },
    [(0, $89d8bb437c2044ff$export$cae2404f62c0f4d7)]: {
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lOG94.default), {
            alt: ""
        }),
        title: (0, $9qPM9.default).changeManagementTitle,
        description: (0, $9qPM9.default).changeManagementDescription,
        learnMoreLink: 'https://support.atlassian.com/jira-service-management-cloud/docs/what-are-changes/',
        inProductHelpArticleId: '7Mj1hWXgoQdMOcnAFuZGfb',
        descriptionForIPH: (0, $9qPM9.default).changeManagementDescriptionForInProductHelp,
        learnMoreLinkText: (0, $9qPM9.default).changeManagementLearnMore,
        learnMoreLinkClickEventName: 'learnMoreAboutChangeManagement',
        detailsTitle: (0, $9qPM9.default).changeManagementDetailsTitle,
        popperText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jSIEd.UpgradePlanContent), {
            feature: "changeManagement"
        }),
        details: [
            (0, $9qPM9.default).changeManagementDetail1,
            (0, $9qPM9.default).changeManagementDetail2,
            (0, $9qPM9.default).changeManagementDetail3
        ],
        automationSystemRules: [
            (0, $9qPM9.default).changeManagementAutomation1,
            (0, $9qPM9.default).changeManagementAutomation2
        ],
        isPremiumFeature: true
    },
    [(0, $89d8bb437c2044ff$export$71f1a79e03f525)]: {
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Ls9Q.default), {
            alt: ""
        }),
        title: (0, $9qPM9.default).postIncidentReviewsTitle,
        description: (0, $9qPM9.default).postIncidentReviewsDescription,
        learnMoreLink: 'https://support.atlassian.com/jira-service-management-cloud/docs/what-are-post-incident-reviews/',
        detailsTitle: undefined,
        details: undefined,
        inProductHelpArticleId: '3e1FLCRCpBoQjPXeBydIx5',
        descriptionForIPH: (0, $9qPM9.default).postIncidentReviewsDescriptionForInProductHelp,
        learnMoreLinkText: (0, $9qPM9.default).learnMoreAboutPostIncidentReviews,
        learnMoreLinkClickEventName: 'learnMoreAboutPostIncidentReviews',
        popperText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jSIEd.UpgradePlanContent), {
            feature: "postIncidentReview"
        }),
        isPremiumFeature: true
    }
};

});
parcelRegister("7Ls9Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c24b0524c126e97$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = 9v9sn9fb8xtwqtkgf39nrb5
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/9v9sn9fb8xtwqtkgf39nrb5

var $9TZf5 = parcelRequire("9TZf5");

var $twnq2 = parcelRequire("twnq2");
const $6c24b0524c126e97$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($twnq2)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($twnq2))
});
var $6c24b0524c126e97$export$2e2bcd8739ae039 = $6c24b0524c126e97$var$Illustration;
// for advanced use only
const $6c24b0524c126e97$export$a179c88182cb9d56 = [
    0,
    0,
    202,
    211
];

});
parcelRegister("twnq2", function(module, exports) {
module.exports = new URL("page-search.2a20ac44.svg", import.meta.url).toString();

});


parcelRegister("lOG94", function(module, exports) {

$parcel$export(module.exports, "default", () => $2dbb8c08c72c292a$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $9TZf5 = parcelRequire("9TZf5");

var $318mi = parcelRequire("318mi");
const $2dbb8c08c72c292a$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($318mi)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($318mi))
});
var $2dbb8c08c72c292a$export$2e2bcd8739ae039 = $2dbb8c08c72c292a$var$Illustration;
// for advanced use only
const $2dbb8c08c72c292a$export$a179c88182cb9d56 = [
    0,
    0,
    64,
    64
];

});
parcelRegister("318mi", function(module, exports) {
module.exports = new URL("jsm-change-management.c2f0cbc4.svg", import.meta.url).toString();

});


parcelRegister("k26I8", function(module, exports) {

$parcel$export(module.exports, "default", () => $6993423e659acb47$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $9TZf5 = parcelRequire("9TZf5");

var $2YSY2 = parcelRequire("2YSY2");
const $6993423e659acb47$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($2YSY2)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($2YSY2))
});
var $6993423e659acb47$export$2e2bcd8739ae039 = $6993423e659acb47$var$Illustration;
// for advanced use only
const $6993423e659acb47$export$a179c88182cb9d56 = [
    0,
    0,
    64,
    64
];

});
parcelRegister("2YSY2", function(module, exports) {
module.exports = new URL("jsm-incident-management.dd18be0a.svg", import.meta.url).toString();

});


parcelRegister("isUra", function(module, exports) {

$parcel$export(module.exports, "default", () => $65e6c6f388812a73$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $9TZf5 = parcelRequire("9TZf5");

var $8tawC = parcelRequire("8tawC");
const $65e6c6f388812a73$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($8tawC)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($8tawC))
});
var $65e6c6f388812a73$export$2e2bcd8739ae039 = $65e6c6f388812a73$var$Illustration;
// for advanced use only
const $65e6c6f388812a73$export$a179c88182cb9d56 = [
    0,
    0,
    64,
    64
];

});
parcelRegister("8tawC", function(module, exports) {
module.exports = new URL("jsm-problem-management.d69d01e4.svg", import.meta.url).toString();

});


parcelRegister("dTq6i", function(module, exports) {

$parcel$export(module.exports, "default", () => $52e6fc274c9716b6$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $9TZf5 = parcelRequire("9TZf5");

var $1aBvn = parcelRequire("1aBvn");
const $52e6fc274c9716b6$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($1aBvn)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($1aBvn))
});
var $52e6fc274c9716b6$export$2e2bcd8739ae039 = $52e6fc274c9716b6$var$Illustration;
// for advanced use only
const $52e6fc274c9716b6$export$a179c88182cb9d56 = [
    0,
    0,
    64,
    64
];

});
parcelRegister("1aBvn", function(module, exports) {
module.exports = new URL("jsm-service-request.b423594a.svg", import.meta.url).toString();

});


parcelRegister("9qPM9", function(module, exports) {

$parcel$export(module.exports, "default", () => $5611964a721210c5$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $5611964a721210c5$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    serviceRequestManagementTitle: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.service-request-management-title",
        "defaultMessage": "Service request management"
    },
    serviceRequestManagementDescription: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.service-request-management-description",
        "defaultMessage": "Streamline your request management workflow with a dedicated service request queue that helps you deliver great service experiences.\n            <a target=\"_blank\" href=\"{href}\">Learn more about service requests</a>."
    },
    serviceRequestManagementDescriptionForIph: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.service-request-management-description-for-iph",
        "defaultMessage": "Streamline your request management workflow with a dedicated service request queue that helps you deliver great service experiences.\n            {learnMoreLink}"
    },
    serviceRequestManagementLearnMore: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.service-request-management-learn-more",
        "defaultMessage": "Learn more about service requests."
    },
    serviceRequestDetailsTitle: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.service-request-details-title",
        "defaultMessage": "Service request management features"
    },
    serviceRequestDetail1: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.service-request-detail-1",
        "defaultMessage": "Dedicated service request queue in your project's sidebar"
    },
    incidentManagementTitle: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.incident-management-title",
        "defaultMessage": "Incident management"
    },
    incidentManagementDescription: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.incident-management-description",
        "defaultMessage": "\n            <p>\n                Enable your agents to respond fast when an incident occurs so they can restore disrupted services and fix vulnerabilities.\n                <a target=\"_blank\" href=\"{href}\">Learn more about incident management</a>.\n            </p>\n            <p>To access all incident management features, make sure Services, On-Call and Alerts are enabled.</p>"
    },
    incidentManagementDescriptionForInProductHelp: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.incident-management-description-for-in-product-help",
        "defaultMessage": "Enable your agents to respond fast when an incident occurs so they can restore disrupted services and fix vulnerabilities. {learnMoreLink} {br}To access all incident management features, make sure Services, On-Call and Alerts are enabled."
    },
    incidentManagementLearnMore: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.incident-management-learn-more",
        "defaultMessage": "Learn more about incident management."
    },
    incidentManagementDetailsTitle: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.incident-management-details-title",
        "defaultMessage": "Incident management features"
    },
    incidentManagementDetail1: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.incident-management-detail-1",
        "defaultMessage": "Customizable on-call schedules, routing rules, and escalation policies to handle alerts based on source and urgency"
    },
    incidentManagementDetail2: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.incident-management-detail-2",
        "defaultMessage": "Incident timeline, conference calls and chat tools for real-time updates and collaboration"
    },
    incidentManagementDetail3: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.incident-management-detail-3",
        "defaultMessage": "Incident notification policies based on user preferences, with alerts by email, voice call, SMS, or push notification"
    },
    problemManagementTitle: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.problem-management-title",
        "defaultMessage": "Problem management"
    },
    problemManagementDescription: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.problem-management-description",
        "defaultMessage": "\n          <p>\n            Help your team prevent recurring incidents and service disruptions with tools that allow them to discover the potential cause of service vulnerabilities.\n            <a target=\"_blank\" href=\"{href}\">Learn more about problem management</a>.\n          </p>\n          <p>To access all problem management features, make sure Services is enabled.</p>"
    },
    problemManagementDescriptionForInProductHelp: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.problem-management-description-for-in-product-help",
        "defaultMessage": "Help your team prevent recurring incidents and service disruptions with tools that allow them to discover the potential cause of service vulnerabilities.{learnMoreLink} {br}To access all problem management features, make sure Services is enabled."
    },
    problemManagementLearnMore: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.problem-management-learn-more",
        "defaultMessage": "Learn more about problem management."
    },
    problemManagementDetailsTitle: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.problem-management-details-title",
        "defaultMessage": "Problem management features"
    },
    problemManagementDetail1: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.problem-management-detail-1",
        "defaultMessage": "Problem logging for post-incident reviews"
    },
    problemManagementDetail2: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.problem-management-detail-2",
        "defaultMessage": "Root-cause investigation workflows"
    },
    problemManagementDetail3: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.problem-management-detail-3",
        "defaultMessage": "Incident grouping and linking"
    },
    changeManagementTitle: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.change-management-title",
        "defaultMessage": "Change management"
    },
    changeManagementDescription: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.change-management-description",
        "defaultMessage": "\n            <p>\n                Speed up service delivery and minimize deployment risk by allowing your team to flag, review, and approve changes before they can impact your services.\n                <a target=\"_blank\" href=\"{href}\">Learn more about change management</a>.\n            </p>\n            <p>To access all change management features, make sure Services is enabled.</p>"
    },
    changeManagementDescriptionForInProductHelp: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.change-management-description-for-in-product-help",
        "defaultMessage": "Speed up service delivery and minimize deployment risk by allowing your team to flag, review, and approve changes before they can impact your services.{learnMoreLink} {br}To access all change management features, make sure Services is enabled."
    },
    changeManagementLearnMore: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.change-management-learn-more",
        "defaultMessage": "Learn more about change management."
    },
    changeManagementDetailsTitle: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.change-management-details-title",
        "defaultMessage": "Change management features"
    },
    changeManagementDetail1: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.change-management-detail-1",
        "defaultMessage": "Automated risk assessments and low-risk deployments"
    },
    changeManagementDetail2: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.change-management-detail-2",
        "defaultMessage": "Advanced approval workflows"
    },
    changeManagementDetail3: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.change-management-detail-3",
        "defaultMessage": "Integrations with CI/CD tools for affected service and deployment tracking"
    },
    postIncidentReviewsTitle: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.post-incident-reviews-title",
        "defaultMessage": "Post-incident reviews"
    },
    postIncidentReviewsDescription: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.post-incident-reviews-description",
        "defaultMessage": "\n                Document and share learnings from an incident so that it doesn\u2019t happen again.\n                <a target=\"_blank\" href=\"{href}\">Learn more about post-incident reviews</a>.\n            </p>"
    },
    postIncidentReviewsDescriptionForInProductHelp: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.post-incident-reviews-description-for-in-product-help",
        "defaultMessage": "Post-incident reviews help you understand the causes and impacts of incidents so that you can reduce the chance of the incident happening again. {learnMoreLink}"
    },
    learnMoreAboutPostIncidentReviews: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.learn-more-about-post-incident-reviews",
        "defaultMessage": "Learn more about post-incident reviews."
    },
    changeManagementAutomation1: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.change-management-automation-1",
        "defaultMessage": "When a change request is created \u2192 then attach the default change management form"
    },
    changeManagementAutomation2: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.change-management-automation-2",
        "defaultMessage": "When a deployment is completed, failed or canceled \u2192 then transition request accordingly"
    },
    premiumLozenge: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.premium-lozenge",
        "defaultMessage": "Premium"
    }
});

});

parcelRegister("jSIEd", function(module, exports) {

$parcel$export(module.exports, "UpgradePlanContent", () => $6bb128d649a5a6f0$export$7b991f11f365aa);

var $eUqFw = parcelRequire("eUqFw");

var $5OdZ3 = parcelRequire("5OdZ3");

var $1zbEq = parcelRequire("1zbEq");
var $1Yimi = parcelRequire("1Yimi");

var $67MTZ = parcelRequire("67MTZ");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $dWLk9 = parcelRequire("dWLk9");

var $8iiIt = parcelRequire("8iiIt");
const $6bb128d649a5a6f0$var$buildUTMParameters = (feature)=>new URLSearchParams({
        utm_campaign: 'JSM-repackaging-upsells',
        utm_source: 'features-page',
        utm_medium: 'product',
        utm_content: `${feature}-toggle`
    });
const $6bb128d649a5a6f0$export$7b991f11f365aa = ({ feature: feature })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const handleLinkClick = (_, analyticEvent)=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/71212
        (0, $jMP2a.fireUIAnalytics)(analyticEvent, 'featureTilePaymentPopoverCta', {
            feature: feature
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), null, formatMessage((0, $8iiIt.default).description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5OdZ3.default), {
        href: `${(0, $67MTZ.getAdminBaseUrl)()}/s/${cloudId}/billing/applications/change-edition/jira-servicedesk.ondemand?${$6bb128d649a5a6f0$var$buildUTMParameters(feature)}`,
        target: "_blank",
        onClick: handleLinkClick,
        onMouseDown: (e)=>{
            e.preventDefault();
        }
    }, formatMessage((0, $8iiIt.default).ctaLink)));
};

});
parcelRegister("8iiIt", function(module, exports) {

$parcel$export(module.exports, "default", () => $02116c6a83666c41$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $02116c6a83666c41$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    description: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.upgrade-plan-content.description",
        "defaultMessage": "Upgrade to a Premium or Enterprise plan to use this feature."
    },
    ctaLink: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.upgrade-plan-content.cta-link",
        "defaultMessage": "Upgrade now"
    }
});

});



parcelRegister("eWwQ7", function(module, exports) {

$parcel$export(module.exports, "default", () => $0eba8e77a7702d13$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3QLcd = parcelRequire("3QLcd");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");
const $0eba8e77a7702d13$var$FeatureDescription = ({ description: description, learnMoreLink: learnMoreLink, inProductHelpArticleId: inProductHelpArticleId, descriptionForIPH: descriptionForIPH, learnMoreLinkText: learnMoreLinkText, learnMoreLinkClickEventName: learnMoreLinkClickEventName })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const descriptionMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...description,
        values: {
            href: learnMoreLink
        }
    });
    if (inProductHelpArticleId && learnMoreLinkText) {
        const fallBackLink = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
            target: "_blank",
            href: learnMoreLink
        }, formatMessage(learnMoreLinkText));
        const inProductHelpLink = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3QLcd.default), {
            appearance: "link",
            spacing: "none",
            articleId: inProductHelpArticleId,
            fallbackComponent: fallBackLink,
            onClick: ()=>(0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'helpLink clicked', learnMoreLinkClickEventName, {
                    articleId: inProductHelpArticleId
                })
        }, formatMessage(learnMoreLinkText));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...descriptionForIPH,
            values: {
                learnMoreLink: inProductHelpLink,
                br: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null))
            }
        });
    }
    return descriptionMessage;
};
var $0eba8e77a7702d13$export$2e2bcd8739ae039 = $0eba8e77a7702d13$var$FeatureDescription;

});



parcelRegister("jArhm", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfe656fc969aaf55$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6zOB7 = parcelRequire("6zOB7");

var $iw0Y6 = parcelRequire("iw0Y6");

var $5OdZ3 = parcelRequire("5OdZ3");

var $ffiyv = parcelRequire("ffiyv");

var $b5IAe = parcelRequire("b5IAe");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $dnJL9 = parcelRequire("dnJL9");

var $eI5EY = parcelRequire("eI5EY");

var $eo17r = parcelRequire("eo17r");
var $k8Qyf = parcelRequire("k8Qyf");

var $3QLcd = parcelRequire("3QLcd");

var $kC1OV = parcelRequire("kC1OV");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");


var $co8Ny = parcelRequire("co8Ny");

var $fJdKO = parcelRequire("fJdKO");

var $iPgVt = parcelRequire("iPgVt");

var $eNeGC = parcelRequire("eNeGC");

var $8S0BR = parcelRequire("8S0BR");
const $bfe656fc969aaf55$var$VIEWS_DOCUMENTATION_URL = 'https://support.atlassian.com/jira-service-management-cloud/docs/manage-your-work-using-a-board/';
const $bfe656fc969aaf55$var$VIEWS_HELP_ARTICLE_ID = '103YhAB4GHpQvY8MAc0Q2r';
const $bfe656fc969aaf55$var$ViewsFeatures = /*#__PURE__*/ (0, $eUqFw.memo)(()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { data: data, saving: saving, update: update } = (0, $iPgVt.default)();
    const showSaveErrorFlag = (0, $fJdKO.default)();
    const flagIdRef = (0, $eUqFw.useRef)({});
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagsService)();
    const [showViewsSettings, setShowViewsSettings] = (0, $eUqFw.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onViewsToggleSuccess = (0, $eUqFw.useCallback)(({ enabled: enabled })=>{
        const flagIdKey = 'views-service-feature-success';
        const { current: flagIds } = flagIdRef;
        flagIds[flagIdKey] = flagIds[flagIdKey] || (0, $eo17r.toFlagId)(flagIdKey);
        const flagId = flagIds[flagIdKey];
        const onDismiss = ()=>{
            dismissFlag(flagId);
        };
        // Dismiss previous flag with the same id
        dismissFlag(flagId);
        showFlag({
            id: flagId,
            type: 'success',
            title: [
                (0, $8S0BR.default).viewsFlagSuccessTitle,
                {
                    value: enabled
                }
            ],
            description: enabled ? (0, $8S0BR.default).viewsEnabledSuccessFlagDescription : (0, $8S0BR.default).viewsDisabledSuccessFlagDescription,
            actions: [
                {
                    content: enabled ? (0, $8S0BR.default).viewsFeatureSuccessEnableAction : (0, $8S0BR.default).viewsFeatureSuccessDisableAction,
                    onClick: ()=>{
                        onDismiss();
                    }
                }
            ]
        });
    }, [
        dismissFlag,
        showFlag
    ]);
    const onViewsToggleError = (0, $eUqFw.useCallback)(({ enabled: enabled })=>{
        showSaveErrorFlag(formatMessage((0, $8S0BR.default).viewsTitle), enabled, {
            errorTitle: (0, $8S0BR.default).enabledErrorTitleForViews,
            errorDescription: (0, $8S0BR.default).saveErrorDescription
        });
    }, [
        showSaveErrorFlag,
        formatMessage
    ]);
    const onViewsChange = async (features, enabled, analyticEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticEvent, 'settingsToggle', {
            field: (0, $89d8bb437c2044ff$export$93b42272f76473c9)
        });
        let hasError = false;
        await Promise.all(features.map((feature)=>new Promise((resolve)=>{
                update({
                    feature: feature,
                    enabled: enabled,
                    onFail: ()=>{
                        hasError = true;
                        resolve(null);
                    },
                    onSuccess: ()=>{
                        resolve(null);
                    }
                });
            })));
        if (hasError) {
            // Revert the changes if there was an error
            await Promise.all(features.map((feature)=>new Promise((resolve)=>{
                    update({
                        feature: feature,
                        enabled: !enabled,
                        onFail: ()=>{
                            resolve(null);
                        },
                        onSuccess: ()=>{
                            resolve(null);
                        }
                    });
                })));
            onViewsToggleError({
                enabled: enabled
            });
        } else onViewsToggleSuccess({
            enabled: enabled
        });
    };
    const onViewsSettingsClick = ()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'openViewsSettingsModal');
        setShowViewsSettings(true);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $co8Ny.FeaturesToggleTile), {
        features: [
            (0, $89d8bb437c2044ff$export$1eb399d8c2d53748),
            (0, $89d8bb437c2044ff$export$abbcecf25bfa1e87)
        ],
        title: formatMessage((0, $8S0BR.default).viewsTitle),
        badge: (0, $eI5EY.fg)('jsm_views_of_work_new_lozenge') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
            appearance: "new"
        }, formatMessage((0, $8S0BR.default).newLozenge)),
        value: data?.[0, $89d8bb437c2044ff$export$1eb399d8c2d53748]?.status === (0, $89d8bb437c2044ff$export$e927a5d1b72f0b68) || data?.[0, $89d8bb437c2044ff$export$abbcecf25bfa1e87]?.status === (0, $89d8bb437c2044ff$export$e927a5d1b72f0b68),
        saving: saving[0, $89d8bb437c2044ff$export$1eb399d8c2d53748] || saving[0, $89d8bb437c2044ff$export$abbcecf25bfa1e87],
        onChange: onViewsChange,
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kC1OV.default), {
            alt: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $8S0BR.default).viewsDescription,
        values: {
            b: (chunk)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
                    weight: "bold"
                }, chunk),
            link: (chunk)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3QLcd.default), {
                    articleId: $bfe656fc969aaf55$var$VIEWS_HELP_ARTICLE_ID,
                    appearance: "link",
                    spacing: "none",
                    fallbackComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5OdZ3.default), {
                        href: $bfe656fc969aaf55$var$VIEWS_DOCUMENTATION_URL,
                        target: "_blank"
                    }, chunk),
                    onClick: ()=>(0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'helpLink clicked', 'learnMoreAboutJsmViews', {
                            articleId: $bfe656fc969aaf55$var$VIEWS_HELP_ARTICLE_ID
                        })
                }, chunk)
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $bfe656fc969aaf55$var$buttonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($iw0Y6))),
        onClick: onViewsSettingsClick
    }, formatMessage((0, $8S0BR.default).selectViewsButton)), showViewsSettings && // TODO: Implement the settings modal
    /* <AsyncViewsSettings
      	onClose={() => setShowViewsSettings(false)}
      /> */ null));
});
const $bfe656fc969aaf55$var$buttonWrapperStyles = (0, $1ZAYh.xcss)({
    marginTop: 'space.100'
});
var $bfe656fc969aaf55$export$2e2bcd8739ae039 = (0, $dnJL9.componentWithFG)('jsm_views_of_work_phase_1', $bfe656fc969aaf55$var$ViewsFeatures, (0, $eNeGC.default));

});
parcelRegister("kC1OV", function(module, exports) {

$parcel$export(module.exports, "default", () => $898d4808e47a23c5$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $9TZf5 = parcelRequire("9TZf5");

var $HDx8X = parcelRequire("HDx8X");

var $6YpUc = parcelRequire("6YpUc");
const $898d4808e47a23c5$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($6YpUc)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($HDx8X))
});
var $898d4808e47a23c5$export$2e2bcd8739ae039 = $898d4808e47a23c5$var$Illustration;
// for advanced use only
const $898d4808e47a23c5$export$a179c88182cb9d56 = [
    0,
    0,
    199,
    243
];

});
parcelRegister("HDx8X", function(module, exports) {
module.exports = new URL("clipboard-darkmode.ede97435.svg", import.meta.url).toString();

});

parcelRegister("6YpUc", function(module, exports) {
module.exports = new URL("clipboard.1dbaa4d8.svg", import.meta.url).toString();

});


parcelRegister("eNeGC", function(module, exports) {

$parcel$export(module.exports, "default", () => $6afbbadf7833ad6c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ffiyv = parcelRequire("ffiyv");

var $1Yimi = parcelRequire("1Yimi");

var $1ybV0 = parcelRequire("1ybV0");

var $eo17r = parcelRequire("eo17r");
var $k8Qyf = parcelRequire("k8Qyf");

var $3QLcd = parcelRequire("3QLcd");

var $b7RZi = parcelRequire("b7RZi");

var $cvLHp = parcelRequire("cvLHp");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $2futN = parcelRequire("2futN");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");


var $lB25E = parcelRequire("lB25E");

var $ksHP7 = parcelRequire("ksHP7");

var $co8Ny = parcelRequire("co8Ny");

var $fJdKO = parcelRequire("fJdKO");

var $iPgVt = parcelRequire("iPgVt");

var $4jD3Z = parcelRequire("4jD3Z");

var $8S0BR = parcelRequire("8S0BR");
const $6afbbadf7833ad6c$var$getLaunchUrl = (projectKey, boardId, feature)=>{
    switch(feature){
        case 0, $89d8bb437c2044ff$export$abbcecf25bfa1e87:
            return `/jira/servicedesk/projects/${projectKey}/boards/${boardId}/calendar`;
        case 0, $89d8bb437c2044ff$export$1eb399d8c2d53748:
            return `/jira/servicedesk/projects/${projectKey}/boards/${boardId}`;
        default:
            return `/jira/servicedesk/projects/${projectKey}`;
    }
};
const $6afbbadf7833ad6c$var$successFlagMessages = (feature, enabled)=>{
    const flagMessages = {
        [(0, $89d8bb437c2044ff$export$abbcecf25bfa1e87)]: {
            enabled: {
                title: (0, $8S0BR.default).calendarFlagSuccessTitle,
                description: (0, $8S0BR.default).calendarEnabledSuccessFlagDescription,
                actionDescription: (0, $8S0BR.default).calendarFeatureSuccessEnableAction
            },
            disabled: {
                title: (0, $8S0BR.default).calendarFlagSuccessTitle,
                description: (0, $8S0BR.default).calendarDisabledSuccessFlagDescription,
                actionDescription: (0, $8S0BR.default).calendarFeatureSuccessDisableDismiss
            }
        },
        [(0, $89d8bb437c2044ff$export$1eb399d8c2d53748)]: {
            enabled: {
                title: (0, $8S0BR.default).boardFlagSuccessTitle,
                actionDescription: (0, $8S0BR.default).boardFeatureSuccessEnableAction
            },
            disabled: {
                title: (0, $8S0BR.default).boardFlagSuccessTitle,
                description: (0, $8S0BR.default).boardDisabledSuccessFlagDescription,
                actionDescription: (0, $8S0BR.default).boardFeatureSuccessDisableDismiss
            }
        }
    };
    return flagMessages[feature][enabled ? 'enabled' : 'disabled'];
};
const $6afbbadf7833ad6c$var$errorFlagMessages = (feature)=>{
    const errorMessages = {
        [(0, $89d8bb437c2044ff$export$abbcecf25bfa1e87)]: {
            errorTitle: (0, $8S0BR.default).enabledErrorTitleForCalendar,
            errorDescription: (0, $8S0BR.default).saveErrorDescription
        },
        [(0, $89d8bb437c2044ff$export$1eb399d8c2d53748)]: {
            errorTitle: (0, $8S0BR.default).enabledErrorTitleForBoard,
            errorDescription: (0, $8S0BR.default).saveErrorDescription
        }
    };
    return errorMessages[feature];
};
const $6afbbadf7833ad6c$var$ViewsFeatures = /*#__PURE__*/ (0, $eUqFw.memo)(()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { data: data, saving: saving, update: update } = (0, $iPgVt.default)();
    const showSaveErrorFlag = (0, $fJdKO.default)();
    const { hasSharedObjectsPermission: hasSharedObjectsPermission } = (0, $4jD3Z.useCreateSharedObjectsPermission)();
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagsService)();
    const { push: push } = (0, $lB25E.useRouterActions)();
    const flagIdRef = (0, $eUqFw.useRef)({});
    const [projectKey = ''] = (0, $lB25E.usePathParam)('projectKey');
    const { data: navData } = (0, $2futN.useJiraServiceManagementProjectNavigation)();
    const onToggleSuccess = (0, $eUqFw.useCallback)((feature, enabled)=>{
        const flagIdKey = `${feature}-service-feature-success`;
        const { current: flagIds } = flagIdRef;
        // toFlagId creates a new string reference. But we want to reuse
        // flag ids so the most relevant flag for a feature is shown
        flagIds[flagIdKey] = flagIds[flagIdKey] || (0, $eo17r.toFlagId)(flagIdKey);
        const id = flagIds[flagIdKey];
        const boardId = navData?.boardInfo.board.id;
        const onDismiss = ()=>{
            dismissFlag(id);
        };
        // Dismiss previous flag with the same id. So user cannot
        // interact with out of update flags
        dismissFlag(id);
        const flagMessages = $6afbbadf7833ad6c$var$successFlagMessages(feature, enabled);
        const launchUrl = $6afbbadf7833ad6c$var$getLaunchUrl(projectKey, boardId, feature);
        showFlag({
            id: id,
            type: 'success',
            title: [
                flagMessages.title,
                {
                    value: enabled
                }
            ],
            description: flagMessages?.description,
            actions: [
                {
                    content: flagMessages.actionDescription,
                    onClick: ()=>{
                        onDismiss();
                        if (enabled) push(launchUrl);
                    }
                }
            ]
        });
    }, [
        dismissFlag,
        navData,
        projectKey,
        push,
        showFlag
    ]);
    const createOnChangeHandler = (0, $eUqFw.useCallback)((featureTitle)=>(feature, enabled, analyticEvent)=>{
            (0, $jMP2a.fireUIAnalytics)(analyticEvent, 'settingsToggle', {
                field: feature
            });
            const errorMessages = $6afbbadf7833ad6c$var$errorFlagMessages(feature);
            update({
                feature: feature,
                enabled: enabled,
                onFail: ()=>{
                    showSaveErrorFlag(featureTitle, enabled, errorMessages);
                },
                onSuccess: ()=>onToggleSuccess(feature, enabled)
            });
        }, [
        update,
        showSaveErrorFlag,
        onToggleSuccess
    ]);
    const createLearnMoreLink = (href, message, articleId, eventName)=>{
        const learnMoreLinkButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ksHP7.ExternalLink), {
            href: href
        }, message);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3QLcd.default), {
            articleId: articleId,
            appearance: "link",
            spacing: "none",
            fallbackComponent: learnMoreLinkButton,
            onClick: ()=>(0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'helpLink clicked', eventName, {
                    articleId: articleId
                })
        }, message);
    };
    const learnMoreAboutBoards = createLearnMoreLink('https://support.atlassian.com/jira-service-management-cloud/docs/manage-your-work-using-a-board/', formatMessage((0, $8S0BR.default).boardLink), '103YhAB4GHpQvY8MAc0Q2r', 'learnMoreAboutJsmBoards');
    const learnMoreAboutCalendar = createLearnMoreLink('https://support.atlassian.com/jira-service-management-cloud/docs/show-issues-in-the-calendar/', formatMessage((0, $8S0BR.default).calendarLink), '64Rt47cO6Aw6VnWaqUkriU', 'learnMoreAboutCalendar');
    const dontHaveSharedObjectsPermission = (0, $1ybV0.ff)('jsm-disable-boards-features-when-no-permission_2vg02') && !hasSharedObjectsPermission;
    const disabledBoardFeatureToggle = (0, $1ybV0.ff)('fix-jsm-board-creation-permission-issue_9bduk') ? !data?.[0, $89d8bb437c2044ff$export$1eb399d8c2d53748]?.editable : dontHaveSharedObjectsPermission;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $co8Ny.FeatureToggleTile), {
        feature: (0, $89d8bb437c2044ff$export$1eb399d8c2d53748),
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b7RZi.default), {
            alt: ""
        }),
        title: formatMessage((0, $8S0BR.default).boardTitle),
        badge: (0, $1ybV0.ff)('jsm-kanban-board-lozenge_31x91') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
            appearance: "new"
        }, formatMessage((0, $8S0BR.default).newLozenge)),
        value: data?.[0, $89d8bb437c2044ff$export$1eb399d8c2d53748]?.status === (0, $89d8bb437c2044ff$export$e927a5d1b72f0b68),
        saving: saving[0, $89d8bb437c2044ff$export$1eb399d8c2d53748],
        disabled: disabledBoardFeatureToggle,
        onChange: createOnChangeHandler(formatMessage((0, $8S0BR.default).boardTitle)),
        tooltip: disabledBoardFeatureToggle && (0, $1ybV0.ff)('fix-jsm-board-creation-permission-issue_9bduk') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...(0, $8S0BR.default).noPermissionTooltipMessage,
            values: {
                strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
                        as: "strong"
                    }, chunks)
            }
        }) : null
    }, formatMessage((0, $8S0BR.default).boardDescription, {
        learnMoreLink: learnMoreAboutBoards
    })), (0, $1ybV0.ff)('jsm-calendar-ga_81o9m') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $co8Ny.FeatureToggleTile), {
        feature: (0, $89d8bb437c2044ff$export$abbcecf25bfa1e87),
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cvLHp.default), {
            alt: ""
        }),
        title: formatMessage((0, $8S0BR.default).calendarTitle),
        badge: (0, $1ybV0.ff)('jsm-calendar-ga-lozenge_d5l0a') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
            appearance: "new"
        }, formatMessage((0, $8S0BR.default).newLozenge)),
        value: data?.[0, $89d8bb437c2044ff$export$abbcecf25bfa1e87]?.status === (0, $89d8bb437c2044ff$export$e927a5d1b72f0b68),
        saving: saving[0, $89d8bb437c2044ff$export$abbcecf25bfa1e87],
        onChange: createOnChangeHandler(formatMessage((0, $8S0BR.default).calendarTitle)),
        tooltip: data?.[0, $89d8bb437c2044ff$export$abbcecf25bfa1e87]?.editable ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...(0, $8S0BR.default).noPermissionTooltipMessage,
            values: {
                strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
                        as: "strong"
                    }, chunks)
            }
        }),
        disabled: !data?.[0, $89d8bb437c2044ff$export$abbcecf25bfa1e87]?.editable
    }, formatMessage((0, $8S0BR.default).calendarDescription, {
        learnMoreLink: learnMoreAboutCalendar
    })));
});
var $6afbbadf7833ad6c$export$2e2bcd8739ae039 = $6afbbadf7833ad6c$var$ViewsFeatures;

});
parcelRegister("cvLHp", function(module, exports) {

$parcel$export(module.exports, "default", () => $9bac55c57754e6f7$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = hmw64wpfb5gbffw5rhb2nfx
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/hmw64wpfb5gbffw5rhb2nfx

var $9TZf5 = parcelRequire("9TZf5");

var $lpyD8 = parcelRequire("lpyD8");
const $9bac55c57754e6f7$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($lpyD8)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($lpyD8))
});
var $9bac55c57754e6f7$export$2e2bcd8739ae039 = $9bac55c57754e6f7$var$Illustration;
// for advanced use only
const $9bac55c57754e6f7$export$a179c88182cb9d56 = [
    0,
    0,
    183,
    197
];

});
parcelRegister("lpyD8", function(module, exports) {
module.exports = new URL("jsm-calendar.205c9141.svg", import.meta.url).toString();

});


parcelRegister("4jD3Z", function(module, exports) {

$parcel$export(module.exports, "useCreateSharedObjectsPermission", () => $17ad9d059fcce7d9$export$1458eb2cfb5f6437);

var $eUqFw = parcelRequire("eUqFw");

var $10Sc8 = parcelRequire("10Sc8");
const $17ad9d059fcce7d9$export$1458eb2cfb5f6437 = ()=>{
    const [hasSharedObjectsPermission, sethasSharedObjectsPermission] = (0, $eUqFw.useState)();
    (0, $eUqFw.useEffect)(()=>{
        (0, $10Sc8.getCreateSharedObjectsPermission)().then((data)=>{
            sethasSharedObjectsPermission(data);
        });
    }, []);
    return {
        hasSharedObjectsPermission: hasSharedObjectsPermission
    };
};

});
parcelRegister("10Sc8", function(module, exports) {

$parcel$export(module.exports, "getCreateSharedObjectsPermission", () => $db5a74fd582124d5$export$c96038ddeaebae69);

var $gUUjF = parcelRequire("gUUjF");

var $lRmyA = parcelRequire("lRmyA");
const $db5a74fd582124d5$var$PERMISSION_BASE_URL = '/rest/api/3/mypermissions';
const $db5a74fd582124d5$var$CREATE_SHARED_OBJECTS_PERMISSION_PARAM = 'permissions=CREATE_SHARED_OBJECTS';
const $db5a74fd582124d5$export$c96038ddeaebae69 = async ()=>{
    try {
        const myPermission = await (0, $lRmyA.performGetRequest)(`${$db5a74fd582124d5$var$PERMISSION_BASE_URL}?${$db5a74fd582124d5$var$CREATE_SHARED_OBJECTS_PERMISSION_PARAM}`);
        return myPermission?.permissions?.CREATE_SHARED_OBJECTS?.havePermission;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('itsm-features.services.common.shared-object-permission.getCreateSharedObjectsPermission', 'Unable to fetch create shared objects permission', error);
        return undefined;
    }
};

});


parcelRegister("8S0BR", function(module, exports) {

$parcel$export(module.exports, "default", () => $edef58312134b4b8$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $edef58312134b4b8$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    boardTitle: {
        "id": "servicedesk-itsm-features.app.sections.labs-section.jsm-board-title",
        "defaultMessage": "Board"
    },
    boardDescription: {
        "id": "servicedesk-itsm-features.app.sections.labs-section.jsm-board-description",
        "defaultMessage": "Visualize your work with a board to track the progress of all issues in your project. Add, rename, or remove columns in your board to match your team's preferred way of working. {learnMoreLink}."
    },
    boardLink: {
        "id": "servicedesk-itsm-features.app.sections.labs-section.jsm-board-link",
        "defaultMessage": "Learn more about setting up a board"
    },
    calendarTitle: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.views-features.calendar-title",
        "defaultMessage": "Calendar"
    },
    calendarDescription: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.views-features.calendar-description",
        "defaultMessage": "Visualize your work with a calendar to track, plan and prioritize your issues. {learnMoreLink}."
    },
    calendarLink: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.views-features.calendar-link",
        "defaultMessage": "Learn more about calendar view"
    },
    viewsTitle: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.views-features.views-title.non-final",
        "defaultMessage": "Views"
    },
    viewsDescription: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.views-features.views-description.non-final",
        "defaultMessage": "Visualize your issues in the way that works best for you. Use the Default view settings to select which views are available to your team, such as <b>board</b> and <b>calendar</b>. <link>Read more about views</link>"
    },
    selectViewsButton: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.views-features.select-views-button.non-final",
        "defaultMessage": "Select views"
    },
    noPermissionTooltipMessage: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.views-features.no-permission-tooltip-message",
        "defaultMessage": "Ask your jira admin for the <strong>Browse projects</strong> permission to enable this feature."
    },
    newLozenge: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.views-features.new-lozenge",
        "defaultMessage": "New"
    },
    // calendar success flag messages
    calendarFlagSuccessTitle: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.views-features.calendar-flag-success-title",
        "defaultMessage": "Calendar {value, select, true {enabled} false {disabled} other {}}"
    },
    calendarEnabledSuccessFlagDescription: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.views-features.calendar-enabled-success-flag-description",
        "defaultMessage": "Start scheduling your work by adding a start date and due date to your issues."
    },
    calendarDisabledSuccessFlagDescription: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.views-features.calendar-disabled-success-flag-description",
        "defaultMessage": "You can enable it again at any time."
    },
    calendarFeatureSuccessEnableAction: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.views-features.calendar-feature-success-enable-action",
        "defaultMessage": "View calendar"
    },
    calendarFeatureSuccessDisableDismiss: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.views-features.calendar-feature-success-disable-dismiss",
        "defaultMessage": "Ok"
    },
    // board success flag messages
    boardFlagSuccessTitle: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.views-features.board-flag-success-title",
        "defaultMessage": "Board {value, select, true {enabled} false {turned off} other {}}"
    },
    boardDisabledSuccessFlagDescription: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.views-features.board-disabled-success-flag-description",
        "defaultMessage": "You can enable your board again at any time."
    },
    boardFeatureSuccessEnableAction: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.views-features.board-feature-success-enable-action",
        "defaultMessage": "Go to board"
    },
    boardFeatureSuccessDisableDismiss: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.views-features.board-feature-success-disable-dismiss",
        "defaultMessage": "Ok"
    },
    // views success flag messages
    viewsFlagSuccessTitle: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.views-features.views-flag-success-title.non-final",
        "defaultMessage": "Views {value, select, true {enabled} false {turned off} other {}}"
    },
    viewsEnabledSuccessFlagDescription: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.views-features.views-enabled-success-flag-description.non-final",
        "defaultMessage": "You can disable views through \"Select views\" button."
    },
    viewsDisabledSuccessFlagDescription: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.views-features.views-disabled-success-flag-description.non-final",
        "defaultMessage": "You can enable views again at any time."
    },
    viewsFeatureSuccessEnableAction: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.views-features.views-feature-success-enable-action",
        "defaultMessage": "Ok"
    },
    viewsFeatureSuccessDisableAction: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.views-features.views-feature-success-disable-action.non-final",
        "defaultMessage": "Ok"
    },
    // Error flag messages
    enabledErrorTitleForCalendar: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.views-features.enabled-error-title-for-calendar",
        "defaultMessage": "We couldn\u2019t {value, select, false {disable} true {enable} other {action}} the calendar"
    },
    enabledErrorTitleForBoard: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.views-features.enabled-error-title-for-board",
        "defaultMessage": "We couldn\u2019t {value, select, false {turn off} true {enable} other {action}} your board"
    },
    enabledErrorTitleForViews: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.views-features.enabled-error-title-for-views.non-final",
        "defaultMessage": "We couldn\u2019t {value, select, false {disable} true {enable} other {action}} the views"
    },
    saveErrorDescription: {
        "id": "servicedesk-itsm-features.app.sections.service-project-section.views-features.save-error-description",
        "defaultMessage": "Refresh the page and try again."
    }
});

});




parcelRegister("qHoPu", function(module, exports) {

$parcel$export(module.exports, "CmdbUpsellWrapper", () => $10478b261edc36ec$export$13b196f18b5f813);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $10478b261edc36ec$export$13b196f18b5f813 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pk1ejb",
            __cmplp.className
        ])
    });
});

});



parcelRegister("kCywN", function(module, exports) {

$parcel$export(module.exports, "ProjectSettingsController", () => $d103d2cdc5840880$export$9e38610dc1164d7d);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $bAQOb = parcelRequire("bAQOb");

var $dnJL9 = parcelRequire("dnJL9");

var $eI64M = parcelRequire("eI64M");

var $bhwgQ = parcelRequire("bhwgQ");

var $gd0Sp = parcelRequire("gd0Sp");

var $lB25E = parcelRequire("lB25E");

var $3hSJ4 = parcelRequire("3hSJ4");
const $d103d2cdc5840880$var$ERROR_REPORTING_PACKAGE_ID = 'projectSettingsController';
const $d103d2cdc5840880$var$ERROR_REPORTING_PACKAGE_NAME = 'jiraSpaAppsSoftwareProjectSettingsController';
const $d103d2cdc5840880$export$2164d5fb3f070c32 = ({ projectKey: projectKey, isRouteAllowedForNonAdmins: isRouteAllowedForNonAdmins, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: $d103d2cdc5840880$var$ERROR_REPORTING_PACKAGE_ID,
        teamName: "morphinecake",
        packageName: $d103d2cdc5840880$var$ERROR_REPORTING_PACKAGE_NAME,
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bhwgQ.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d103d2cdc5840880$var$RedirectNonAdminsAndArchivedProjects, {
        projectKey: projectKey,
        isRouteAllowedForNonAdmins: isRouteAllowedForNonAdmins
    }, children)));
const $d103d2cdc5840880$export$6d6f90026f9508a7 = ({ projectKey: projectKey, isRouteAllowedForNonAdmins: isRouteAllowedForNonAdmins, children: children, packageId: packageId = $d103d2cdc5840880$var$ERROR_REPORTING_PACKAGE_ID, packageName: packageName = $d103d2cdc5840880$var$ERROR_REPORTING_PACKAGE_NAME, teamName: teamName = 'morphinecake' })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: $d103d2cdc5840880$var$ERROR_REPORTING_PACKAGE_ID,
        teamName: "morphinecake",
        packageName: $d103d2cdc5840880$var$ERROR_REPORTING_PACKAGE_NAME,
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bhwgQ.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d103d2cdc5840880$var$RedirectNonAdminsAndArchivedProjects, {
        projectKey: projectKey,
        isRouteAllowedForNonAdmins: isRouteAllowedForNonAdmins
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: packageId,
        teamName: teamName,
        packageName: packageName,
        sendToPrivacyUnsafeSplunk: true
    }, children))));
const $d103d2cdc5840880$export$9e38610dc1164d7d = (0, $dnJL9.componentWithFG)('projectsettingscontroller_error_boundary', $d103d2cdc5840880$export$6d6f90026f9508a7, $d103d2cdc5840880$export$2164d5fb3f070c32);
const $d103d2cdc5840880$var$RedirectNonAdminsAndArchivedProjectsNew = ({ projectKey: projectKey, isRouteAllowedForNonAdmins: isRouteAllowedForNonAdmins, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gd0Sp.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
        if (!projectKey) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
            to: "/jira/projects"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3hSJ4.ProjectContextSubscriber), null, (projectContext)=>{
            if (projectContext.isProjectArchived) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eI64M.RedirectToArchivedPage), null);
            if (tenantContext.isAdmin || projectContext.isProjectAdmin || isRouteAllowedForNonAdmins && isRouteAllowedForNonAdmins()) return children;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
                to: `/projects/${projectContext.projectKey}`
            });
        });
    });
const $d103d2cdc5840880$var$RedirectNonAdminsAndArchivedProjectsOld = ({ projectKey: projectKey, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gd0Sp.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
        if (!projectKey) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
            to: "/jira/projects"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3hSJ4.ProjectContextSubscriber), null, (projectContext)=>{
            if (projectContext.isProjectArchived) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eI64M.RedirectToArchivedPage), null);
            if (tenantContext.isAdmin || projectContext.isProjectAdmin) return children;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
                to: `/projects/${projectContext.projectKey}`
            });
        });
    });
const $d103d2cdc5840880$var$RedirectNonAdminsAndArchivedProjects = (0, $bAQOb.componentWithFF)('olympus-da-157-enable-project-settings-navigation_zxaq5', $d103d2cdc5840880$var$RedirectNonAdminsAndArchivedProjectsNew, $d103d2cdc5840880$var$RedirectNonAdminsAndArchivedProjectsOld);

});
parcelRegister("eI64M", function(module, exports) {

$parcel$export(module.exports, "isProjectArchivedCondition", () => $949f89d276fadb14$export$34040938aec58f90);
$parcel$export(module.exports, "RedirectToArchivedPage", () => $949f89d276fadb14$export$36db2ddf32573bd8);
$parcel$export(module.exports, "default", () => $949f89d276fadb14$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bNe1g = parcelRequire("bNe1g");

var $lB25E = parcelRequire("lB25E");

const $949f89d276fadb14$export$34040938aec58f90 = (projectContextData)=>projectContextData && projectContextData.isProjectArchived || false;
const $949f89d276fadb14$var$RedirectIfProjectArchived = ({ projectKey: projectKey })=>{
    if (projectKey === null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bNe1g.ProjectContextProvider), null, (projectContext)=>$949f89d276fadb14$export$34040938aec58f90(projectContext.data) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
            to: (0, $8b47e2956ab1dffe$export$9a6ccb84170b615b)
        }) : null);
};
const $949f89d276fadb14$export$36db2ddf32573bd8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
        to: (0, $8b47e2956ab1dffe$export$9a6ccb84170b615b)
    });
var $949f89d276fadb14$export$2e2bcd8739ae039 = $949f89d276fadb14$var$RedirectIfProjectArchived;

});
const $8b47e2956ab1dffe$export$9a6ccb84170b615b = '/jira/errors/project-archived';


parcelRegister("3hSJ4", function(module, exports) {

$parcel$export(module.exports, "ProjectContextSubscriber", () => $21ed2776f26316f6$export$b6f3f3997ca8a783);

var $ixwgj = parcelRequire("ixwgj");

var $lB25E = parcelRequire("lB25E");
const $21ed2776f26316f6$export$b6f3f3997ca8a783 = ({ children: children })=>{
    const { data: data } = (0, $lB25E.useResource)((0, $ixwgj.projectContextResourceWithCache));
    if (!data) return null;
    return children(data);
};

});





//# sourceMappingURL=async-project-settings-service-desk-itsm-features.cd5ca158.js.map
